var canvas;
let canvases = {};

document.addEventListener("DOMContentLoaded", function() {
  const buttonExists = document.querySelector('.top-header-cart-icon');
  const cartElement = document.querySelector('.header_cart');

  if (buttonExists && cartElement) {
    cartElement.remove();
  }
});
// if($('.template-product .selector-wrapper--color .radio__inputs--swatch .swatch__button_variant_options_main').length > 5){
//   $('.selector-wrapper--color .radio__inputs--swatch').slick({
//       slidesToShow: 5,
//       infinite:true,
//       dots: false,
//       centerMode: true,
//       centerPadding: '40px',
//       focusOnSelect: true,
//       responsive: [{
//         breakpoint: 1024,
//         settings: {
//             slidesToShow: 3
//         }
//       }, {
//         breakpoint: 640,
//         settings: {
//             slidesToShow: 3
//         }
//       }, {
//           breakpoint: 589,
//           settings: {
//               slidesToShow: 3
//       }
//       }]
//     });
// }

function updateAttributesMain(dataParams, data_object_url=""){
  $.ajax({
    url: `${window.Shopify?.routes?.root??"/"}cart/update.js`,
    type: 'POST',
    dataType: 'json',
    data: dataParams,
    success: function(cart) {
      //window.location.reload();
      console.log(window.location.hostname);
      window.location.href = data_object_url;
    },
    error: function(err) {
      console.error('Error adding products to cart:', err);
    }
  });
}

if($('.top-header-inner').length == 0 && (active_course_tmp!=domain_handle_tmp)){
  const dataParams = {
    "attributes[active_course]": domain_handle_tmp
  }; 
  updateAttributesMain(dataParams);
}

$(document).ready(function () {
  
  $("a").each(function(index){
    var this_href = $(this).attr("href"); 
    if(typeof this_href !== 'undefined' 
      && this_href.includes("/collections/") 
      && !this_href.includes("/products/") 
      && !this_href.includes("page") 
      && !this_href.includes("/vendors")
      && !this_href.includes(js_product_primary_tag)
      && !this_href.includes(js_product_primary_tag+"+"+js_course_code)
      ){
      $(this).attr("href",this_href+"/"+js_product_primary_tag+"+"+js_course_code);
    }
  });

  productSlickSlideshow();
});
let isSwatchClickProcessing = false;

$(document).off("click", ".swatch__button--square_color");
$(document).on("click", ".swatch__button--square_color", function(e) { 
// $(document).off("click", ".swatch__button_variant_options_main");
// $(document).on("click", ".swatch__button_variant_options_main", function(e) {
   e.preventDefault();
  if (isSwatchClickProcessing) return;
  isSwatchClickProcessing = true;
  
  var this_product_url = $(this).attr("data-product-url");
  var page_type = $(this).attr("page_type");
  
  if(page_type == "collections"){
    var productIndex = $(this).attr("productIndex");
    var product__image = $(this).find("label").find('image-element').html(); 
    $(".product-grid-img-"+productIndex).find("product-grid-item-image").find(".inner_thumb").html(product__image);
    // var productContainer = $(this).closest('[data-product-id]');
    // productContainer.find(".product-grid-img-"+productIndex).find("product-grid-item-image").find(".inner_thumb").html(product__image);
    isSwatchClickProcessing = false;
  }else if(this_product_url!=''){ 
    window.history.pushState({ path: this_product_url }, '', this_product_url);
    productDataLoad(this_product_url)
  }else {
    isSwatchClickProcessing = false;
  }
});

$(document).on("mouseenter", ".swatch__button--square_color", function(e) {  
// $(document).on("mouseenter", ".swatch__button_variant_options_main", function(e) {
  var hover_title = $(this).find("label").attr("data-swapper-hover"); 
  $(this).closest(".custom-selector-wrapper--color").find("[data-swapper-target]").html(hover_title);
});

$(document).on("mouseleave", ".swatch__button--square_color", function(e) { 
// $(document).on("mouseleave", ".swatch__button_variant_options_main", function(e) {
  var checked_title = $(this).closest(".custom-selector-wrapper--color").find("input:checked").val();
  $(this).closest(".custom-selector-wrapper--color").find("[data-swapper-target]").html(checked_title); 
});
  
function productDataLoad(this_product_url) {
  var current_variant_id = $("#current_variant_id").val();
  var product_main_logo_viewing = $("#product_main_logo_viewing").val();
  var checkboxLogo = $('input[name="properties[Logo]"]:checked').val();
  var product_section_id = $(".product-section").attr("data-section-id");
  var logo_personalized_section_id = $(".section_custom_meta_logo_personalized").attr("data-section-id");
  var input_personalize_text =  $(".input-personalize-text").val();
  $("#ajax_loader").show();
  $.ajax({
    url: `${this_product_url}/?sections=${product_section_id},${logo_personalized_section_id}&variant=${current_variant_id}`,
    type: 'GET',
    dataType: 'html',
    success: function(data) { 
      let jsonData =  JSON.parse(data); 
      var product_section = $(jsonData[product_section_id]).html(); 
      $("#shopify-section-"+product_section_id).html(product_section); 
      productSlickSlideshow("product__media__wrapper");
      setTimeout(function() {
        var checked_title = $(".custom-selector-wrapper--color").find("input:checked").val();
        $(".custom-selector-wrapper--color").find("[data-swapper-target]").html(checked_title); 
        
        var meta_logo_personalized_section = $(jsonData[logo_personalized_section_id]).html(); 
        $("#shopify-section-"+logo_personalized_section_id).html(meta_logo_personalized_section);
        logoInputSvgLoad();
        logoImageSvgLoad();  
        checkboxDropdownUpdate();
        pageOnLoadEvents(); 
        if(input_personalize_text!=''){
            $(".input-personalize-text").val(input_personalize_text); 
        } 
        var variant_wrapper_custom_div = $("#variant_wrapper_custom_div").html();
        if(variant_wrapper_custom_div!=''){
          $(".product__main__content").find(".variant-wrapper-custom").remove();
          $("#variant_wrapper_custom_div").html("");
           $(".product__main__content").find('.product__block__variants').last().after(variant_wrapper_custom_div);
          if(product_main_logo_viewing == "Logo Mockup"){ 
            $(".product__main__content").find(".variant-wrapper-custom").hide();
          } 
        }
        
        $("#ajax_loader").hide();
      }, 500); 
      isSwatchClickProcessing = false;
      
      var variantId = parseInt($("#current_variant_id").val());
      setTimeout(function() {
        let logoSelector = ".LogoSelect-" + variantId + "-logo-" + checkboxLogo;
        let target = $(logoSelector).parent(".logo_product-form__swatch__item");
        if (target.length) { 
          target.trigger('click');
          $(logoSelector).trigger('click');
        } else {
          console.warn("Logo element not found:", logoSelector);
        }
      }, 1500);
    },
    error: function(jqXHR, textStatus, errorThrown) {
      console.error("Error fetching meta-logo-personalized content:", errorThrown);
      $("#ajax_loader").hide(); 
      isSwatchClickProcessing = false;
    }
  });
}

$(document).on("click", ".add-to-cart-sub-btn", function (e) {
  e.preventdefault;
  var isStatus = false;
  var count = 1;
  $(this).find("[data-add-to-cart-text]").html("Customizing Product...");
  if ($(".checkbox-dropdown .checkbox:checked").length > 0) {
    svgToPngBase64($(".checkbox-dropdown .checkbox:checked").eq(0), count);
  } else {
    update_cart_item(); 
  }
});

// $(document).on("click", ".product-card__swatch__item", function(e) {
//   var product_id = $(this).attr("product-id");
//   var variant_id = $(this).attr("variant-id"); 
//   $(".collections_media_product_"+product_id).hide();
//   $(".collections_media_variant_"+variant_id).show();
// });

$(window).on("load", function() {
  logoInputSvgLoadCustom();
  logoInputSvgLoad();
  logoImageSvgLoad(); 
});

window.logoInputSvgLoadCustom =  function() {
  var logo_input_svg_load = $(".logo-input-svg-custom"); 
  logo_input_svg_load.each(function(index){
    var image_layer =false;
    var logoThisObj = $(this);
    var data_variant_logo = $(this).attr("data-variant-logo");
    var data_variant_logo_src = $(this).attr("data-logo-image-template");  
    variantLogoLayerRenderCustom(data_variant_logo_src,$(this),image_layer,"bgpickers");   
  });
}
 
window.variantLogoLayerRenderCustom = function(logoUrl,loadHtml,image_layer= false,layer_class) {
  if(typeof logoUrl !== 'undefined'){
    var input_log_customization_type = $("#input_log_customization_type").val();
    if (logoUrl.indexOf("?") > 0) {
      logoUrl = logoUrl.substring(0, logoUrl.indexOf("?")); 
    }
    let extension = logoUrl.substring(logoUrl.lastIndexOf('.') + 1); 
    if(extension == "svg"){
      var xhr = new XMLHttpRequest(); 
      xhr.open("GET", logoUrl);
      xhr.onreadystatechange = function () {                 
        if (xhr.readyState === 4) { 
          var response = xhr.response;
          var success =  $($.parseHTML(response)).filter("svg");  
          let svgHtml = success[0];
          if(success.length == 1){     
              loadHtml.html(response);
              loadHtml.find("svg").attr({
                // "viewBox":"0 0 2048 2048",
                "width":100,
                "height":100,
              });
              loadHtml.find("svg").removeAttr("preserveAspectRatio");
              loadHtml.find("image").attr("style", "mix-blend-mode: multiply;"); 
             
            logoLayerData(loadHtml,layer_class);
          }
        }
      } 
      xhr.send(); 
     }
  }
}

function logoLayerData(thisObj,layer_class) {
   $("."+layer_class+"-"+thisObj.attr("data-variant-logo")).each(function(index){
    var subThisObj = $(this);
    var default_svg_colors = $(this).attr("default-svg-colors"); 
    thisObj.find("[fill='" + default_svg_colors + "']").each(function(){ 
      $(this).css("fill", subThisObj.val());
      $(this).attr("fill", subThisObj.val());
      $(this).attr("default-svg-colors", default_svg_colors);
    });
  });
}

function productSlickSlideshow(parentCheck = "") {
  setTimeout(() => {
    if(parentCheck!=""){
      var sliderData = $("."+parentCheck).find('.custom-product-slideshow');
    }else{
      var sliderData = $('.custom-product-slideshow');  
    }
    
    if (sliderData.hasClass('slick-initialized')) {
      sliderData.slick('unslick');
    }
    
    sliderData.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      useTransform: true,
      asNavFor: ".product_custom_thumbs_scroller"
    });

    if(parentCheck!=""){
      var thumbsData = $("."+parentCheck).find('.product_custom_thumbs_scroller');
    }else{
      var thumbsData = $('.product_custom_thumbs_scroller');  
    }
    
    if (thumbsData.hasClass('slick-initialized')) {
      thumbsData.slick('unslick');
    }
  
    thumbsData.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite:true,
      asNavFor: ".custom-product-slideshow",
      dots: false,
      focusOnSelect: true,
      responsive: [{
        breakpoint: 1024,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
        }
      }, {
        breakpoint: 640,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
        }
      }, {
          breakpoint: 589,
          settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
      }
      }]
    });
  }, 1000); 
}

$(document).on("click", "#clear-cart-button", function(e) {
  fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(response => {
    if (response.ok) { 
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          document.dispatchEvent(new Event('theme:cart:reload'));
          // document.dispatchEvent(new CustomEvent('cart:build'));
        });
    } else {
      console.error('Failed to clear cart.');
    }
  }).catch(error => console.error('Error:', error));
});

function svgToPngBase64(thisObj, count) {
  var is_checked = thisObj.prop("checked");
  var loValue = thisObj.attr("data-location");

  if (is_checked == true) {
    var product_main_logo_viewing = $("#product_main_logo_viewing").val();
    if(product_main_logo_viewing == "Logo Mockup"){
      var SvgImageEle = $(".product__media__wrapper").find(".custom-product-slideshow").find(".slick-active").find("image-element");
    }else{
      var SvgImageEle = $(".full_image_" + loValue);
    }
    var fullSvgImage = SvgImageEle.html();
    var logoSvgImage = SvgImageEle
      .find(".logo-image-svg")
      .html();
    var tamlength = $(".checkbox-dropdown .checkbox:checked").length;
    if(product_main_logo_viewing == "Logo Mockup"){
      var checkedValue = $('input[name="properties[Logo]"]:checked').val(); 
      var courseLogo = js_course_code+"."+checkedValue;
    }else{
      var courseLogo = $(".data_logo_input_" + loValue + ":checked").val();
    }

    if (fullSvgImage != "" || logoSvgImage != "") {
      if(product_main_logo_viewing == "Logo Mockup"){
        var svgContent = ".slick-active";
      }else{
        var svgContent = ".full_image_" + loValue;
      }
      const svg = document.querySelector(svgContent);
      const firstImage = svg.querySelector("image");
      const firstLogo = svg.querySelector("g.logo-image-svg");
      const svgText = svg.querySelector("g.logo-image-svg-text");

      var imageSource = "";
      if (firstImage) {
        var imageSource =
          firstImage.getAttribute("href") ||
          firstImage.getAttribute("xlink:href");
      } else {
        console.log("No image found in the SVG.");
      }

      // Base image URL
      const baseImageUrl = imageSource.trim();

      // Create a canvas and context
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");

      const canvas_logo = document.createElement("canvas");
      const context_logo = canvas_logo.getContext("2d");

      const canvas_text = document.createElement("canvas");
      const context_text = canvas_text.getContext("2d");

      // Load the base image
      const baseImage = new Image();
      baseImage.crossOrigin = "anonymous";
      baseImage.onload = function () {
        // Set canvas dimensions to match the base image
        canvas.width = baseImage.width;
        canvas.height = baseImage.height;

        // Draw the base image onto the canvas
        context.drawImage(baseImage, 0, 0);

        

        if ($(firstLogo).text().trim() == "Personalize") {
          if ($(svgText).text().trim() != "") {
            var svgTextElement = svgText.querySelector("text"); //$(svgText).find("text");
            // Add custom text
            const textX = $(svgTextElement).attr("x"); // X position of the text
            const textY = $(svgTextElement).attr("y"); // Y position of the text
            const textWidth = $(svgTextElement).attr("width"); // width of the text
            const textHeight = $(svgTextElement).attr("height"); // height of the text
            const fontSize = $(svgTextElement).attr("font-size"); // Font size of the text
            const fontFamily = $(svgTextElement).attr("font-family"); // font family of the text
            const fontColor = $(svgTextElement).attr("fill"); // color of the text
            // const svgTextData = $(svgText).text().trim(); // text of svg

            canvas_text.width = parseInt(textWidth) + 200;
            canvas_text.height = 200 + parseInt(textHeight) / 2;

            // $(svgText)
            //   .find("tspan")
            //   .each(function () {
            //     var svgTextData = $(this).text().trim();

            //     if ($(svgText).find("tspan").length > 1) {
            //       var ttextX = $(this).attr("x"); // X position of the text
            //       var ttextY = $(this).attr("y"); // Y position of the text  
            //       if ($(this).index() == 0) {
            //         // var textYS = parseInt(textY) - parseInt(textHeight) / 2;
            //         var textYS1 = 100;
            //       } else {
            //         // var textYS = textY;
            //         var textYS1 = 100 + parseInt(textHeight) / 2;
            //       }
            //       context.font = `${fontSize} ${fontFamily}`;
            //       context.fillStyle = fontColor; // Text color
            //       context.fillText(svgTextData, ttextX, ttextY);

            //       context_text.font = `${fontSize} ${fontFamily}`;
            //       context_text.fillStyle = fontColor; // Text color
            //       context_text.fillText(
            //         svgTextData,
            //         canvas_text.width / 2 - parseInt(textWidth) / 2,
            //         textYS1
            //       );
            //     } else {
            //       context.font = `${fontSize} ${fontFamily}`;
            //       context.fillStyle = fontColor; // Text color
            //       context.fillText(svgTextData, textX, textY);

            //       context_text.font = `${fontSize} ${fontFamily}`;
            //       context_text.fillStyle = fontColor; // Text color
            //       context_text.fillText(
            //         svgTextData,
            //         canvas_text.width / 2 - parseInt(textWidth) / 2,
            //         100
            //       );
            //     }
            //   });

            $(svgText)
            .find("tspan")
            .each(function () {
              var ttextX = $(this).attr("x"); // X position of the text
              var ttextY = $(this).attr("y"); // Y position of the text  
              if ($(this).index() == 0) {
                // var textYS = parseInt(textY) - parseInt(textHeight) / 2;
                var textYS1 = 100;
              } else {
                // var textYS = textY;
                var textYS1 = 100 + parseInt(textHeight) / 2;
              }

              const svgTextData = $(this).text().trim();
              const fontSize = parseFloat($(this).attr("font-size") || $(svgTextElement).attr("font-size") || "30") + "px";
              const fontFamily = $(this).attr("font-family") || $(svgTextElement).attr("font-family") || "Arial";
              const fontColor = $(this).attr("fill") || $(svgTextElement).attr("fill") || "#000";
              
              let x = parseFloat($(this).attr("x")) || parseFloat($(svgTextElement).attr("x")) || 0;
              let y = parseFloat($(this).attr("y")) || parseFloat($(svgTextElement).attr("y")) || 0;
          
              // Check for transform at this tspan level (more precise)
              let transformAttr = $(this).attr("transform") || $(svgTextElement).attr("transform") || "";
              let rotate = 0, rotateX = x, rotateY = y;
          
              const rotateMatch = transformAttr.match(/rotate\(\s*(-?\d+\.?\d*)\s*,?\s*(-?\d+\.?\d*)?\s*,?\s*(-?\d+\.?\d*)?\s*\)/);
              if (rotateMatch) {
                rotate = parseFloat(rotateMatch[1]);
                if (rotateMatch[2]) rotateX = parseFloat(rotateMatch[2]);
                if (rotateMatch[3]) rotateY = parseFloat(rotateMatch[3]);
              }
          
              // Draw on base canvas
              context.save();
              context.font = `${fontSize} ${fontFamily}`;
              context.fillStyle = fontColor;
              context.textBaseline = "middle";
          
              // Support SVG text-anchor for alignment
              const anchor = $(svgTextElement).attr("text-anchor") || "start";
              if (anchor === "middle") context.textAlign = "center";
              else if (anchor === "end") context.textAlign = "right";
              else context.textAlign = "left";
          
              context.translate(rotateX, rotateY);
              context.rotate((rotate * Math.PI) / 180);
              context.fillText(svgTextData, x - rotateX, y - rotateY);
              context.restore();
          
              // Optional canvas_text (no rotation, centered)
              // context_text.save();
              // context_text.font = `${fontSize} ${fontFamily}`;
              // context_text.fillStyle = fontColor;
              // context_text.textAlign = "center";
              // context_text.textBaseline = "middle";
              // context_text.fillText(svgTextData, canvas_text.width / 2, canvas_text.height / 2);
              // context_text.restore();
              context_text.font = `${fontSize} ${fontFamily}`;
              context_text.fillStyle = fontColor; // Text color
              context_text.fillText(
                svgTextData,
                canvas_text.width / 2 - parseInt(textWidth) / 2,
                textYS1
              );
            });
            
          }
            
          // Convert the canvas to a Base64-encoded PNG image
          const finalImage = canvas.toDataURL("image/png");
          var finalImage_text = "";
          var finalImage_logo = "";
          if ($(svgText).text().trim() != "") {
            finalImage_text = canvas_text.toDataURL("image/png");
          }

          $.ajax({
            type: "POST",
            // url: "https://qetail.com/apps/convert_base64_image/convert_image_v2.php",
            url: "https://qetail.com/apps/ecom_apps_uploadfile/convertImageUniversal.php",
            data: {
              subHostName: window.location.host,
              courseLogo: courseLogo,
              fullSvgImage: fullSvgImage,
              logoSvgImage: logoSvgImage,
              fullPngImage: finalImage,
              logoPngImage: finalImage_logo,
              textPngImage: finalImage_text,
              hostname: js_permanent_domain,
            },
            dataType: "json",
            success: function (response) {
              if (response.success) {
                $("#full_url_" + loValue).val(response.fullPngImage);
                if (response.logoPngImage != "") {
                  $("#logo_url_" + loValue).val(response.logoPngImage);
                } else {
                  $("#logo_url_" + loValue).val("");
                }
                if (response.textPngImage != "") {
                  $("#_personalization_" + loValue + "_text_image_url").val(
                    response.textPngImage
                  );
                }

                if (count == tamlength) {
                  update_cart_item();
                  return;
                }

                count = parseInt(count) + 1;
                svgToPngBase64(
                  $(".checkbox-dropdown .checkbox:checked").eq(
                    parseInt(count) - 1
                  ),
                  count
                );
              }
            },
            error: function () {
              alert("There was an error adding the item to the cart");
            },
          });
        
        } else {
          const firstLogoSvg = firstLogo.querySelector("svg");
          const svgData = $(firstLogo).html();

          // Create a Blob URL for the SVG
          const svgBlob = new Blob([svgData], {
            type: "image/svg+xml;charset=utf-8",
          });
          const svgUrl = URL.createObjectURL(svgBlob);

          // Load the SVG as a PNG
          const svgImage = new Image();
          svgImage.onload = function () {
            // Define position and size for the SVG overlay
            const x = parseInt($(firstLogoSvg).attr("x")); //913; // X position
            const y = parseInt($(firstLogoSvg).attr("y")); // Y position
            const width = parseInt($(firstLogoSvg).attr("width")); // Width of the overlay
            const height = parseInt($(firstLogoSvg).attr("height")); // Height of the overlay
            const rotate_angle = parseFloat($(firstLogoSvg).attr("rotate_angle")); // Height of the overlay
            const logo_width = 1024;
            const logo_height = 1024;

            canvas_logo.width = logo_width;
            canvas_logo.height = logo_height;

            if(rotate_angle!="" && rotate_angle>0){
              const angleInRadians = rotate_angle * Math.PI / 180;
              context.save();
              context.translate(x, y); 
              context.rotate(angleInRadians); 
              context.drawImage(svgImage, 0, 0, width, height); 
              context.restore();
            }else{
              context.drawImage(svgImage, x, y, width, height);
            }
            context_logo.drawImage(svgImage, 0, 0, logo_width, logo_height);

            if ($(svgText).text().trim() != "") {
              var svgTextElement = svgText.querySelector("text"); //$(svgText).find("text");
              // Add custom text
              const textX = $(svgTextElement).attr("x"); // X position of the text
              const textY = $(svgTextElement).attr("y"); // Y position of the text
              const textWidth = $(svgTextElement).attr("width"); // width of the text
              const textHeight = $(svgTextElement).attr("height"); // height of the text
              const fontSize = $(svgTextElement).attr("font-size"); // Font size of the text
              const fontFamily = $(svgTextElement).attr("font-family"); // font family of the text
              const fontColor = $(svgTextElement).attr("fill"); // color of the text
              // const svgTextData = $(svgText).text().trim(); // text of svg
  
              canvas_text.width = parseInt(textWidth) + 200;
              canvas_text.height = 200 + parseInt(textHeight) / 2;
  
              // $(svgText)
              //   .find("tspan")
              //   .each(function () {
              //     var svgTextData = $(this).text().trim();
  
              //     if ($(svgText).find("tspan").length > 1) {
              //       var ttextX = $(this).attr("x"); // X position of the text
              //       var ttextY = $(this).attr("y"); // Y position of the text  
              //       if ($(this).index() == 0) {
              //         // var textYS = parseInt(textY) - parseInt(textHeight) / 2;
              //         var textYS1 = 100;
              //       } else {
              //         // var textYS = textY;
              //         var textYS1 = 100 + parseInt(textHeight) / 2;
              //       }
              //       context.font = `${fontSize} ${fontFamily}`;
              //       context.fillStyle = fontColor; // Text color
              //       context.fillText(svgTextData, ttextX, ttextY);
  
              //       context_text.font = `${fontSize} ${fontFamily}`;
              //       context_text.fillStyle = fontColor; // Text color
              //       context_text.fillText(
              //         svgTextData,
              //         canvas_text.width / 2 - parseInt(textWidth) / 2,
              //         textYS1
              //       );
              //     } else {
              //       context.font = `${fontSize} ${fontFamily}`;
              //       context.fillStyle = fontColor; // Text color
              //       context.fillText(svgTextData, textX, textY);
  
              //       context_text.font = `${fontSize} ${fontFamily}`;
              //       context_text.fillStyle = fontColor; // Text color
              //       context_text.fillText(
              //         svgTextData,
              //         canvas_text.width / 2 - parseInt(textWidth) / 2,
              //         100
              //       );
              //     }
              //   });

              $(svgText)
              .find("tspan")
              .each(function () {
                var ttextX = $(this).attr("x"); // X position of the text
                var ttextY = $(this).attr("y"); // Y position of the text  
                if ($(this).index() == 0) {
                  // var textYS = parseInt(textY) - parseInt(textHeight) / 2;
                  var textYS1 = 100;
                } else {
                  // var textYS = textY;
                  var textYS1 = 100 + parseInt(textHeight) / 2;
                }
                const svgTextData = $(this).text().trim();
                const fontSize = parseFloat($(this).attr("font-size") || $(svgTextElement).attr("font-size") || "30") + "px";
                const fontFamily = $(this).attr("font-family") || $(svgTextElement).attr("font-family") || "Arial";
                const fontColor = $(this).attr("fill") || $(svgTextElement).attr("fill") || "#000";
                
                let x = parseFloat($(this).attr("x")) || parseFloat($(svgTextElement).attr("x")) || 0;
                let y = parseFloat($(this).attr("y")) || parseFloat($(svgTextElement).attr("y")) || 0;
            
                // Check for transform at this tspan level (more precise)
                let transformAttr = $(this).attr("transform") || $(svgTextElement).attr("transform") || "";
                let rotate = 0, rotateX = x, rotateY = y;
            
                const rotateMatch = transformAttr.match(/rotate\(\s*(-?\d+\.?\d*)\s*,?\s*(-?\d+\.?\d*)?\s*,?\s*(-?\d+\.?\d*)?\s*\)/);
                if (rotateMatch) {
                  rotate = parseFloat(rotateMatch[1]);
                  if (rotateMatch[2]) rotateX = parseFloat(rotateMatch[2]);
                  if (rotateMatch[3]) rotateY = parseFloat(rotateMatch[3]);
                }
            
                // Draw on base canvas
                context.save();
                context.font = `${fontSize} ${fontFamily}`;
                context.fillStyle = fontColor;
                context.textBaseline = "middle";
            
                // Support SVG text-anchor for alignment
                const anchor = $(svgTextElement).attr("text-anchor") || "start";
                if (anchor === "middle") context.textAlign = "center";
                else if (anchor === "end") context.textAlign = "right";
                else context.textAlign = "left";
            
                context.translate(rotateX, rotateY);
                context.rotate((rotate * Math.PI) / 180);
                context.fillText(svgTextData, x - rotateX, y - rotateY);
                context.restore();
            
                // Optional canvas_text (no rotation, centered)
                // context_text.save();
                // context_text.font = `${fontSize} ${fontFamily}`;
                // context_text.fillStyle = fontColor;
                // context_text.textAlign = "center";
                // context_text.textBaseline = "middle";
                // context_text.fillText(svgTextData, canvas_text.width / 2, canvas_text.height / 2);
                // context_text.restore();
                 context_text.font = `${fontSize} ${fontFamily}`;
                context_text.fillStyle = fontColor; // Text color
                context_text.fillText(
                  svgTextData,
                  canvas_text.width / 2 - parseInt(textWidth) / 2,
                  textYS1
                );
              });
            
            }
              
            // Revoke the Blob URL to free memory
            URL.revokeObjectURL(svgUrl);

            // Convert the canvas to a Base64-encoded PNG image
            const finalImage = canvas.toDataURL("image/png");
            const finalImage_logo = canvas_logo.toDataURL("image/png");
            var finalImage_text = "";
            if ($(svgText).text().trim() != "") {
              finalImage_text = canvas_text.toDataURL("image/png");
            }
            
            $.ajax({
              type: "POST",
              // url: "https://qetail.com/apps/convert_base64_image/convert_image_v2.php",
              url: "https://qetail.com/apps/ecom_apps_uploadfile/convertImageUniversal.php",
              data: {
                subHostName: window.location.host,
                courseLogo: courseLogo,
                fullSvgImage: fullSvgImage,
                logoSvgImage: logoSvgImage,
                fullPngImage: finalImage,
                logoPngImage: finalImage_logo,
                textPngImage: finalImage_text,
                hostname: js_permanent_domain,
              },
              dataType: "json",
              success: function (response) {
                if (response.success) {
                  $("#full_url_" + loValue).val(response.fullPngImage);
                  if (response.logoPngImage != "") {
                    $("#logo_url_" + loValue).val(response.logoPngImage);
                  }
                  if (response.textPngImage != "") {
                    $("#_personalization_" + loValue + "_text_image_url").val(
                      response.textPngImage
                    );
                  }

                  if (count == tamlength) {
                    // $(".btn--add-to-cart").trigger("click");
                    update_cart_item();
                    return;
                  }

                  count = parseInt(count) + 1;
                  svgToPngBase64(
                    $(".checkbox-dropdown .checkbox:checked").eq(
                      parseInt(count) - 1
                    ),
                    count
                  );
                }
              },
              error: function () {
                alert("There was an error adding the item to the cart");
              },
            });
            
          };
          svgImage.src = svgUrl;
        }
      };
      baseImage.src = baseImageUrl;
    }
  }
}

$(document).on("click", ".meta_logo_logos_list", function(e) { 
  $('.collection-logo-list').show();
});

$(document).on("click", ".collection_logo_list_close_icon", function(e) { 
  $(".main_variant_logos_wrapper").removeClass("sticky-active");
  $('.collection-logo-list').hide();
  $('.collection_logo_list_close_icon').hide();
});

$(document).ready(function() {
  var main_variant_logos_wrapper = document.querySelector(".main_variant_logos_wrapper");
  if (main_variant_logos_wrapper) { 
    var debounceTimeout;
    $(window).scroll(function() {
      clearTimeout(debounceTimeout);
      debounceTimeout = setTimeout(function() { 
        $('.collection-title').each(function() {
            var elementTop = $(this).offset().top;
            var elementBottom = elementTop + $(this).outerHeight();
            var viewportTop = $(window).scrollTop();
            var viewportBottom = viewportTop + $(window).height();
            if (elementBottom > viewportTop && elementTop < viewportBottom) {
              $('.collection_logo_list_close_icon').hide();
              $(main_variant_logos_wrapper).addClass('sticky-active');
               // $(".main_variant_logos_wrapper").attr("data-button-event", "sticky");
            }else{ 
              $('.collection_logo_list_close_icon').show();
            }
        });    
      }, 20);
    });
  }

  document.addEventListener('theme:cart:change', function(event) { 
    var addPersonalizeProduct = addUpdatePersonalizeProduct();
    addPersonalizeProduct.then(function(res) { 
    });
  });
});

$(document).off("click", ".accordion").on("click", ".accordion", function (e) {
  e.preventDefault();
  if ($(this).hasClass("active")) {
    $(this).removeClass("active");
    $(this).next(".panel").slideUp("fast");
    $(this).find(".arrow svg").css("transform", "rotate(0deg)");
  } else {
    $(".accordion").removeClass("active");
    $(".panel").slideUp("fast");
    $(".accordion .arrow svg").css("transform", "rotate(0deg)");
    $(this).addClass("active");
    $(this).next(".panel").slideDown("fast");
    $(this).find(".arrow svg").css("transform", "rotate(180deg)");
  }
});

$(document).on("keypress input", ".input-personalize-text", function (e) {
  // const maxLines = 2;
  // const maxCharsPerLine = 10;
  const maxLines = 3;
  const maxCharsPerLine = 25;
  $("#error-message").hide();
  let value = $(this).val();
  let lines = value.split("\n");
  if (e.key === "Enter" && lines.length >= maxLines) {
    $("#error-message").text("Only "+maxLines+" lines allowed.").show();
    e.preventDefault();
    return;
  }
  
  for (let i = 0; i < lines.length; i++) {
    if (lines[i].length > maxCharsPerLine) {
      $("#error-message").text("Maximum "+maxCharsPerLine+" characters per line allowed.").show();
      lines[i] = lines[i].substring(0, maxCharsPerLine);
      $(this).val(lines.join("\n"));
      return;
    }
  }

  if (e.key === "Backspace" || e.inputType === "deleteContentBackward") {
    lines = $(this).val().split("\n");
    let trimmedLines = lines.map((line) =>
      line.substring(0, maxCharsPerLine)
    );

    if (trimmedLines.length > maxLines) {
      trimmedLines = trimmedLines.slice(0, maxLines);
      $("#error-message").text("Only "+maxLines+" lines allowed.").show();
    }
    $(this).val(trimmedLines.join("\n"));
  }
});

document.addEventListener("DOMContentLoaded", function () {
  let links = document.querySelectorAll(".grid-product__content a");
  let currentUrl = window.location.href;
  var mainurl = new URL(window.location.href); 
  links.forEach(link => {
      let href = link.getAttribute("href");
      if (href && currentUrl.includes("view_type=addOrder")) { 
        var order_page_type = "";
        if(currentUrl.includes("order_page_type=")){ 
          var orderPageType = mainurl.searchParams.get("order_page_type"); 
          if(orderPageType!=''){
            var order_page_type = "&order_page_type="+orderPageType;
          }
        }
        link.href = href + "&view_type=addOrder" + order_page_type;
      }
  });
});

function update_cart_item(){
   if (window.location.href.includes("view_type=addOrder")) { 
    let currentUrl = window.location.href;
    var mainurl = new URL(window.location.href); 
    let productForm = $(".product-single__form");
    let variantId = productForm.find("input[name='id']").val();
    let quantity = 1;
    let productTitle = $(".product-single__title").text();
    let productImage = $(".product-image-main").eq(0).find("image-element").find("image").attr("href");;
    let price = $(".product__price").text();
    let properties = propertiesSerializeForm(productForm);
    let cart = getCartDetails();
    var collection_product_url = $("#collection_product_url").val();
    var tmp_item_id = Date.now();
    cart.line_items.push({
        id: tmp_item_id, // Generate a unique ID
        variant_id: variantId,
        price: (meta.product.variants[0].price/100),
        quantity: quantity,
        title: productTitle,
        name: productTitle,
        images: {src: productImage},
        handle: collection_product_url.replace("/products/",""),
        product_id: meta.product.id,
        sku: meta.product.variants[0].sku,
        vendor:  meta.product.vendor,
        properties: properties
    });
    updateCartDetails(cart);

    var orderPageType = "";
    if(currentUrl.includes("order_page_type=")){ 
      orderPageType = mainurl.searchParams.get("order_page_type"); 
    }
    if(orderPageType!=""){
      window.location.href = "/account/orders/"+orderPageType;
    }else{
      window.location.href = "/pages/cart-details";
    }
  }else if(window.location.href.includes("pages/cart-details") || window.location.href.includes("account/orders")){ 
    let productForm = $(".product-single__form");
    var current_item_id = parseInt($("#current_item_id").val()); 
    let properties = propertiesSerializeForm(productForm);
    let cart = getCartDetails();
    cart.line_items.forEach((item, index) => {
      if (item.id === current_item_id) { 
        cart.line_items[index]['properties'] = properties; 
      }
    });  
    updateCartDetails(cart);
    autoFatchOrderDetails();
    $("#ajax_loader").show();
  }else{
    $(".btn--add-to-cart").trigger("click");
    $(".add-to-cart-sub-btn").find("[data-add-to-cart-text]").html("Add to cart");
  }
}

async function addUpdatePersonalizeProduct() {
  try {
    const res = await fetch(`${window.Shopify?.routes?.root??"/"}cart.js`);
    const cart = await res.json();
     
    let logoLocationFirst = 0;
    let additionalLogoLocation = 0;
    let personalizaLogoLocation = 0;
     
    cart.items.forEach(item => {
      let quantity = parseInt(item.quantity);
      let properties = item["properties"];
 
      if (item.handle !== "embroidery" && item.handle !== "additional-logo-locations" && item.handle !== "personalization" && !$.isEmptyObject(properties)) {
        let logoCount = 0;
        let personalizationCount = 0;
 
        Object.keys(properties).forEach(logoKey => {
          const logoValue = properties[logoKey];
           
          if (logoKey.toLowerCase().startsWith("logo") && logoValue.trim() !== "") {
            logoCount++;
          } 
          if (logoKey.toLowerCase().startsWith("_personalization") && logoKey.toLowerCase().includes("coordinates") && logoValue.trim() !== "") {
            personalizationCount++;
          }
        });
 
        if (logoCount > 0) {
          if (logoCount > 1) {
            logoLocationFirst += quantity;
            additionalLogoLocation += quantity * (logoCount - 1);
          } else {
            logoLocationFirst += quantity;
          }
        }
        
        if (personalizationCount > 0) {
          personalizaLogoLocation += quantity * personalizationCount;
        }
      }
    });
 
    let logoLocationFirst12_5 = 0;
    let logoLocationFirst7_5 = 0;
    let logoLocationFirst2_5 = 0;

    if (logoLocationFirst === 1) {
      logoLocationFirst12_5 = logoLocationFirst;
    } else if (logoLocationFirst > 1 && logoLocationFirst < 72) {
      logoLocationFirst7_5 = logoLocationFirst;
    } else if (logoLocationFirst > 72) {
      logoLocationFirst2_5 = logoLocationFirst;
    }
 
    const [logoLocationFirst12_5_id, logoLocationFirst7_5_id, logoLocationFirst2_5_id, additionalLogoLocation_id, personalizaLogoLocation_id] = await Promise.all([
      getProductByHandle("embroidery", "id", "sku", "EMB-1"),
      getProductByHandle("embroidery", "id", "sku", "EMB-2"),
      getProductByHandle("embroidery", "id", "sku", "EMB-3"),
      getProductByHandle("additional-logo-locations", "id", "first", ""),
      getProductByHandle("personalization", "id", "first", "")
    ]);  
    
    const response = {
      "logoLocationFirst12_5": { "id": logoLocationFirst12_5_id, "quantity": logoLocationFirst12_5 },
      "logoLocationFirst7_5": { "id": logoLocationFirst7_5_id, "quantity": logoLocationFirst7_5 },
      "logoLocationFirst2_5": { "id": logoLocationFirst2_5_id, "quantity": logoLocationFirst2_5 },
      "additionalLogoLocation": { "id": additionalLogoLocation_id, "quantity": additionalLogoLocation },
      "personalizaLogoLocation": { "id": personalizaLogoLocation_id, "quantity": personalizaLogoLocation }
    };
 
    const updates = Object.keys(response).reduce((acc, key) => {
      const product = response[key];
      const product_id = product.id.toString();
      acc[product_id] = product.quantity; 
      return acc;
    }, {});
 
    if (Object.keys(updates).length > 0) {
      $.ajax({
        url: `${window.Shopify?.routes?.root??"/"}cart/update.js`,
        type: 'POST',
        dataType: 'json',
        data: { updates: updates },
        success: function(cart) {
          document.dispatchEvent(new Event('theme:cart:reload'));
        },
        error: function(err) {
          console.error('Error adding products to cart:', err);
        }
      });
    }
    return response;
  } catch (error) {
    // console.error('Error in addUpdatePersonalizeProduct:', error);
    // throw error;
  }
}

function getProductByHandle(product_handle, res_type, type, sku) {
    return new Promise(function(resolve, reject) {  
        jQuery.getJSON('/products/' + product_handle + '.js', function(product) {  
            var resProduct = ""; 
            if(res_type == 'id'){ 
              if (type === 'first') { 
                  resProduct = product.variants[0].id;
              } else if (type === 'sku' && sku !== '') { 
                  $.each(product.variants, function(index, item) {
                      if (item.sku === sku) {
                          resProduct = item.id;
                          return false;
                      }
                  });
              }
            }else{
              if (type === 'first') { 
                  var variantsData = product.variants[0];
                  variantsData.product_id = product.id; 
                  resProduct = variantsData;
              } else if (type === 'sku' && sku !== '') { 
                  $.each(product.variants, function(index, item) {
                      if (item.sku === sku) {
                          item.product_id = product.id;
                          resProduct = item;
                          return false;
                      }
                  });
              }
            }
            if (resProduct === '') {
                resProduct = product;
            } 
            resolve(resProduct);
        }).fail(function(error) {  
            reject('Error fetching product data: ' + error.statusText);
        });
    });
}

$(document).off("click", ".logo_product-form__swatch__item").on("click", ".logo_product-form__swatch__item", function () {
  const $this = $(this);
  const logoSVG = $this.find(".logo-image-svg svg").html();
  const logoSVGviewBox = $this.find(".logo-image-svg svg").attr("viewBox");
  const inputText = $(".input-personalize-text").val();
 
  $(".media-gallery__slider .logo-image-svg svg").each(function () {
    const $svg = $(this);
    if ($svg.html() !== logoSVG) {
      $svg.html(logoSVG);
      $svg.attr("viewBox",logoSVGviewBox);
    }
  });
  $(".logo-inner").trigger("change");
  if (inputText) { 
    setTimeout(() => {
      const $input = $(".input-personalize-text");
      $input.val(inputText).trigger("keyup"); 
      $("[class^='personalization_properties_']").prop("disabled", false);
    }, 500);
  }
});


$(document).on("click", ".custom_logo_customization_popup_scroll", function(e) {
  e.preventDefault();
  var suffix_id = $(this).attr("data-suffix");
  var data_scroll_id = $(this).attr("data-scroll-id");
  $('#'+data_scroll_id).removeAttr('disabled'); 
  $('#'+data_scroll_id).focus();
});

$(document).off("change", ".collections-logo-inner");
$(document).on("change", ".collections-logo-inner", function(e) {
  e.preventdefault;
  var logo_svg_url = $(this).find(".logo-input-svg").attr("data-logo-image-template");
  var logo_svg_code = $(this).attr("data-variant-logo-code");
  logoImageSvgLoad(logo_svg_url);
  $(".grid-product__link").each(function(index) {
    var hrefVal = $(this).attr("href");
    var urlObj;
    if (hrefVal.startsWith('http')) {
      urlObj = new URL(hrefVal);
    } else {
      urlObj = new URL(hrefVal, window.location.origin);
    }
    if (urlObj.searchParams.has("sLogo")) {
        urlObj.searchParams.set("sLogo", logo_svg_code);
    } else {
        urlObj.searchParams.append("sLogo", logo_svg_code);
    }
    $(this).attr("href", urlObj.toString());
  });
});

$(document).on("click", ".logo-input-customization", function(e) {
  e.preventdefault;
  var thisEle = $(this);
  var suffix_id = $(this).attr("data-suffix");
  var location_suffix_id = $(this).attr("data-location-suffix");
  var logo_input_svg_html = $(this).find(".logo_customization_svg").html();
  var svg_logo_x_code = $(this).attr("data-x");
  var svg_logo_y_code = $(this).attr("data-y");
  var svg_logo_width_code = $(this).attr("data-width");
  var svg_logo_height_code = $(this).attr("data-height");
  var svg_logo_rotate_angle_code = $(this).attr("data-rotate-angle");
 
  var text_logo_input_svg_html = $(this).find(".logo_customization_svg_text").html();
  var text_svg_logo_x_code = $(this).find(".logo-image-svg-text").find("text").attr("x");
  var text_svg_logo_y_code = $(this).find(".logo-image-svg-text").find("text").attr("y");
  var text_svg_logo_width_code = $(this).find(".logo-image-svg-text").find("text").attr("width");
  var text_svg_logo_height_code = $(this).find(".logo-image-svg-text").find("text").attr("height");

  $(".product__main-photos_" + location_suffix_id).find(".logo-image-svg").each(function(index) {
    $(this).html(logo_input_svg_html);
    if(svg_logo_rotate_angle_code > 0){
      $(this).attr({ "transform": "rotate("+svg_logo_rotate_angle_code+", "+svg_logo_x_code+", "+svg_logo_y_code+")" });  
      $(this).find("svg").attr("rotate_angle",svg_logo_rotate_angle_code);
    }else{
      $(this).removeAttr("transform");  
    }
    
    $(this).find("svg").attr({
      "width": svg_logo_width_code,
      "height": svg_logo_height_code,
      "x": svg_logo_x_code,
      "y": svg_logo_y_code
    });
    $(this).find("image").attr("style", "mix-blend-mode: multiply;");
  });

  if(text_logo_input_svg_html!=''){
    text_logo_input_svg_html = text_logo_input_svg_html.replace("<hr>", "").replace("<br>", "");
    $(".product__main-photos_" + location_suffix_id).find(".logo-image-svg-text").html(text_logo_input_svg_html); 
    $(".personalization_properties_" + location_suffix_id).each(function(index) { 
        $(this).removeAttr('disabled');
    });
  }else{
    $(".product__main-photos_" + location_suffix_id).find(".logo-image-svg-text").html(""); 
    $(".personalization_properties_" + location_suffix_id).each(function(index) {
      //if($(this).val()!=''){
        $(this).attr('disabled', "disabled");
      //}
    });
  }

  // $(".logo_inner_input_" + location_suffix_id).each(function(index) {
  //   $(this).find('input').prop('checked', false);
  // });
  // $(".logo_inner_input_" + suffix_id).find('input').prop('checked', true);
  $(".logo_inner_input_" + location_suffix_id).each(function(index) { 
    $(this).find('input').removeAttr('checked');
    $(this).find('input').prop('checked', false);
  }); 
  $(".logo_inner_input_" + suffix_id).find('input').attr('checked', 'checked');
  $(".logo_inner_input_" + suffix_id).find('input').prop('checked', true); 
  
  $(".logo-input-customization-" + location_suffix_id).each(function(index) {
    $(this).find(".logo-input").removeClass("active");
  });
  thisEle.find(".logo-input").addClass("active");

  $(".location_note_" + location_suffix_id).each(function(index) {
    $(this).attr('disabled', "disabled");
  });
  logoPropertiesUpdate(thisEle, suffix_id, location_suffix_id);
  var custom_form_id = $("#custom_form_id").val();
  $("#location_note_" + suffix_id).removeAttr('disabled');
  $("#location_note_" + suffix_id).attr('form', custom_form_id);

});

$(document).off("change", ".logo-inner");
$(document).on("change", ".logo-inner", function(e) {
  e.preventdefault;
  var suffix_id = $(this).attr("data-suffix");
  var location_suffix_id = $(this).attr("data-location-suffix");
  var data_variant_id = $(this).attr("data-variant-logo");
  var form_id = $(this).attr("form-id");
  var data_variant_logo_code = $(this).attr("data-variant-logo-code");
  var base64_id = "#logo-base64-" + location_suffix_id + "-" + data_variant_id;
  var logo_input_svg_html = $(this).find(".logo-input-svg").html();
  var logo_input_svg_element = $(this).find(".logo-input-svg");
  var data_variant_logo_src = $(this).find("img").attr("src");
  var text_logo_input_svg_html = $("#logo_customization_view_" + suffix_id).find(".logo_customization_svg_text").html();
  var product_main_logo_viewing = $("#product_main_logo_viewing").val();
  if(product_main_logo_viewing == "Logo Mockup"){
    var checkedRadioButtonId = $("input[name='properties[Logo]']:checked").attr("id");
    var logo_input_svg_element = $("."+checkedRadioButtonId).find(".logo-image-svg");
  }
  
  $(".logo_inner_input_" + location_suffix_id).each(function(index) { 
    $(this).find('input').removeAttr('checked');
    $(this).find('input').prop('checked', false);
  }); 
  $(".logo_inner_input_" + suffix_id).find('input').attr('checked', 'checked');
  $(".logo_inner_input_" + suffix_id).find('input').prop('checked', true); 
  
  $('#_logo_' + location_suffix_id + '_rotate_angle').val("");
  $(".logo-input-customization-" + location_suffix_id).each(function(index) {
    $(this).find(".logo-input").removeClass("active");
  });
  $("#logo_customization_view_" + suffix_id).find(".logo-input").addClass("active");

  if (typeof data_variant_logo_src === 'undefined') {
    var data_variant_logo_src = $(this).find(".logo-input-svg").attr("data-logo-image-template");
  }
  logoLayerRender(logo_input_svg_html, data_variant_logo_src, base64_id, suffix_id, "_" + location_suffix_id);

  $("#logo_customization_" + suffix_id).html('<div id="loading-bar-spinner" class="spinner"><div class="spinner-icon"></div></div>');

  if (logo_input_svg_element != '') {
    logoCustomizationLayer(logo_input_svg_element, form_id, base64_id, data_variant_id, suffix_id, location_suffix_id);
  }
  var canvas_id = 'logo-image-svg-canvas-' + suffix_id + "-" + data_variant_id;
  loadSVG(canvas_id, logo_input_svg_element, suffix_id, location_suffix_id);

  if(text_logo_input_svg_html!=''){
    text_logo_input_svg_html = text_logo_input_svg_html.replace("<hr>", "").replace("<br>", "");
    $(".product__main-photos_" + location_suffix_id).find(".logo-image-svg-text").html(text_logo_input_svg_html);
    $(".personalization_properties_" + location_suffix_id).each(function(index) { 
        $(this).removeAttr('disabled');
    });
  }else{
    $(".product__main-photos_" + location_suffix_id).find(".logo-image-svg-text").html('');
    $(".personalization_properties_" + location_suffix_id).each(function(index) {
        $(this).attr('disabled', "disabled");
    });
  }
  $(".custom_logo_customization_popup_btn_" + location_suffix_id).addClass('hide');
  $(".custom_logo_customization_popup_" + suffix_id).removeClass('hide');
});

$(document).on("click", ".custom_logo_customization_popup_btn", function(e) {
  e.preventdefault;
  var suffix_id = $(this).attr("data-suffix");
  var location_suffix_id = $(this).attr("data-location-suffix");
  var data_button = $(this).attr("data-button"); 
  var product_main_logo_viewing = $("#product_main_logo_viewing").val();
  
  $("#custom_logo_customization_popup_" + suffix_id).addClass("open-popup");
  $("body").addClass("open-customization-popup");
  $("#logo_customization_view_" + suffix_id).removeClass("logo-hidden");
  $(".logo_inner_input_" + suffix_id).addClass('hide');
  $(".logo-input-customization-" + location_suffix_id).each(function(index) {
    $(this).find(".logo-input").removeClass("active");
  });
  $("#logo_customization_view_" + suffix_id).find(".logo-input").addClass("active");
  if(product_main_logo_viewing != "Logo Mockup"){
     window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth'
    });
  } 
});

$(document).on("click", ".custom_logo_customization_popup_close", function(e) {
  var suffix_id = $(this).attr("data-suffix");
  var location_suffix_id = $(this).attr("data-location-suffix");
  var btn_type = $(this).attr("btn-type");
  var text_logo_input_svg_html = $("#logo_customization_view_"+suffix_id).find(".logo_customization_svg_text").html();
  var product_main_logo_viewing = $("#product_main_logo_viewing").val();
  
  if(btn_type == 'close' && product_main_logo_viewing != "Logo Mockup"){
    $('#input_personalize_text_' + suffix_id).val('');
    personalizationTextCanvas('', suffix_id, location_suffix_id);
    $(".custom_logo_customization_popup_" + suffix_id).trigger('change');
  }
  $("body").removeClass("open-customization-popup");
  $("#custom_logo_customization_popup_" + suffix_id).removeClass("open-popup");
  if(text_logo_input_svg_html!=''){
    $(".personalization_properties_" + location_suffix_id).each(function(index) { 
        $(this).removeAttr('disabled');
    });
  }else{
    $(".personalization_properties_" + location_suffix_id).each(function(index) {
        $(this).attr('disabled', "disabled");
    });
  }
  
  setTimeout(function() {
    var currentUrl = window.location.href;
    var newUrl = currentUrl.split('#')[0];
    window.history.pushState({}, "", newUrl);
  }, 500);
});

$(document).on("click", ".custom_logo_customization_popup_reset", function(e) {
  var suffix_id = $(this).attr("data-suffix");
  var location_suffix_id = $(this).attr("data-location-suffix");
  var product_main_logo_viewing = $("#product_main_logo_viewing").val();
  $('#input_personalize_text_' + suffix_id).val('');
  personalizationTextCanvas('', suffix_id, location_suffix_id);
  $("#input_personalize_font_"+suffix_id).val($("#input_personalize_font_"+suffix_id+" option:first").val());
  $("#input_personalize_font_size_"+suffix_id).val($("#input_personalize_font_size_"+suffix_id+" option:first").val());
  $('#location_note_' + suffix_id).val('');
  $(".custom_logo_customization_popup_" + suffix_id).trigger('change');
  if(product_main_logo_viewing != "Logo Mockup"){
    setTimeout(function() {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      });
     }, 500);
  }
});

function logoPropertiesUpdate(svgDivHtml,suffix_id, location_suffix_id){
  var svg_logo_x_code = svgDivHtml.attr("data-x");
  var svg_logo_y_code = svgDivHtml.attr("data-y");
  var svg_logo_width_code = svgDivHtml.attr("data-width");
  var svg_logo_height_code = svgDivHtml.attr("data-height");
  var svg_logo_rotate_angle_code = svgDivHtml.attr("data-rotate-angle");
  var svgHtml = svgDivHtml.find(".logo_customization_svg"); 
  var svgText = svgDivHtml.find(".logo_customization_svg_text").find("text");
  
  var thread_colors_pro = [];
  var thread_names_pro = [];
  var thread_codes_pro = [];
  
  svgHtml.find('[id^="layer_"]').each(function(index) {
      var layer_id = this.id;
      var fill_color = $(this).attr("fill");
      var logo_thread_title = $(this).attr("logo-thread-title");
      var logo_thread_code = $(this).attr("logo-thread-code");
      var layer_id_tmp = layer_id.replace('_', '-');
      thread_colors_pro[index] = fill_color;
    
      if (typeof logo_thread_title !== "undefined" && typeof logo_thread_code !== "undefined") { 
        thread_names_pro[index] = logo_thread_title;
        thread_codes_pro[index] = logo_thread_code;
      } else { 
        thread_names_pro[index] = layer_id_tmp;
        thread_codes_pro[index] = layer_id_tmp; 
      }
  });  
  
  $('#_logo_' + location_suffix_id + '_coordinates').val(svg_logo_x_code + "_" + svg_logo_y_code + "_" + svg_logo_width_code + "_" + svg_logo_height_code);
  if(svg_logo_rotate_angle_code!='' && svg_logo_rotate_angle_code>0){
    $('#_logo_' + location_suffix_id + '_rotate_angle').val(svg_logo_rotate_angle_code);  
  }else{
    $('#_logo_' + location_suffix_id + '_rotate_angle').val("");
  }
  $("#_logo_" + location_suffix_id + "_thread_colors").val(thread_colors_pro.join('_'));
  $("#_logo_" + location_suffix_id + "_thread_names").val(thread_names_pro.join('_'));
  $("#_logo_" + location_suffix_id + "_thread_codes").val(thread_codes_pro.join('_'));

  if(svgText.length>0){
    var input_personalize_text = $("#input_personalize_text_"+suffix_id).val();
    var fill_color = svgText.attr("fill");
    var color_hex_code_only = fill_color.replace("#",'');
    var logo_thread_title = $(".thread_colors_"+suffix_id+"_text_layer_1_"+color_hex_code_only).find("input").attr("thread_colors_title");
    var logo_thread_code = $(".thread_colors_"+suffix_id+"_text_layer_1_"+color_hex_code_only).find("input").attr("thread_colors_code");
     if (typeof svgText.attr("data-value") !== "undefined") {
      $("#_personalization_" + location_suffix_id + "_text").val(svgText.attr("data-value"));
    }else{
      $("#_personalization_" + location_suffix_id + "_text").val(input_personalize_text);
    }
    $("#_personalization_" + location_suffix_id + "_font").val(svgText.attr("font-family"));
    $("#_personalization_" + location_suffix_id + "_font_size").val(svgText.attr("font-size"));
    $("#_personalization_" + location_suffix_id + "_thread_names").val(logo_thread_title +" - "+ logo_thread_code);
    $("#_personalization_" + location_suffix_id + "_thread_colors").val(svgText.attr("fill"));
    $("#_personalization_" + location_suffix_id + "_thread_codes").val(logo_thread_code);
    $("#_personalization_" + location_suffix_id + "_coordinates").val(svgText.attr("x")+"_"+svgText.attr("y")+"_"+svgText.attr("width")+"_"+svgText.attr("height"));
  }else{
    $("#_personalization_" + location_suffix_id + "_text").val("");
    $("#_personalization_" + location_suffix_id + "_font").val("");
    $("#_personalization_" + location_suffix_id + "_font_size").val("");
    $("#_personalization_" + location_suffix_id + "_thread_names").val("");
    $("#_personalization_" + location_suffix_id + "_thread_colors").val("");
    $("#_personalization_" + location_suffix_id + "_thread_codes").val("");
    $("#_personalization_" + location_suffix_id + "_coordinates").val("");
  }
}

function logoCustomizationLayer(svgHtml, form_id, base64_id, data_variant_id, suffix_id, location_suffix_id) {
  var custom_form_id = $("#custom_form_id").val();
  var logoCustClone = $("#logo_customization_clone_" + suffix_id).html();
  var logoCustCloneSectionId = $("#logo_customization_clone_" + suffix_id).attr("data-section-id");
  var threadConeSvg = getFixdThreadConeSvg();
  var logo_customization = $('#logo_customization_' + suffix_id);
  var personalize_customization = $('#personalize_customization_' + suffix_id);
  var personalize_customization_assigned_thread = $('#personalize_customization_' + suffix_id).attr("assigned-thread");
  var personalize_customization_use_assigned = $('#personalize_customization_' + suffix_id).attr("use-assigned-thread");   
  var visible_section = $('#meta_logo_custom_index_section_' + location_suffix_id).is(':visible');
  var thread_colors_pro = [];
  var thread_names_pro = [];
  var thread_codes_pro = [];
  
  threadConeSvg.then(function(threadConeSvgRes) {
    if (typeof logoCustClone !== "undefined") { 
      svgHtml.find('[id^="layer_"]').each(function(index) {
        var layer_id = this.id;
        var logo_thread_title = $(this).attr("logo-thread-title");
        var logo_thread_code = $(this).attr("logo-thread-code");
        var layer_id_tmp = layer_id.replace('_', '-');
        var layer_id_formatted = layer_id.replace(/_/g, ' ').replace(/\b\w/g, function(char) {
          return char.toUpperCase();
        });
        var fill_color = $(this).attr("fill");
        thread_colors_pro[index] = fill_color;
       
        var replaceHtml = logoCustClone.replace(/{~i~}/g, layer_id);
        replaceHtml = replaceHtml.replace(/{~index~}/g, index);

        logo_customization.append(replaceHtml);
  
        if (typeof logo_thread_title !== "undefined" && typeof logo_thread_code !== "undefined") {
          layer_id_formatted = layer_id_formatted + " | " + logo_thread_title + " (" + logo_thread_code + ")";
          thread_names_pro[index] = logo_thread_title;
          thread_codes_pro[index] = logo_thread_code;
        } else {
          var color_hex_code_only = fill_color.replace("#",'');
          var logo_thread_title = $(".thread_colors_"+suffix_id+"_"+layer_id+"_"+color_hex_code_only).find("input").attr("thread_colors_title");
          var logo_thread_code = $(".thread_colors_"+suffix_id+"_"+layer_id+"_"+color_hex_code_only).find("input").attr("thread_colors_code");
          
          if (typeof logo_thread_title == "undefined" && typeof logo_thread_code == "undefined") { 
            logo_thread_title = $(".thread_colors_"+color_hex_code_only).attr("thread_colors_title");
            logo_thread_code = $(".thread_colors_"+color_hex_code_only).attr("thread_colors_code");
          }

          if (typeof logo_thread_title !== "undefined" && typeof logo_thread_code !== "undefined") { 
            svgHtml.find("#"+layer_id).attr({"logo-thread-title":logo_thread_title,"logo-thread-code":logo_thread_code});
            layer_id_formatted = layer_id_formatted + " | " + logo_thread_title + " (" + logo_thread_code + ")";
            thread_names_pro[index] = logo_thread_title;
            thread_codes_pro[index] = logo_thread_code;
          }else{
            thread_names_pro[index] = layer_id_tmp;
            thread_codes_pro[index] = layer_id_tmp;
          }
        }
        logo_customization.find("#logo_customization_title_" + suffix_id + "_" + layer_id).html(layer_id_formatted);
        logo_customization.find("#thread_colors_properties_" + suffix_id + "_" + layer_id).val(fill_color);
        logo_customization.find("#thread_colors_properties_" + suffix_id + "_" + layer_id).attr("form", form_id);
        if (visible_section) {
          logo_customization.find("#thread_colors_properties_" + suffix_id + "_" + layer_id).attr('disabled', false);
        } else {
          logo_customization.find("#thread_colors_properties_" + suffix_id + "_" + layer_id).attr('disabled', true);
        }
        logo_customization.find("#logo_customization_image_" + suffix_id + "_" + layer_id).html(threadConeSvgRes);
        logo_customization.find("#logo_customization_image_" + suffix_id + "_" + layer_id).find('svg').attr({
          "width": 50,
          "height": 50
        });
        logo_customization.find("#logo_customization_image_" + suffix_id + "_" + layer_id).find('#thread_color').attr({
          "fill": fill_color
        }).css("fill", fill_color);
        logo_customization.find("#logo_customization_image_" + suffix_id + "_" + layer_id).find('#Shadow_Image').attr("style", "mix-blend-mode: multiply;");
      });
  
      customization_thread_cone_img(logo_customization, threadConeSvgRes);
    
      if (1) {
        var layer_id = "text_layer_1";
        var layer_id_formatted = layer_id.replace(/_/g, ' ').replace(/\b\w/g, function(char) {
          return char.toUpperCase();
        });
        
        if(typeof personalize_customization_assigned_thread !== "undefined" && personalize_customization_assigned_thread!=""){
          var fill_color =  personalize_customization_assigned_thread;
        }else{
          // var fill_color = "#E12B29";
          var fill_color = "#302E32";
        } 
        $("#_personalization_edit_"+location_suffix_id+"_thread_colors").val(fill_color);
        var color_hex_code_only = fill_color.replace("#",'');
        var logo_thread_title = $(".thread_colors_"+suffix_id+"_"+layer_id+"_"+color_hex_code_only).find("input").attr("thread_colors_title");
        var logo_thread_code = $(".thread_colors_"+suffix_id+"_"+layer_id+"_"+color_hex_code_only).find("input").attr("thread_colors_code");
        if (typeof logo_thread_title !== "undefined" && typeof logo_thread_code !== "undefined") {  
          layer_id_formatted = layer_id_formatted + " | " + logo_thread_title + " (" + logo_thread_code + ")";  
        }
        var replaceHtml = logoCustClone.replace(/{~i~}/g, layer_id);
        replaceHtml = replaceHtml.replace(/{~index~}/g, svgHtml.find('[id^="layer_"]').length);
        personalize_customization.html(replaceHtml);
        personalize_customization.find("#logo_customization_title_" + suffix_id + "_" + layer_id).html(layer_id_formatted);
        personalize_customization.find("#thread_colors_properties_" + suffix_id + "_" + layer_id).val(fill_color);
        personalize_customization.find("#thread_colors_properties_" + suffix_id + "_" + layer_id).attr("form", form_id);
        personalize_customization.find("#logo_customization_image_" + suffix_id + "_" + layer_id).html(threadConeSvgRes);
        personalize_customization.find("#logo_customization_image_" + suffix_id + "_" + layer_id).find('svg').attr({ "width": 50, "height": 50 });
        personalize_customization.find("#logo_customization_image_" + suffix_id + "_" + layer_id).find('#thread_color').attr({ "fill": fill_color }).css("fill", fill_color);
        personalize_customization.find("#logo_customization_image_" + suffix_id + "_" + layer_id).find('#Shadow_Image').attr("style", "mix-blend-mode: multiply;");
        if(personalize_customization_use_assigned == "false"){ 
          personalize_customization.find(".icon-use-assigned").hide();
        }
      }
      customization_thread_cone_img(personalize_customization, threadConeSvgRes);
    }
    $('#logo_customization_' + suffix_id).find(".thread_colors_update").each(function(index) {
      $(this).attr("data-variant-logo", data_variant_id);
    });

    $(".logo_customization_view_" + suffix_id).each(function(index) {
      $(this).find(".logo-image-svg").html(svgHtml.html());
      if ($(this).attr("display-type") == "Popup") {
        $(this).find(".logo-image-svg").find("svg").attr({
          width: "100%",
          height: "100%"
        });
      }
    });

    $(".location_note_" + location_suffix_id).each(function(index) {
      $(this).attr('disabled', "disabled");
    });
    if (visible_section) {
      var custom_form_id = $("#custom_form_id").val();
      $("#location_note_" + suffix_id).removeAttr('disabled');
      $("#location_note_" + suffix_id).attr('form', custom_form_id);
    }

    sectionSetup(logoCustCloneSectionId);

    logo_customization.find("input").each(function() {
      $(this).attr('form', custom_form_id);
    });
    $("#_logo_" + location_suffix_id + "_thread_colors").val(thread_colors_pro.join('_'));
    $("#_logo_" + location_suffix_id + "_thread_names").val(thread_names_pro.join('_'));
    $("#_logo_" + location_suffix_id + "_thread_codes").val(thread_codes_pro.join('_'));
    logo_customization.find(".spinner").hide();
  });
}

function customization_thread_cone_img(logo_customization_div, threadConeSvgRes) {
  logo_customization_div.find(".logo_customization_thread_cone_img").each(function(index) {
    var data_thread_cone_code = $(this).attr("data-thread-cone-code");
    $(this).html(threadConeSvgRes);
    $(this).find('svg').attr({
      "width": 50,
      "height": 50
    });
    $(this).find('#thread_color').attr({
      "fill": data_thread_cone_code
    }).css("fill", data_thread_cone_code);
    $(this).find('#Shadow_Image').attr("style", "mix-blend-mode: multiply;");
  });
}

$(document).on("click", ".thread_colors_update", function(e) {
  e.preventdefault;
  var location_suffix_id = $(this).attr("data-location-suffix");
  var suffix_id = $(this).attr("data-suffix");
  var thread_colors_value = $(this).val();
  var data_variant_id = $(this).attr("data-variant-logo");
  var base64_id = "#logo-base64-" + location_suffix_id + "-" + data_variant_id;
  var thread_colors_layer_id = $(this).attr("thread_colors_layer_id");
  var canvas_id = 'canvaslogo-image-svg-canvas-' + suffix_id + "-" + data_variant_id;

  var layer_id_formatted = thread_colors_layer_id.replace(/_/g, ' ').replace(/\b\w/g, function(char) {
    return char.toUpperCase();
  });
  var thread_colors_title_code = $(this).attr("thread_colors_title_code");
  var thread_colors_title = $(this).attr("thread_colors_title");
  var thread_colors_code = $(this).attr("thread_colors_code");

  $("#logo_customization_image_" + suffix_id + "_" + thread_colors_layer_id).find("#thread_color").attr({
    "fill": thread_colors_value
  }).css("fill", thread_colors_value);
  $("#logo_customization_title_" + suffix_id + "_" + thread_colors_layer_id).html(layer_id_formatted + " | " + thread_colors_title_code);
  $("#thread_colors_properties_" + suffix_id + "_" + thread_colors_layer_id).val(thread_colors_value);


  $(".product__main-photos_" + location_suffix_id).find(".logo-image-svg").each(function(index) {
    var image_layer = true;
    var logoThisObj = $(this).find("svg");
    logoThisObj.find("#" + thread_colors_layer_id).attr({
      "fill": thread_colors_value
    }).css("fill", thread_colors_value);
  });

  $(".logo_customization_view_" + suffix_id).each(function(index) {
    var logoThisObj = $(this).find(".logo-image-svg").find("svg");
    logoThisObj.find("#" + thread_colors_layer_id).attr({
      "fill": thread_colors_value,
      "logo-thread-title": thread_colors_title,
      "logo-thread-code": thread_colors_code
    }).css("fill", thread_colors_value);
  });

  setThreadColorsUpdateCanvas(canvas_id, thread_colors_layer_id, thread_colors_value);

  if (thread_colors_layer_id == "text_layer_1") {
    var product_main_logo_viewing = $("#product_main_logo_viewing").val();
    if(product_main_logo_viewing == "Logo Mockup"){ 
       $(".product__media__wrapper").find(".product__main-photos_custom").each(function(index) {
          $(this).find(".logo-image-svg-text").find("text").attr({ "fill": thread_colors_value }).css("fill", thread_colors_value);
      });
    }else{
      $(".product__main-photos_" + location_suffix_id).find(".logo-image-svg-text").find("text").attr({ "fill": thread_colors_value }).css("fill", thread_colors_value);
    }
    $(".logo_customization_view_" + suffix_id).each(function(index) {
      $(this).find(".logo-image-svg-text").find("text").attr({
        "fill": thread_colors_value,
        "logo-thread-title": thread_colors_title,
        "logo-thread-code": thread_colors_code
      }).css("color", thread_colors_value);
    });

    $("#_personalization_" + location_suffix_id + "_thread_names").val(thread_colors_title +" - "+ thread_colors_code);
    $("#_personalization_" + location_suffix_id + "_thread_colors").val(thread_colors_value);
    $("#_personalization_" + location_suffix_id + "_thread_codes").val(thread_colors_code);
  } else {
    var thread_colors_pro = [];
    var thread_names_pro = [];
    var thread_codes_pro = [];
    $("#logo_customization_view_" + suffix_id).find(".logo-image-svg").find('[id^="layer_"]').each(function(index) {
      var layer_id = this.id;
      var layer_id_tmp = layer_id.replace('_', '-');
      var ly_thread_colors_value = $(this).attr("fill");
      var ly_thread_colors_title = $(this).attr("logo-thread-title");
      var ly_thread_colors_code = $(this).attr("logo-thread-code");
      thread_colors_pro[index] = ly_thread_colors_value
      thread_names_pro[index] = (typeof ly_thread_colors_title !== "undefined") ? ly_thread_colors_title : layer_id_tmp
      thread_codes_pro[index] = (typeof ly_thread_colors_code !== "undefined") ? ly_thread_colors_code : layer_id_tmp
    });
    $("#_logo_" + location_suffix_id + "_thread_colors").val(thread_colors_pro.join('_'));
    $("#_logo_" + location_suffix_id + "_thread_names").val(thread_names_pro.join('_'));
    $("#_logo_" + location_suffix_id + "_thread_codes").val(thread_codes_pro.join('_'));
  }

});

function logoInputSvgLoad() { 
  var product_main_logo_viewing = $("#product_main_logo_viewing").val();
  var urlObj = new URL(window.location.href);
  var sLogoValue = urlObj.searchParams.get("sLogo");
  var main_variant_logos_wrapper = $(".main_variant_logos_wrapper");
  main_variant_logos_wrapper.each(function(index_main) {
    var $wrapper = $(this);
    var location_suffix_id, suffix_id, page_type, data_variant_logo_src;
    $wrapper.find(".logo-input-svg").each(function(index) {
      var $logoInputSvg = $(this);
      page_type = $logoInputSvg.attr("page-type");
      suffix_id = $logoInputSvg.attr("data-suffix");
      location_suffix_id = $logoInputSvg.attr("data-location-suffix");
      data_variant_logo_src = $logoInputSvg.attr("data-logo-image-template");
      
      if (data_variant_logo_src.includes("ONLYPERSONALIZATION")) {
        if(product_main_logo_viewing == "Logo Mockup"){
          setTimeout(function() {  $logoInputSvg.trigger('change');  }, 1500);
        }else{
          return;  
        }
      }
      
      variantLogoLayerRender(data_variant_logo_src, $logoInputSvg, false, "bgpickers", suffix_id, location_suffix_id);
      if (sLogoValue !== null) { 
        var sLogoValueCheck = location_suffix_id + "_" + sLogoValue;
        if (index_main === 0 && sLogoValueCheck === suffix_id) {
          var logoSection = $("#LogoSection-" + location_suffix_id + "-logos").find(".logo_inner_input_" + location_suffix_id + "_" + sLogoValue).find('input'); 
          setTimeout(function() { $logoInputSvg.trigger('change'); logoSection.prop("checked", true); }, 1500); 
        }
      } else {
        if (index_main === 0 && index === 0 && page_type !== 'collections') {
          setTimeout(function() {  $logoInputSvg.trigger('change');  }, 1500);
        }
      }
    });
  });
}

// function logoImageSvgLoad(logo_svg_url = '') {
//   var logo_image_svg_load = $(".logo-image-svg");
//   logo_image_svg_load.each(function(index) {
//     if($(this).attr("data-size") == "fixed"){
//       var image_layer = false;
//     }else{
//       var image_layer = true;
//     }
    
//     var logoThisObj = $(this);
//     var data_variant_logo = $(this).attr("data-variant-logo");
//     if(logo_svg_url!=''){
//       var data_variant_logo_src = logo_svg_url;  
//     }else{
//       var data_variant_logo_src = $(this).attr("data-logo-image-template");
//     }
    
//     variantLogoLayerRender(data_variant_logo_src, logoThisObj, image_layer, "layer_bgpickers");
//   });
// }

// function variantLogoLayerRender(logoUrl, loadHtml, image_layer = false, layer_class,suffix_id='',location_suffix_id='') {
//   if (typeof logoUrl !== 'undefined') {
//     let extension = logoUrl.substring(logoUrl.lastIndexOf('.') + 1);
//     if (extension == "svg") {
//       var xhr = new XMLHttpRequest();
//       xhr.open("GET", logoUrl);
//       xhr.onreadystatechange = function() {
//         if (xhr.readyState === 4) {
//           var response = xhr.response;
//           var success = $($.parseHTML(response)).filter("svg");
//           if (success.length == 1) {
//             if (image_layer) {
//               $(".logo-image-png").hide();
//               loadHtml.html(response).show();
//               loadHtml.find("svg").attr({
//                 //"viewBox":"0 0 2048 2048",
//                 "width": loadHtml.attr("width"),
//                 "height": loadHtml.attr("height"),
//                 "x": loadHtml.attr("x"),
//                 "y": loadHtml.attr("y")
//               });  
//             } else {
//               loadHtml.html(response);
//               loadHtml.find("svg").attr({  "width": 100, "height": 100 });  
//             }
//             var getImageHref = loadHtml.find("image").attr("href");

//             if (getImageHref.startsWith('http') || getImageHref.startsWith('https')) {
//               var getImagewidth = loadHtml.find("image").attr("width");
//               var getImageheight = loadHtml.find("image").attr("height");

//               getBase64Image(getImageHref, getImagewidth, getImageheight, function(base64String) {
//                 if (typeof(base64String) !== "undefined") {
//                   loadHtml.find("image").attr("image-href", getImageHref);
//                   loadHtml.find("image").attr("href", base64String);
//                 }
//               });
//             }
//             loadHtml.find("image").css("mix-blend-mode", "multiply");
//             loadHtml.find("svg").removeAttr("preserveAspectRatio");
            
//             logoLayer(loadHtml, layer_class,suffix_id,location_suffix_id);
//           }
//         }
//       }
//       xhr.send();
//     }
//   }
// }

// In-memory SVG cache
const svgCache = {}; 

// Main function to load all logo-image-svg elements
async function logoImageSvgLoad(logo_svg_url = '') {
  const logo_image_svg_load = $(".logo-image-svg");

  for (const el of logo_image_svg_load) {
    const $el = $(el);
    const image_layer = $el.attr("data-size") !== "fixed";
    const data_variant_logo_src = logo_svg_url || $el.attr("data-logo-image-template");

    await variantLogoLayerRender(data_variant_logo_src, $el, image_layer, "layer_bgpickers");
  } 
}

// Main renderer with in-memory cache
async function variantLogoLayerRender(logoUrl, loadHtml, image_layer = false, layer_class, suffix_id = '', location_suffix_id = '') {
  if (!logoUrl) return;
  const fileName = logoUrl.split('/').pop().replace(/\./g, '_');
  const cacheId = "LogoLocker_" + fileName;

  if (svgCache[cacheId]) {
    // Use cached SVG
    loadHtml.html(svgCache[cacheId]);
    finalizeSvg(loadHtml, image_layer, layer_class, suffix_id, location_suffix_id);
  } else {
    const extension = logoUrl.split('.').pop();
    if (extension === "svg") {
      try {
        const response = await fetchSvg(logoUrl);
        const parser = new DOMParser();
        const svgDoc = parser.parseFromString(response, "image/svg+xml").documentElement;
        const svgHtml = svgDoc.outerHTML;
        svgCache[cacheId] = svgHtml;
        loadHtml.html(svgHtml);
        finalizeSvg(loadHtml, image_layer, layer_class, suffix_id, location_suffix_id);
      } catch (err) {
        console.error("Failed to load SVG:", err);
      }
    }
  }
}

// Promisified SVG fetcher
function fetchSvg(url) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", url);
    xhr.onload = () => {
      if (xhr.status === 200) resolve(xhr.responseText);
      else reject(new Error("Failed to fetch SVG: " + xhr.status));
    };
    xhr.onerror = () => reject(new Error("Network error while fetching SVG"));
    xhr.send();
  });
}

// Finalize and prepare the SVG
function finalizeSvg(loadHtml, image_layer, layer_class, suffix_id, location_suffix_id) {
  const svg = loadHtml.find("svg");

  if (image_layer) {
    var svg_width = cal_svg_width =  parseInt(loadHtml.attr("width"));
    var svg_height = cal_svg_height =  parseInt(loadHtml.attr("height"));
    var svg_x = cal_svg_x = parseInt(loadHtml.attr("x"));
    var svg_y = cal_svg_y = parseInt(loadHtml.attr("y")); 
    var svg_hoop =  parseFloat(loadHtml.attr("data-hooper"));
    var svg_ratio =  parseFloat(svg.attr('ratio')); 
    // svg_ratio = 2;
    if (!isNaN(svg_hoop) && svg_hoop > 0 && !isNaN(svg_ratio) && svg_ratio > 0) {
      var multiplayer = svg_ratio/svg_hoop;
      if(multiplayer < 1){ 
        svg_width =  cal_svg_width*multiplayer;
        svg_height =  cal_svg_height*multiplayer;
        svg_x = cal_svg_x + ((cal_svg_width-svg_width)/2);
        svg_y = cal_svg_y + ((cal_svg_height-svg_height)/2);                 
      } 
    }

    $(".logo-image-png").hide(); 
    svg.attr({
      //"viewBox":"0 0 2048 2048",
      "width": svg_width,
      "height": svg_height,
      "x": svg_x,
      "y": svg_y
    }); 

    // $(".logo-image-png").hide();
    // svg.attr({
    //   width: loadHtml.attr("width"),
    //   height: loadHtml.attr("height"),
    //   x: loadHtml.attr("x"),
    //   y: loadHtml.attr("y")
    // });
  } else {
    svg.attr({ width: 100, height: 100 });
  }

  const image = loadHtml.find("image");
  const getImageHref = image.attr("href");

  if (getImageHref && (getImageHref.startsWith('http') || getImageHref.startsWith('https'))) {
    const getImagewidth = image.attr("width");
    const getImageheight = image.attr("height");

    getBase64Image(getImageHref, getImagewidth, getImageheight, function (base64String) {
      if (typeof base64String !== "undefined") {
        image.attr("image-href", getImageHref);
        image.attr("href", base64String);
      }
    });
  }

  image.css("mix-blend-mode", "multiply");
  svg.removeAttr("preserveAspectRatio");

  logoLayer(loadHtml, layer_class, suffix_id, location_suffix_id);
}

function getBase64Image(img, getImagewidth = 1024, getImageheight = 1024, callback) {
  var Base64canvas = document.createElement("canvas");
  var ctx = Base64canvas.getContext("2d");
  const baseImage = new Image();
  baseImage.crossOrigin = "anonymous";
  baseImage.onload = function() {
    Base64canvas.width = getImagewidth;
    Base64canvas.height = getImageheight;
    ctx.drawImage(baseImage, 0, 0, getImagewidth, getImageheight);
    var dataURL = Base64canvas.toDataURL("image/png"); 
    if (typeof callback === 'function') {
      callback(dataURL);
    }
  }
  baseImage.src = img;
}

function logoLayer(thisObj, layer_class, suffix_id = '', location_suffix_id = '') {
  var logoLayerClass = location_suffix_id !== '' ? ".bg_svg_thread_instructions_" + location_suffix_id  : "." + layer_class + "-" + thisObj.attr("data-variant-logo");

  var data_switchy = thisObj.data("switchy");
  if(data_switchy){
  thisObj.find('[id^="layer_"]').each(function(index) {
    var fillColor = $(this).attr("fill");
    var switchyFillColor = $(this).attr(data_switchy);
    if(typeof (switchyFillColor) === "undefined"){
         switchyFillColor = $(this).attr(data_switchy.toLowerCase());
    }
    if(typeof (switchyFillColor) !== "undefined"){
        if(fillColor == "#f5d76e"){
          $(this).css("fill", switchyFillColor);
          $(this).attr("fill", switchyFillColor)
          $(this).attr("data-switchy", data_switchy);
        }
    }
  
  });
  }
  $(logoLayerClass).each(function() {
    var subThisObj = $(this);
    var defaultSvgColors = subThisObj.attr("default-svg-colors");
    var fillPrefix = defaultSvgColors ? defaultSvgColors.substring(0, 3) : ''; 
    var threadTitle = subThisObj.attr("logo-thread-title");
    var threadCode = subThisObj.attr("logo-thread-code");
    var newColor = subThisObj.val();
    thisObj.find("[fill^='" + fillPrefix + "']").each(function() {
      var $this = $(this);
      var default_svg_colors = $this.attr("default-svg-colors");
      var data_switchy = $this.attr("data-switchy");
      if(typeof (default_svg_colors) === "undefined" && typeof (data_switchy) === "undefined"){
        $this.attr("default-svg-colors", $this.attr('fill'));
        $this.css("fill", newColor);
        $this.attr("fill", newColor);
        $this.attr("logo-thread-title", threadTitle);
        $this.attr("logo-thread-code", threadCode);
      }
    });
  });
}

function loadSVG(canvas_id, logo_input_svg_element, suffix_id = '', location_suffix_id = '') {
  var product_main_logo_viewing = $("#product_main_logo_viewing").val();
  var product_main_logo_resize = $("#product_main_logo_resize").val();
  var product_main_logo_canvas_where = $("#product_main_logo_canvas_where").val();
  var data_product_img_url = $(".canvas-container-main_" + suffix_id).attr("data-product-img-url");
  var svg_logo_x_code = parseInt($("#" + canvas_id).attr("data-x"));
  var svg_logo_y_code = parseInt($("#" + canvas_id).attr("data-y"));

  var svg_logo_width_code = svg_logo_width_code_resize = $("#" + canvas_id).attr("data-width");
  var svg_logo_height_code = svg_logo_height_code_resize = $("#" + canvas_id).attr("data-height");

  var canvas_x_code = parseInt($("#" + canvas_id).attr("canvas-x"));
  var canvas_y_code = parseInt($("#" + canvas_id).attr("canvas-y"));
  var canvas_width_code = parseInt($("#" + canvas_id).attr("canvas-width"));
  var canvas_height_code = parseInt($("#" + canvas_id).attr("canvas-height"));
  
  if(product_main_logo_viewing == "Logo Mockup"){
    data_product_img_url = $(".product__media__wrapper").find(".custom-product-slideshow").find(".slick-active").find("image-element").find("image").attr("href");
    
    var data_product_img_ele = $(".product__media__wrapper").find(".custom-product-slideshow").find(".slick-active").find("image-element").find(".logo-image-svg");
    svg_logo_x_code = parseInt(data_product_img_ele.attr("x"));
    svg_logo_y_code = parseInt(data_product_img_ele.attr("y"));
    svg_logo_width_code = parseInt(data_product_img_ele.attr("width"));
    svg_logo_height_code = parseInt(data_product_img_ele.attr("height"));

    svg_logo_width_code_resize = parseInt(data_product_img_ele.attr("width"));
    svg_logo_height_code_resize = parseInt(data_product_img_ele.attr("height"));

    canvas_x_code = parseInt(data_product_img_ele.attr("x"));
    canvas_y_code = parseInt(data_product_img_ele.attr("y"));
    canvas_width_code = parseInt(data_product_img_ele.attr("width"));
    canvas_height_code = parseInt(data_product_img_ele.attr("height"));
  } 

  if (!data_product_img_url || data_product_img_url === "undefined") {
      console.warn("Image URL not found");
      return;
  }
  

  var logo_input_svg_element_replce = logo_input_svg_element.html();
  if (!$(logo_input_svg_element_replce).is('svg') || product_main_logo_viewing == "Logo Mockup") {
    var is_personalize = true;
    // var p_canvas_x_code = parseInt($("#" + canvas_id).attr("p-canvas-x")); 
    // if(!isNaN(p_canvas_x_code)){ 
    //   var canvas_x_code = parseInt($("#" + canvas_id).attr("p-canvas-x"));
    //   var canvas_y_code = parseInt($("#" + canvas_id).attr("p-canvas-y"));
    //   var canvas_width_code = parseInt($("#" + canvas_id).attr("p-canvas-width"));
    //   var canvas_height_code = parseInt($("#" + canvas_id).attr("p-canvas-height"));
    // } 
    var p_canvas_x_code = parseInt($("#" + canvas_id).attr("p-canvas-x"));
    var p_canvas_y_code = parseInt($("#" + canvas_id).attr("p-canvas-y"));
    var p_canvas_width_code = parseInt($("#" + canvas_id).attr("p-canvas-width"));
    var p_canvas_height_code = parseInt($("#" + canvas_id).attr("p-canvas-height"));
    if (!$(logo_input_svg_element).is('svg')) {
      // canvas_x_code = parseInt($("#" + canvas_id).attr("p-canvas-x"));
      // canvas_y_code = parseInt($("#" + canvas_id).attr("p-canvas-y"));
      // canvas_width_code = parseInt($("#" + canvas_id).attr("p-canvas-width"));
      // canvas_height_code = parseInt($("#" + canvas_id).attr("p-canvas-height"));

      if(!isNaN(p_canvas_x_code) && p_canvas_x_code!=0){
        canvas_x_code = p_canvas_x_code;
      }
      if(!isNaN(p_canvas_y_code) && p_canvas_y_code!=0){
        canvas_y_code = p_canvas_y_code;
      }
      if(!isNaN(p_canvas_width_code) && p_canvas_width_code!=0){
        canvas_width_code = p_canvas_width_code;
      }
      if(!isNaN(p_canvas_height_code) && p_canvas_height_code!=0){
        canvas_height_code = p_canvas_height_code;
      }
    }

  }  
  
  var logoSvgElement = $($.parseHTML(logo_input_svg_element_replce)).filter("svg");
  // var svg_hoop =  parseInt($("#" + canvas_id).attr("data-hooper"));
  // var svg_hoop =  parseInt(logo_input_svg_element.attr("data-hooper"));
  // var svg_ratio =  parseInt(logoSvgElement.attr('ratio'));
  var svg_hoop = parseFloat($("#" + canvas_id).attr("data-hooper") || '');
  var svg_ratio = parseFloat(logoSvgElement.attr('ratio') || '');
  
  // svg_ratio = 2;
  if (!isNaN(svg_hoop) && svg_hoop > 0 && !isNaN(svg_ratio) && svg_ratio > 0) {
    logo_input_svg_element_replce = logo_input_svg_element_replce.replace('width="100"', 'width="' + svg_logo_width_code + '"');
    logo_input_svg_element_replce = logo_input_svg_element_replce.replace('height="100"', 'height="' + svg_logo_height_code + '"');
    
    var multiplayer = svg_ratio/svg_hoop;  
    
    if(multiplayer < 1){ 
      // var parsed = $($.parseHTML(logo_input_svg_element_replce));
      // var originalSvg = parsed.filter("svg");
      // var innerSvg = originalSvg[0];
      // const innerViewBox = $(innerSvg).attr('viewBox');
      // const viewBoxWidth = innerViewBox ? parseFloat(innerViewBox.split(' ')[2]) : 1024;
      // const viewBoxHeight = innerViewBox ? parseFloat(innerViewBox.split(' ')[3]) : 1024;
      
      // var cal_svg_logo_width_code = viewBoxWidth * multiplayer;
      // var cal_svg_logo_height_code = viewBoxHeight * multiplayer;
      // var cal_svg_logo_x_code = (viewBoxWidth - cal_svg_logo_width_code) / 2;
      // var cal_svg_logo_y_code = (viewBoxHeight - cal_svg_logo_height_code) / 2;
      // var outerSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      // Array.from(innerSvg.attributes).forEach(attr => {
      //   outerSvg.setAttribute(attr.name, attr.value);
      // });
      // innerSvg.setAttribute("width", parseInt(cal_svg_logo_width_code));
      // innerSvg.setAttribute("height", parseInt(cal_svg_logo_height_code));
      // innerSvg.setAttribute("x", parseInt(cal_svg_logo_x_code));
      // innerSvg.setAttribute("y", parseInt(cal_svg_logo_y_code));
 
      // var innerSvgClone = innerSvg.cloneNode(true);
      // outerSvg.appendChild(innerSvgClone);
      // var serializerSvg = outerSvg; 

      // var serializer = new XMLSerializer();
      // var logo_input_svg_element_replce = serializer.serializeToString(serializerSvg);

      svg_logo_width_code = svg_logo_width_code * multiplayer;
      svg_logo_height_code = svg_logo_height_code * multiplayer;
      svg_logo_x_code = (svg_logo_x_code + ((svg_logo_width_code_resize - svg_logo_width_code) / 2 ));
      svg_logo_y_code = (svg_logo_y_code + ((svg_logo_height_code_resize - svg_logo_height_code) / 2 ));
    } 
  }else{
    logo_input_svg_element_replce = logo_input_svg_element_replce.replace('width="100"', 'width="' + svg_logo_width_code + '"');
    logo_input_svg_element_replce = logo_input_svg_element_replce.replace('height="100"', 'height="' + svg_logo_height_code + '"');
  }

  let newCanvasId = 'canvas' + canvas_id;
  
  var canvasElement = document.getElementById(canvas_id);
  if (!canvasElement || canvasElement.nodeName !== 'CANVAS') {
    console.error("Invalid canvas element:", canvasElement);
    return;
  }
  
  if (canvases[newCanvasId] instanceof fabric.Canvas) {
    canvases[newCanvasId].dispose();
  }
    
  canvases[newCanvasId] = new fabric.Canvas(canvas_id, {
    width: 2048,
    height: 2048,
    selection: true,
    preserveObjectStacking: true,
  });
  canvases[newCanvasId].clear();

  var canvas = canvases[newCanvasId]; 
  fabric.Image.fromURL(data_product_img_url, (img) => {
    if (!canvas || !canvas.contextContainer) {
      console.warn('Canvas is not ready yet.');
      return;
    }
    
    const scale = Math.min(canvas.width / img.width, canvas.height / img.height);

    img.set({
      scaleX: scale,
      scaleY: scale,
      left: 0,
      top: 0,
      selectable: false,
    });

    canvas.add(img);
    canvas.renderAll();
  
    var containerWidth = $("#meta_logo_custom_index_section_"+location_suffix_id).find(".custom__item-inner").width();
    var containerHeight = $("#meta_logo_custom_index_section_"+location_suffix_id).find(".custom__item-inner").height();
    if(containerWidth!="" && typeof(containerWidth) == "undefined"){
       var containerWidth =  ($(".product__media__wrapper").find(".custom-product-slideshow").find(".slick-active").width()*70)/100; 
      // var containerWidth = 500; 
    }
    if(containerHeight!="" && typeof(containerHeight) == "undefined"){
      var containerHeight =  ($(".product__media__wrapper").find(".custom-product-slideshow").find(".slick-active").height()*70)/100; 
      // var containerHeight = 500; 
    } 
    
    $(".canvas-container-main-data").css("width", containerWidth + "px");
    $(".canvas-container-main-data").css("height", containerHeight + "px");
    var isMobile = /iPhone|iPod|iPad|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
               window.matchMedia("only screen and (max-width: 767px)").matches;

    if(isMobile){
      var scaleFactorX = (containerWidth-15) / canvas.width;
      var scaleFactorY = (containerHeight-15) / canvas.height;
    }else{
      var scaleFactorX = containerWidth / canvas.width;
      var scaleFactorY = containerHeight / canvas.height;
    }
    

    var zoom = Math.min(scaleFactorX, scaleFactorY);
    zoom = Math.max(zoom, 0.01);
    canvas.setZoom(zoom);
    canvas.centerObject(img);
    canvas.renderAll();

    var borderRect = new fabric.Rect({
      left: canvas_x_code,
      top: canvas_y_code,
      width: canvas_width_code,
      height: canvas_height_code,
      fill: 'transparent',
      stroke: '#fff',
      strokeWidth: 5,
      selectable: false,
      evented: false,
      lockScalingX: true,
      lockScalingY: true,
    });
    canvas.add(borderRect);
    canvas.bringToFront(borderRect);
    canvas.renderAll();

    fabric.Object.prototype.set({
      transparentCorners: false,
      cornerColor: 'rgba(102,153,255,0.5)',
      cornerSize: 8,
      padding: 2,
      objectCaching: false
    });
   
    fabric.loadSVGFromString(logo_input_svg_element_replce, function (objects, options) {
      if (!objects || objects.length === 0) {
        console.error("SVG string did not yield any Fabric objects");
        return;
      }
      if (!logo_input_svg_element_replce.includes('viewBox')) {
        var width = svg_logo_width_code;
        var height = svg_logo_height_code;
        logo_input_svg_element_replce = logo_input_svg_element_replce.replace('<svg', '<svg viewBox="0 0 ' + width + ' ' + height + '"');
      }

      if (!logo_input_svg_element_replce.includes('preserveAspectRatio')) {
        logo_input_svg_element_replce = logo_input_svg_element_replce.replace('<svg', '<svg preserveAspectRatio="xMidYMid meet"');
      }
      var isEditTrigger = false;
      var rotate_angle = 0;
      var logo_edit_coordinates = $("#_logo_edit_"+location_suffix_id+"_coordinates").val(); 
      var logo_edit_code = $("#_logo"+location_suffix_id+"_code").val(); 
      var logo_edit_code_suffix_id = ""
      if(logo_edit_code!="" && typeof(logo_edit_code) !== "undefined"){
        var logo_edit_code_suffix_id = location_suffix_id+"_"+logo_edit_code.split('.')[1]; 
      }
      if(logo_edit_coordinates!="" && typeof(logo_edit_coordinates) !== "undefined" && suffix_id == logo_edit_code_suffix_id){
        var l_coordinates = logo_edit_coordinates.split('_');  
        svg_logo_x_code = parseFloat(l_coordinates[0]);
        svg_logo_y_code = parseFloat(l_coordinates[1]);
        svg_logo_width_code = parseFloat(l_coordinates[2]);
        svg_logo_height_code = parseFloat(l_coordinates[3]);
        $("#_logo_edit_"+location_suffix_id+"_coordinates").val(""); 
        var logo_edit_rotate_angle = $("#_logo_edit_"+location_suffix_id+"_rotate_angle").val(); 
        if(logo_edit_rotate_angle!="" && typeof(logo_edit_rotate_angle) !== "undefined"){
          rotate_angle = parseFloat(logo_edit_rotate_angle);
        }
        isEditTrigger = true;
      }
      
      var loadedObject = fabric.util.groupSVGElements(objects, options);
      var scaleX = svg_logo_width_code / loadedObject.width;
      var scaleY = svg_logo_height_code / loadedObject.height;
      var ishasControls = true;
      var lockMovement = false;
      if(product_main_logo_viewing == "Logo Mockup"){
          ishasControls = false;
          lockMovement = true;
      }

      if(product_main_logo_viewing == "Logo Location" && product_main_logo_resize == "No"){ 
          ishasControls = false;
      }
      if(product_main_logo_viewing == "Logo Location" && product_main_logo_canvas_where == "No"){ 
          lockMovement = true;
      }
      
      loadedObject.set({
        left: svg_logo_x_code,
        top: svg_logo_y_code,
        scaleX: scaleX,
        scaleY: scaleY,
        angle: rotate_angle,
        hasControls: ishasControls,
        lockMovementX: lockMovement,  // Lock horizontal movement
        lockMovementY: lockMovement,  // Lock vertical movement
        lockScalingX: false,
        lockScalingY: false,
        lockRotation: false,
        lockScalingFlip: ishasControls,
        lockUniScaling: false,
      });
      
      loadedObject.setControlsVisibility({
        mt: false,
        mb: false,
        ml: false,
        mr: false,
        bl: ishasControls,
        br: ishasControls,
        tl: ishasControls,
        tr: ishasControls,
        mtr: ishasControls, // Enable rotation control
      });
      
      loadedObject.controls.mtr.offsetY = -20;
      canvas.add(loadedObject);
      loadedObject.setCoords();
      canvas.setActiveObject(loadedObject);
      canvas.renderAll();
      
      // canvas.on('object:moving', function (e) {
      //   var obj = e.target; 
      //   var rotationAngletmp = obj.angle; 
            
      //   var objActive = canvas.getActiveObject();
      //   var new_width = parseInt(obj.getScaledWidth());
      //   var new_height = parseInt(obj.getScaledHeight());
      //   var imageLeft = loadedObject.left;
      //   var imageTop = loadedObject.top;
      //   const canvasWidth = canvas.width;
      //   const canvasHeight = canvas.height;
      //   var rightGap = canvasWidth - (canvas_x_code + canvas_width_code);
      //   var bottomGap = canvasHeight - (canvas_y_code + canvas_height_code);
        
      //   if (typeof (obj.text) !== "undefined") {
      //     var setActiveObjectData = canvas.getObjects('i-text')[0];
      //     var imageLeft = setActiveObjectData.left;
      //     var imageTop = setActiveObjectData.top;

      //     var leftEdge = imageLeft - new_width / 2;
      //     var topEdge = imageTop - new_height / 2;
      //     var rightEdge = imageLeft + new_width / 2;
      //     var bottomEdge = imageTop + new_height / 2;
      
      //     if (leftEdge < canvas_x_code) {
      //         obj.set({ left: (new_width / 2 + canvas_x_code) + 20 });
      //     }
      
      //     if (topEdge < canvas_y_code) {
      //         obj.set({ top: (new_height / 2 + canvas_y_code) + 20 });
      //     }
      
      //     if (rightEdge > canvasWidth - rightGap) {
      //         obj.set({ left: (canvasWidth - new_width / 2 - rightGap) - 20 });
      //     }
      
      //     if (bottomEdge > canvasHeight - bottomGap) {
      //         obj.set({ top: (canvasHeight - new_height / 2 - bottomGap) - 20 });
      //     }
      //   }else if(rotationAngletmp >= 1){
      //     var br = obj.getBoundingRect(true); // 🔄 rotation-aware bounding box
          
      //     var leftEdge = br.left;
      //     var topEdge = br.top;
      //     var rightEdge = br.left + br.width;
      //     var bottomEdge = br.top + br.height;
        
      //     if (leftEdge < canvas_x_code) {
      //       loadedObject.left += canvas_x_code - leftEdge + 20;
      //     }
      
      //     if (topEdge < canvas_y_code) {
      //       loadedObject.top += canvas_y_code - topEdge + 20;
      //     }
      
      //     if (rightEdge > canvasWidth - rightGap) {
      //       loadedObject.left -= (rightEdge - (canvasWidth - rightGap)) + 20;
      //     }
      
      //     if (bottomEdge > canvasHeight - bottomGap) {
      //       loadedObject.top -= (bottomEdge - (canvasHeight - bottomGap)) + 20;
      //     }
      //     loadedObject.setCoords();
      //   }else{
      //     if (imageLeft < canvas_x_code) {
      //       loadedObject.set({ left: canvas_x_code + 20 });
      //     }
  
      //     if (imageTop < canvas_y_code) {
      //       loadedObject.set({ top: (canvas_y_code) + 20 });
      //     }
  
      //     if (imageLeft + new_width > canvasWidth - rightGap) {
      //       loadedObject.set({ left: canvas.width - new_width - rightGap - 20 });
      //     }
  
      //     if (imageTop + new_height > canvasHeight - bottomGap) {
      //       loadedObject.set({ top: (canvas.height) - new_height - bottomGap - 20 });
      //     }
      //   }
      //   canvas.renderAll();
      // });

      // canvas.on('mouse:up', function () {
      //   const obj = canvas.getActiveObject();
      //   if (!obj) return;
      
      //   const br = obj.getBoundingRect(true);
      
      //   const borderLeft = canvas_x_code;
      //   const borderTop = canvas_y_code;
      //   const borderRight = canvas_x_code + canvas_width_code;
      //   const borderBottom = canvas_y_code + canvas_height_code;
      
      //   let left = obj.left;
      //   let top = obj.top;
      
      //   // Correct position only if outside
      //   if (br.left < borderLeft) {
      //     left += borderLeft - br.left + 20;
      //   }
      //   if (br.top < borderTop) {
      //     top += borderTop - br.top + 20;
      //   }
      //   if (br.left + br.width > borderRight) {
      //     left -= (br.left + br.width - borderRight) + 20;
      //   }
      //   if (br.top + br.height > borderBottom) {
      //     top -= (br.top + br.height - borderBottom) + 20;
      //   }
      
      //   obj.set({ left, top });
      //   obj.setCoords();
      //   canvas.renderAll();
      // });

      // canvas.on('object:scaling', function (e) {
      //   var obj = e.target; 

      //   const scaledFontSize = obj.fontSize * obj.scaleY;
      //   const decimal = scaledFontSize % 1; // Get decimal part

      //   let finalFontSize;
      //   if (decimal <= 0.25) {
      //     finalFontSize = Math.floor(scaledFontSize);
      //   } else {
      //     finalFontSize = Math.ceil(scaledFontSize);
      //   }
        
      //   $('#_personalization_'+ location_suffix_id +'_font_size').val(finalFontSize);
        
      //   var new_width = parseInt(obj.getScaledWidth());
      //   var new_height = parseInt(obj.getScaledHeight());
      //   var object_x = parseInt(obj.left);
      //   var object_y = parseInt(obj.top); 
      //   if (obj === borderRect) {
      //     return;
      //   } 
      //   var brNew = obj.getBoundingRect();
         
      //   if (object_x < canvas_x_code) {
      //     obj.set({left: canvas_x_code + 20});
      //   }
      //   if (object_y < canvas_y_code) {
      //     obj.set({top: canvas_y_code + 20});
      //   }
      //   if (brNew.left + brNew.width > canvas_x_code + canvas_width_code) {
      //     obj.set({left: canvas_x_code + canvas_width_code - brNew.width - 20});
      //   }
      //   if (brNew.top + brNew.height > canvas_y_code + canvas_height_code) {
      //     obj.set({top: canvas_y_code + canvas_height_code - brNew.height - 20});
      //   }
        
      //   if (new_width < 20) new_width = 20;
      //   if (new_height < 20) new_height = 20;
     
      //   var scaleXFactor = new_width / obj.width;
      //   var scaleYFactor = new_height / obj.height;
     
      //   if (new_width > (canvas_width_code - 20)) {
      //     scaleXFactor = (canvas_width_code - 20) / new_width;
      //     scaleYFactor = (canvas_width_code - 20) / new_width;
      //   }
     
      //   if (new_height > (canvas_height_code - 20)) {
      //     scaleXFactor = (canvas_height_code - 20) / new_height;
      //     scaleYFactor = (canvas_height_code - 20) / new_height;
      //   }
     
      //   obj.set({ scaleX: scaleXFactor, scaleY: scaleYFactor });
     
      //   if (obj.left + obj.getScaledWidth() > canvas_x_code + canvas_width_code) {
      //       obj.set({ left: canvas_x_code + canvas_width_code - obj.getScaledWidth() - 20 });
      //   }
    
      //   if (obj.top + obj.getScaledHeight() > canvas_y_code + canvas_height_code) {
      //       obj.set({ top: canvas_y_code + canvas_height_code - obj.getScaledHeight() - 20 });
      //   } 
      //   obj.setCoords();
      //   canvas.renderAll();
      // });

      if(isEditTrigger || (!isNaN(svg_hoop) && svg_hoop > 0 && !isNaN(svg_ratio) && svg_ratio > 0)){ 
        canvas.fire('object:modified', {
            target: loadedObject
        });
      }

    });
  });
  
  canvas.on('object:moving', function (e) {
    var obj = e.target; 
    var rotationAngletmp = obj.angle; 
        
    var objActive = canvas.getActiveObject();
    var new_width = parseInt(obj.getScaledWidth());
    var new_height = parseInt(obj.getScaledHeight());
    var imageLeft = obj.left;
    var imageTop = obj.top;
    var canvasWidth = canvas.width;
    var canvasHeight = canvas.height;
    if (typeof (obj.text) !== "undefined") {
      var p_canvas_x_code = parseInt($("#" + canvas_id).attr("p-canvas-x"));
      var p_canvas_y_code = parseInt($("#" + canvas_id).attr("p-canvas-y"));
      var p_canvas_width_code = parseInt($("#" + canvas_id).attr("p-canvas-width"));
      var p_canvas_height_code = parseInt($("#" + canvas_id).attr("p-canvas-height"));
      if(!isNaN(p_canvas_x_code) && p_canvas_x_code!=0){
        canvas_x_code = p_canvas_x_code;
      }
      if(!isNaN(p_canvas_y_code) && p_canvas_y_code!=0){
        canvas_y_code = p_canvas_y_code;
      }
      if(!isNaN(p_canvas_width_code) && p_canvas_width_code!=0){
        canvas_width_code = p_canvas_width_code;
      }
      if(!isNaN(p_canvas_height_code) && p_canvas_height_code!=0){
        canvas_height_code = p_canvas_height_code;
      }
    }

    var rightGap = canvasWidth - (canvas_x_code + canvas_width_code);
    var bottomGap = canvasHeight - (canvas_y_code + canvas_height_code);
    
    if (typeof (obj.text) !== "undefined") {
      var setActiveObjectData = canvas.getObjects('i-text')[0];
      var imageLeft = setActiveObjectData.left;
      var imageTop = setActiveObjectData.top;

      var leftEdge = imageLeft - new_width / 2;
      var topEdge = imageTop - new_height / 2;
      var rightEdge = imageLeft + new_width / 2;
      var bottomEdge = imageTop + new_height / 2;
  
      if (leftEdge < canvas_x_code) {
          obj.set({ left: (new_width / 2 + canvas_x_code) + 20 });
      }
  
      if (topEdge < canvas_y_code) {
          obj.set({ top: (new_height / 2 + canvas_y_code) + 20 });
      }
  
      if (rightEdge > canvasWidth - rightGap) {
          obj.set({ left: (canvasWidth - new_width / 2 - rightGap) - 20 });
      }
  
      if (bottomEdge > canvasHeight - bottomGap) {
          obj.set({ top: (canvasHeight - new_height / 2 - bottomGap) - 20 });
      }
    }else if(rotationAngletmp >= 1){
      var br = obj.getBoundingRect(true); // 🔄 rotation-aware bounding box
      
      var leftEdge = br.left;
      var topEdge = br.top;
      var rightEdge = br.left + br.width;
      var bottomEdge = br.top + br.height;
    
      if (leftEdge < canvas_x_code) {
        obj.left += canvas_x_code - leftEdge + 20;
      }
  
      if (topEdge < canvas_y_code) {
        obj.top += canvas_y_code - topEdge + 20;
      }
  
      if (rightEdge > canvasWidth - rightGap) {
        obj.left -= (rightEdge - (canvasWidth - rightGap)) + 20;
      }
  
      if (bottomEdge > canvasHeight - bottomGap) {
        obj.top -= (bottomEdge - (canvasHeight - bottomGap)) + 20;
      }
      obj.setCoords();
    }else{
      if (imageLeft < canvas_x_code) {
        obj.set({ left: canvas_x_code + 20 });
      }

      if (imageTop < canvas_y_code) {
        obj.set({ top: (canvas_y_code) + 20 });
      }

      if (imageLeft + new_width > canvasWidth - rightGap) {
        obj.set({ left: canvas.width - new_width - rightGap - 20 });
      }

      if (imageTop + new_height > canvasHeight - bottomGap) {
        obj.set({ top: (canvas.height) - new_height - bottomGap - 20 });
      }
    }
    canvas.renderAll();
  });

  canvas.on('mouse:up', function () {
    const obj = canvas.getActiveObject();
    if (!obj) return;
  
    const br = obj.getBoundingRect(true);
  
    const borderLeft = canvas_x_code;
    const borderTop = canvas_y_code;
    const borderRight = canvas_x_code + canvas_width_code;
    const borderBottom = canvas_y_code + canvas_height_code;
  
    let left = obj.left;
    let top = obj.top;
  
    // Correct position only if outside
    if (br.left < borderLeft) {
      left += borderLeft - br.left + 20;
    }
    if (br.top < borderTop) {
      top += borderTop - br.top + 20;
    }
    if (br.left + br.width > borderRight) {
      left -= (br.left + br.width - borderRight) + 20;
    }
    if (br.top + br.height > borderBottom) {
      top -= (br.top + br.height - borderBottom) + 20;
    }
  
    obj.set({ left, top });
    obj.setCoords();
    canvas.renderAll();
  });

  canvas.on('object:scaling', function (e) {
    var obj = e.target; 

    var borderRectTmp = obj.getObjects().find(o => o.id === 'borderRect');
    const scaledFontSize = obj.fontSize * obj.scaleY;
    const decimal = scaledFontSize % 1; // Get decimal part

    let finalFontSize;
    if (decimal <= 0.25) {
      finalFontSize = Math.floor(scaledFontSize);
    } else {
      finalFontSize = Math.ceil(scaledFontSize);
    }
    
    $('#_personalization_'+ location_suffix_id +'_font_size').val(finalFontSize);
    
    var new_width = parseInt(obj.getScaledWidth());
    var new_height = parseInt(obj.getScaledHeight());
    var object_x = parseInt(obj.left);
    var object_y = parseInt(obj.top); 
    if (obj === borderRectTmp) {
      return;
    } 
    var brNew = obj.getBoundingRect();
     
    if (object_x < canvas_x_code) {
      obj.set({left: canvas_x_code + 20});
    }
    if (object_y < canvas_y_code) {
      obj.set({top: canvas_y_code + 20});
    }
    if (brNew.left + brNew.width > canvas_x_code + canvas_width_code) {
      obj.set({left: canvas_x_code + canvas_width_code - brNew.width - 20});
    }
    if (brNew.top + brNew.height > canvas_y_code + canvas_height_code) {
      obj.set({top: canvas_y_code + canvas_height_code - brNew.height - 20});
    }
    
    if (new_width < 20) new_width = 20;
    if (new_height < 20) new_height = 20;
 
    var scaleXFactor = new_width / obj.width;
    var scaleYFactor = new_height / obj.height;
 
    if (new_width > (canvas_width_code - 20)) {
      scaleXFactor = (canvas_width_code - 20) / new_width;
      scaleYFactor = (canvas_width_code - 20) / new_width;
    }
 
    if (new_height > (canvas_height_code - 20)) {
      scaleXFactor = (canvas_height_code - 20) / new_height;
      scaleYFactor = (canvas_height_code - 20) / new_height;
    }
 
    obj.set({ scaleX: scaleXFactor, scaleY: scaleYFactor });
 
    if (obj.left + obj.getScaledWidth() > canvas_x_code + canvas_width_code) {
        obj.set({ left: canvas_x_code + canvas_width_code - obj.getScaledWidth() - 20 });
    }

    if (obj.top + obj.getScaledHeight() > canvas_y_code + canvas_height_code) {
        obj.set({ top: canvas_y_code + canvas_height_code - obj.getScaledHeight() - 20 });
    } 
    obj.setCoords();
    canvas.renderAll();
  });
  
  $('#_logo_' + location_suffix_id + '_coordinates').val(svg_logo_x_code + "_" + svg_logo_y_code + "_" + svg_logo_width_code + "_" + svg_logo_height_code);

  canvas.on('object:modified', function (e) {
    var obj = e.target;
    var objActive = canvas.getActiveObject();
    var object_x = parseInt(obj.left);
    var object_y = parseInt(obj.top);
    var old_width = parseInt(obj.width);
    var old_height = parseInt(obj.height);
    // console.log(old_width);
    // console.log(old_height);
    var new_width = parseInt(obj.getScaledWidth());
    var new_height = parseInt(obj.getScaledHeight());
    var currentRotation = obj.get('angle');
    var product_main_logo_viewing = $("#product_main_logo_viewing").val();

    if ($(".svg_to_base64_zoom").length > 0) {
      $(".svg_to_base64_zoom").each(function(index) {
          $(this).remove();
      });
    }

    if (typeof (obj.text) !== "undefined") {
      const textArr = obj.text.split("\n");
      var fontSize = parseInt(obj.fontSize);
      const lineHeight = fontSize * 1.2;
      const scaleX = obj.scaleX || 1;
      const scaleY = obj.scaleY || 1;
    
      const new_width = obj.getScaledWidth();
      const new_height = obj.getScaledHeight();
    
      let object_x = obj.left;
      let object_y = obj.top;
      const scaledFontSize = obj.fontSize * obj.scaleY;
      const decimal = scaledFontSize % 1; // Get decimal part

  
      if (decimal <= 0.25) {
        fontSize = Math.floor(scaledFontSize);
      } else {
        fontSize = Math.ceil(scaledFontSize);
      }
      // Adjust x/y based on originX and originY
      if (obj.originX === 'center') object_x -= new_width / 2;
      else if (obj.originX === 'right') object_x -= new_width;
    
      if (obj.originY === 'center') object_y -= new_height / 2;
      else if (obj.originY === 'bottom') object_y -= new_height;
      
        
      $("#_personalization_" + location_suffix_id + "_coordinates").val(object_x + "_" + object_y + "_" + new_width + "_" + new_height);
  
      $("#logo_customization_view_" + suffix_id).find(".logo-image-svg-text").find('text').attr({ "x": object_x, "y": object_y });
      if(product_main_logo_viewing == "Logo Mockup"){  
        $(".product__media__wrapper").find(".product__main-photos_custom").find(".logo-image-svg-text").find('text').attr({ "x": object_x, "y": object_y });
      }else{
        $(".product__main-photos_" + location_suffix_id).find(".logo-image-svg-text").find('text').attr({ "x": object_x, "y": object_y });
      }

      // Rotation center
      const center_x = obj.left;
      const center_y = obj.top;
    
      // Begin generating <tspan> lines
      let newTextHtml = "";
      let currentY = object_y + fontSize;
    
      textArr.forEach((line, i) => {
        const mtextW = (obj.__lineWidths?.[i] || 0) * scaleX;
        let mtextX = object_x;
    
        if (obj.textAlign === 'center') {
          mtextX = object_x + (new_width - mtextW) / 2;
        } else if (obj.textAlign === 'right') {
          mtextX = object_x + (new_width - mtextW);
        }
    
        newTextHtml += `<tspan x="${mtextX}" y="${currentY}" textLength="${mtextW}">${line}</tspan>`;
        currentY += lineHeight;
      });
    
      const finalTextHtml = `<text
        x="${object_x}"
        y="${object_y}"
        width="${new_width}"
        height="${new_height}"
        font-family="${obj.fontFamily}"
        font-size="${fontSize}px"
        fill="${obj.fill}"
        transform="rotate(${currentRotation} ${center_x} ${center_y})"
        style="font-size:${fontSize}px; font-family:${obj.fontFamily}; color:${obj.fill};">
        ${newTextHtml}
      </text>`;
      
      $("#logo_customization_view_" + suffix_id).find(".logo-image-svg-text").each(function () {
        $(this).html(finalTextHtml);
      });

      if(product_main_logo_viewing == "Logo Mockup"){  
        $(".product__media__wrapper").find(".product__main-photos_custom").find(".logo-image-svg-text").each(function () {
          $(this).html(finalTextHtml);
        });
      }else{ 
        $(".product__main-photos_" + location_suffix_id).find(".logo-image-svg-text").each(function () {
          $(this).html(finalTextHtml);
        });
      }
      
      // if (obj.originX === 'center' && obj.originY === 'center') {
      //     object_x -= new_width / 2;
      //     object_y += new_height / 2
      // }
        
      // $("#_personalization_" + location_suffix_id + "_coordinates").val(object_x + "_" + object_y + "_" + new_width + "_" + new_height);

      // $("#logo_customization_view_" + suffix_id).find(".logo-image-svg-text").find('text').attr({ "x": object_x, "y": object_y });
      // if(product_main_logo_viewing == "Logo Mockup"){  
      //   $(".product__media__wrapper").find(".product__main-photos_custom").find(".logo-image-svg-text").find('text').attr({ "x": object_x, "y": object_y });
      // }else{
      //   $(".product__main-photos_" + location_suffix_id).find(".logo-image-svg-text").find('text').attr({ "x": object_x, "y": object_y });
      // }

      // if ($("#logo_customization_view_" + suffix_id).find(".logo-image-svg-text").find('text').find('tspan').length == 1) {
      //   $("#logo_customization_view_" + suffix_id).find(".logo-image-svg-text").find('text').find('tspan').attr({ "x": object_x, "y": object_y });
         
      //   if(product_main_logo_viewing == "Logo Mockup"){ 
      //      $(".product__media__wrapper").find(".product__main-photos_custom").each(function(index) {
      //         $(this).find(".logo-image-svg-text").find('text').find('tspan').attr({ "x": object_x, "y": object_y });
      //     });
      //   }else{
      //    $(".product__main-photos_" + location_suffix_id).find(".logo-image-svg-text").find('text').find('tspan').attr({ "x": object_x, "y": object_y });
      //   } 
            
      // } else if ($("#logo_customization_view_" + suffix_id).find(".logo-image-svg-text").find('text').find('tspan').length > 1) {         
      //   var textArr = obj.text.split("\n"); 
      //   var svg_text_html = '';
      //   var textW = parseInt(obj.width);
      //   var textH = parseInt(obj.height);
      //   var textX = parseInt(obj.left);
      //   var textY = parseInt(obj.top); 
      //   if (obj.originX === 'center') {
      //       textX -= textW / 2;
      //   } else if (obj.originX === 'right') {
      //       textX -= textW;
      //   }
    
      //   var lineHeight = parseInt(obj.fontSize) * 1.2;
      //   var textSpanY = textY;
      //   var newTextHtml = "";
      //   $.each(textArr, function(key, value) {
      //       var mtextW = parseInt(obj.__lineWidths[key]); 
      //       var mtextX = obj.left;
      //       if (obj.originX === 'center') {
      //           mtextX -= mtextW / 2;
      //       } else if (obj.originX === 'right') {
      //           mtextX -= mtextW;
      //       }
      //       newTextHtml += `<tspan y="${textSpanY}" x="${mtextX}" textLength="${mtextW}">${value}</tspan>`;  
      //       textSpanY += lineHeight;
      //   });

      //   $("#logo_customization_view_" + suffix_id).find(".logo-image-svg-text").each(function () {
      //     $(this).find('text').html(newTextHtml);
      //   });
            

      //   if(product_main_logo_viewing == "Logo Mockup"){  
      //     $(".product__media__wrapper").find(".product__main-photos_custom").find(".logo-image-svg-text").each(function () {
      //       $(this).find('text').html(newTextHtml);
      //     });
      //   }else{ 
      //     $(".product__main-photos_" + location_suffix_id).find(".logo-image-svg-text").each(function () {
      //       $(this).find('text').html(newTextHtml);
      //     });
      //   }
      // }

    } else {

      if (!isNaN(svg_hoop) && svg_hoop > 0 && !isNaN(svg_ratio) && svg_ratio > 0) {
        var multiplayer = svg_ratio/svg_hoop;  

        if(multiplayer < 1){  
          // new_width =  parseInt(old_width*multiplayer);
          // new_height =  parseInt(old_height*multiplayer);
          // object_x = parseInt(object_x + ((old_width-new_width)/2));
          // object_y = parseInt(object_y + ((old_height-new_height)/2));    
        }
      }

      var currentRotationVal = currentRotation.toFixed(2);
      if (currentRotationVal > 0) {
        $(".product__main-photos_" + location_suffix_id).find(".logo-image-svg").attr({
          "transform": "rotate(" + currentRotationVal + ", " + object_x + ", " + object_y + ")"
        });
        $('#_logo_' + location_suffix_id + '_rotate_angle').val(currentRotationVal);
      }

      $('#_logo_' + location_suffix_id + '_coordinates').val(object_x + "_" + object_y + "_" + new_width + "_" + new_height);
      $("#logo_customization_view_" + suffix_id).attr({
        "data-width": new_width,
        "data-height": new_height,
        "data-x": object_x,
        "data-y": object_y,
        "data-rotate-angle": currentRotationVal
      });

      if(product_main_logo_viewing == "Logo Mockup"){  
        $(".product__media__wrapper").find(".product__main-photos_custom").find(".logo-image-svg").each(function () {
          $(this).find('svg').attr({
            "width": new_width,
            "height": new_height,
            "x": object_x,
            "y": object_y,
            "rotate_angle": currentRotationVal
          });
        });
      }else{
        $(".product__main-photos_" + location_suffix_id).find(".logo-image-svg").find('svg').attr({
          "width": new_width,
          "height": new_height,
          "x": object_x,
          "y": object_y,
          "rotate_angle": currentRotationVal
        });
      }
    }
  });

}

$(document).on("change", ".resize_font", function(event) {
  var location_suffix_id = $(this).attr("data-location-suffix");
  var suffix_id = $(this).attr("data-suffix");
  var data_variant_id = $(this).attr("data-variant-logo");
  var canvas_id = 'logo-image-svg-canvas-' + suffix_id + "-" + data_variant_id;
  var fontresize = $(this).val();
  var textCanvas = canvases["canvas" + canvas_id];
  var currentText = textCanvas.getObjects('i-text')[0];

  if (currentText) {
    if ($(this).prop('checked')) {
      var resize_enable = true;
     // $('#input_personalize_font_size_'+suffix_id).attr('disabled',true);
    }else{
      var resize_enable = false;
     // $('#input_personalize_font_size_'+suffix_id).removeAttr('disabled');
      const $select = $('#input_personalize_font_size_' + suffix_id);
      $select.prop('selectedIndex', 0);
      $select.trigger('change');
    }
    currentText.set({
      editable: false,
      lockUniScaling: true
    });
    currentText.setControlsVisibility({
      mt: false,
      mb: false,
      ml: false,
      mr: false,
      bl: resize_enable,
      br: resize_enable,
      tl: resize_enable,
      tr: resize_enable,
      mtr: true, // Enable rotation control
    });
    textCanvas.renderAll();
  }
});
$(document).on("keyup", ".input-personalize-text", function(event) {
  var location_suffix_id = $(this).attr("data-location-suffix");
  var suffix_id = $(this).attr("data-suffix");
  var data_variant_id = $(this).attr("data-variant-logo");
  var canvas_id = 'logo-image-svg-canvas-' + suffix_id + "-" + data_variant_id;
  var fontFamily = $("#input_personalize_font_" + suffix_id).val();
  var fontPosition = $("#input_personalize_font_position_" + suffix_id).val();
  var fontSize = $("#input_personalize_font_size_" + suffix_id).val();
  var svg_logo_x_code = parseInt($("#" + canvas_id).attr("data-x"));
  var svg_logo_y_code = parseInt($("#" + canvas_id).attr("data-y"));
  var svg_logo_width_code = parseInt($("#" + canvas_id).attr("data-width"));
  var svg_logo_height_code = parseInt($("#" + canvas_id).attr("data-height"));
  var product_main_logo_viewing = $("#product_main_logo_viewing").val();
  var canvas_x_code = parseInt($("#" + canvas_id).attr("canvas-x"));
  var canvas_y_code = parseInt($("#" + canvas_id).attr("canvas-y"));
  var canvas_width_code = parseInt($("#" + canvas_id).attr("canvas-width"));
  var canvas_height_code = parseInt($("#" + canvas_id).attr("canvas-height"));

  var p_canvas_x_code = parseInt($("#" + canvas_id).attr("p-canvas-x"));
  var p_canvas_y_code = parseInt($("#" + canvas_id).attr("p-canvas-y"));
  var p_canvas_width_code = parseInt($("#" + canvas_id).attr("p-canvas-width"));
  var p_canvas_height_code = parseInt($("#" + canvas_id).attr("p-canvas-height"));
  if (!$(logo_input_svg_element).is('svg')) {
    // canvas_x_code = parseInt($("#" + canvas_id).attr("p-canvas-x"));
    // canvas_y_code = parseInt($("#" + canvas_id).attr("p-canvas-y"));
    // canvas_width_code = parseInt($("#" + canvas_id).attr("p-canvas-width"));
    // canvas_height_code = parseInt($("#" + canvas_id).attr("p-canvas-height"));

    if(!isNaN(p_canvas_x_code) && p_canvas_x_code!=0){
      canvas_x_code = p_canvas_x_code;
    }
    if(!isNaN(p_canvas_y_code) && p_canvas_y_code!=0){
      canvas_y_code = p_canvas_y_code;
    }
    if(!isNaN(p_canvas_width_code) && p_canvas_width_code!=0){
      canvas_width_code = p_canvas_width_code;
    }
    if(!isNaN(p_canvas_height_code) && p_canvas_height_code!=0){
      canvas_height_code = p_canvas_height_code;
    }
  }
  console.log(canvas_width_code);
  console.log(canvas_height_code);
  var logo_input_svg_element = $(".logo_inner_input_"+suffix_id).find(".logo-input-svg").html();

  var value = $(this).val();
  var textCanvas = canvases["canvas" + canvas_id];
  var currentText = textCanvas.getObjects('i-text')[0];
   
  if (value !== '') {
    var maxFontSize = fontSize;
    if (currentText) {
      
      currentText.set({
        text: value
      });
      
      while (currentText.fontSize < maxFontSize) {
        currentText.set({ fontSize: fontSize + 1 });
        currentText.setCoords(); 
        if (
          currentText.getScaledWidth() > canvas_width_code ||
          currentText.getScaledHeight() > canvas_height_code
        ) {      
          currentText.set({ fontSize });
          break;
        }
        fontSize++;
      }
      while (
        (currentText.getScaledWidth() > canvas_width_code || currentText.getScaledHeight() > canvas_height_code) &&
        fontSize > 5
      ) {
        fontSize--;
        currentText.set({ fontSize });
        currentText.setCoords();
      }
      textCanvas.renderAll();

      $("#_personalization_" + location_suffix_id + "_text").val(value);
      $("#_personalization_" + location_suffix_id + "_coordinates").val(currentText.left + "_" + currentText.top + "_" + parseInt(currentText.width) + "_" + parseInt(+currentText.height));
      personalizationTextCanvas(currentText, suffix_id, location_suffix_id);
    } else {
      var fontFamilyInput = fontFamily;
      fontFamily = {
        'serif': 'SerifFont',
        'athletic': 'AthleticFont',
        'script': 'ScriptFont',
        'brush': 'BrushFont',
        'block': 'BlockFont'
      }[fontFamily] || fontFamily;
       
      var IText_x_code = canvas_x_code + (canvas_width_code/2);
      var IText_y_code = canvas_y_code + (canvas_height_code/2);
      var personalization_edit_coordinates = $("#_personalization_edit_"+location_suffix_id+"_coordinates").val(); 
      if(personalization_edit_coordinates!="" && typeof(personalization_edit_coordinates) !== "undefined"){
        var p_coordinates = personalization_edit_coordinates.split('_');  
        IText_x_code = parseFloat(p_coordinates[0]) + (parseFloat(p_coordinates[2])/2);
        IText_y_code = parseFloat(p_coordinates[1]) - (parseFloat(p_coordinates[3])/2);
        $("#_personalization_edit_"+location_suffix_id+"_coordinates").val(""); 
      }
      var textFillColor = '#fff';
      var color_hex_code_only = '';
      var personalization_edit_thread_colors = $("#_personalization_edit_"+location_suffix_id+"_thread_colors").val(); 
      if(personalization_edit_thread_colors!="" && typeof(personalization_edit_thread_colors) !== "undefined"){
        textFillColor = personalization_edit_thread_colors; 
        color_hex_code_only = personalization_edit_thread_colors.replace("#",'');
         $("#_personalization_edit_"+location_suffix_id+"_thread_colors").val(""); 
      }
      var rotate_angle = 0;
      var newText = new fabric.IText(value, {
        left: IText_x_code,
        top: IText_y_code,
        fontFamily: fontFamily,
        fontSize: fontSize,
        textAlign: fontPosition,
        originX: fontPosition,
        originY: 'center',
        splitByGrapheme: true, 
        fill: textFillColor,
        angle: rotate_angle,
        lockUniScaling: true,
        editable: false,
        lockScalingX: false,
        lockScalingY: false,
        hasControls: true,
        lockRotation: false,
        lockScalingFlip: true,
        lockUniScaling: false,
        // selectable: false,
        // evented: false,  
      });
      var isChecked = $(this).parent().parent().parent().find('.resize_main').find('#resize_font').is(':checked');
      if(isChecked){
        newText.setControlsVisibility({
          mt: false,
          mb: false,
          ml: false,
          mr: false,
          bl: true,
          br: true,
          tl: true,
          tr: true,
          mtr: true, // Enable rotation control
        });
      }else{
        newText.setControlsVisibility({
          mt: false,
          mb: false,
          ml: false,
          mr: false,
          bl: false,
          br: false,
          tl: false,
          tr: false,
          mtr: true, // Enable rotation control
        });
      }

      while (newText.fontSize < maxFontSize) {
        newText.set({ fontSize: fontSize + 1 });
        newText.setCoords(); 
        if (
          newText.getScaledWidth() > canvas_width_code ||
          newText.getScaledHeight() > canvas_height_code
        ) {      
          newText.set({ fontSize });
          break;
        }
        fontSize++;
      }
      while (
        (newText.getScaledWidth() > canvas_width_code || newText.getScaledHeight() > canvas_height_code) &&
        fontSize > 5
      ) {
        fontSize--;
        newText.set({ fontSize });
        newText.setCoords();
      }
      
      textCanvas.add(newText);
      textCanvas.bringToFront(newText); 
      textCanvas.setActiveObject(newText);
      textCanvas.renderAll();
 
      var thread_colors_update_checked = $(".thread_colors_update_" + suffix_id + "_text_layer_1").find('input:checked'); 
      if (thread_colors_update_checked.length == 0) { 
         thread_colors_update_checked = $(".thread_colors_update_" + suffix_id + "_text_layer_1").eq(0).find('input');
      }
      thread_colors_update_checked.trigger('click');
      setTimeout(() => {
        if(color_hex_code_only!=''){
          var thread_colors_update_checked_hex = $(".thread_colors_"+suffix_id+"_text_layer_1_"+color_hex_code_only).find("input"); 
          if (thread_colors_update_checked_hex.length > 0) {  
             thread_colors_update_checked_hex.trigger('click');
          }
        }  
      }, 1000);

      if (newText.originX === 'center' && newText.originY === 'center') {
        var object_x = (newText.left-newText.width) / 2;
        var object_y = (newText.top-newText.height) / 2;
      }
      
      $("#_personalization_" + location_suffix_id + "_text").val(value);
      $("#_personalization_" + location_suffix_id + "_font").val(fontFamilyInput);
      $("#_personalization_" + location_suffix_id + "_font_size").val(fontSize);
      $("#_personalization_" + location_suffix_id + "_coordinates").val(object_x + "_" + object_y + "_" + parseInt(newText.width) + "_" + parseInt(newText.height));

      personalizationTextCanvas(newText, suffix_id, location_suffix_id);
    }
  } else {
    $("#_personalization_" + location_suffix_id + "_text").val("");
    $("#_personalization_" + location_suffix_id + "_font").val("");
    $("#_personalization_" + location_suffix_id + "_font_size").val("");
    $("#_personalization_" + location_suffix_id + "_thread_names").val("");
    $("#_personalization_" + location_suffix_id + "_thread_colors").val("");
    $("#_personalization_" + location_suffix_id + "_thread_codes").val("");
    $("#_personalization_" + location_suffix_id + "_coordinates").val("");
    if (currentText) {
      textCanvas.remove(currentText);
      textCanvas.renderAll();
      personalizationTextCanvas(textCanvas, suffix_id, location_suffix_id);
    }
  }
});

$(document).on("change", ".input_personalize_font_position", function(event) {
  var location_suffix_id = $(this).attr("data-location-suffix");
  var suffix_id = $(this).attr("data-suffix");
  var data_variant_id = $(this).attr("data-variant-logo");
  var canvas_id = 'logo-image-svg-canvas-' + suffix_id + "-" + data_variant_id;
  var fontposition = $(this).val();
  var textCanvas = canvases["canvas" + canvas_id];
  var currentText = textCanvas.getObjects('i-text')[0];

  if (currentText) {
    $("#_personalization_" + location_suffix_id + "_text_position").val(fontposition);
    currentText.set({
      textAlign: fontposition,
      originX: 'center',
      originY: 'center',  
    });
    textCanvas.renderAll();
    personalizationTextCanvas(currentText, suffix_id, location_suffix_id);
  } else {
    $("#_personalization_" + location_suffix_id + "_text_position").val("");
  }
  
});

$(document).on("change", ".input_personalize_font", function(event) {
  var location_suffix_id = $(this).attr("data-location-suffix");
  var suffix_id = $(this).attr("data-suffix");
  var data_variant_id = $(this).attr("data-variant-logo");
  var canvas_id = 'logo-image-svg-canvas-' + suffix_id + "-" + data_variant_id;
  var fontFamily = $(this).val();
  var textCanvas = canvases["canvas" + canvas_id];
  var currentText = textCanvas.getObjects('i-text')[0];
  
  if (currentText) {
    $("#_personalization_" + location_suffix_id + "_font").val(fontFamily);

    fontFamily = {
      'serif': 'SerifFont',
      'athletic': 'AthleticFont',
      'script': 'ScriptFont',
      'brush': 'BrushFont',
      'block': 'BlockFont'
    }[fontFamily] || fontFamily;
    
    currentText.set({
      fontFamily: fontFamily
    });
    textCanvas.renderAll();
    personalizationTextCanvas(currentText, suffix_id, location_suffix_id);
  } else {
    $("#_personalization_" + location_suffix_id + "_font").val("");
  }
});

$(document).on("change", ".input_personalize_font_size", function(event) {
  var location_suffix_id = $(this).attr("data-location-suffix");
  var suffix_id = $(this).attr("data-suffix");
  var data_variant_id = $(this).attr("data-variant-logo");
  var canvas_id = 'logo-image-svg-canvas-' + suffix_id + "-" + data_variant_id;

  var fontSize = $(this).val();
  var textCanvas = canvases["canvas" + canvas_id];
  var currentText = textCanvas.getObjects('i-text')[0];

  if (currentText) {
    $("#_personalization_" + location_suffix_id + "_font_size").val(fontSize);
    currentText.set({
      fontSize: fontSize
    });
    textCanvas.renderAll();
    personalizationTextCanvas(currentText, suffix_id, location_suffix_id);
  } else {
    $("#_personalization_" + location_suffix_id + "_font_size").val("");
  }
});

function personalizationTextCanvas(textCanvas, suffix_id, location_suffix_id) {
  if (!textCanvas || typeof textCanvas.text === "undefined") {
    $(".product__main-photos_" + location_suffix_id).find(".logo-image-svg-text").html("");
    $(".logo_customization_view_" + suffix_id).each(function () {
      $(this).find(".logo-image-svg-text").html("");
    }); 
    $(".product__media__wrapper").find(".product__main-photos_custom").each(function(index) {
      $(this).find(".logo-image-svg-text").html("");
    });  
    return;
  }
  var product_main_logo_viewing = $("#product_main_logo_viewing").val();
  const fontSize = parseFloat(textCanvas.fontSize);
  const lineHeight = fontSize * 1.2;
  const scaleX = textCanvas.scaleX || 1;
  const scaleY = textCanvas.scaleY || 1;

  var textW = parseInt(textCanvas.width);
  var textH = parseInt(textCanvas.height);
  var textX = parseInt(textCanvas.left);
  var textY = parseInt(textCanvas.top);
  
  const scaledWidth = textCanvas.width * scaleX;
  const scaledHeight = textCanvas.height * scaleY;

  // Compute top-left position from origin
  let left = textCanvas.left;
  let top = textCanvas.top;

  if (textCanvas.originX === 'center') left -= scaledWidth / 2;
  else if (textCanvas.originX === 'right') left -= scaledWidth;

  if (textCanvas.originY === 'center') top -= scaledHeight / 2;
  else if (textCanvas.originY === 'bottom') top -= scaledHeight;

  // This is the rotation center point
  const centerX = textCanvas.left;
  const centerY = textCanvas.top;

  let currentY = top + fontSize;
  const textArr = textCanvas.text.split("\n");
  let svgTextLines = '';

  textArr.forEach((line, i) => {
    const lineWidth = (textCanvas.__lineWidths?.[i] || 0) * scaleX;
    let x = left;

    if (textCanvas.textAlign === 'center') {
      x += (scaledWidth - lineWidth) / 2;
    } else if (textCanvas.textAlign === 'right') {
      x += (scaledWidth - lineWidth);
    }

    svgTextLines += `<tspan x="${x}" y="${currentY}" textLength="${lineWidth}">${line}</tspan>\n`;
    currentY += lineHeight;
  });

  const svgText = `
    <text
      transform="rotate(${textCanvas.angle}, ${centerX}, ${centerY})"
      x="${textX}" 
      y="${textY}" 
      width="${textW}" 
      height="${textH}"   
      font-family="${textCanvas.fontFamily}"
      font-size="${fontSize}px"
      fill="${textCanvas.fill}">
      ${svgTextLines}
    </text>`;

  if(product_main_logo_viewing == "Logo Mockup"){ 
     $(".product__media__wrapper").find(".product__main-photos_custom").each(function(index) {
        $(this).find(".logo-image-svg-text").html(svgText);
    });
  }else{
   $(".product__main-photos_" + location_suffix_id).find(".logo-image-svg-text").html(svgText);
  } 
  
  // $(".product__main-photos_" + location_suffix_id).find(".logo-image-svg-text").html(svgText);

  $(".logo_customization_view_" + suffix_id).each(function () {
    $(this).find(".logo-image-svg-text").html(svgText);
    if ($(this).attr("display-type") === "Popup") {
      $(this).find("text").css("font-size", fontSize + "px");
    }
  });

  if ($(".svg_to_base64_zoom").length > 0) {
    $(".svg_to_base64_zoom").each(function(index) {
        $(this).remove();
    });
  }

}

// function personalizationTextCanvas(textCanvas, suffix_id, location_suffix_id) {
//   if (textCanvas != '' && typeof(textCanvas.text) !== "undefined") {
//     var newTextHtml = '';
//     var newTextHtmlDis = '';
//     var textArr = textCanvas.text.split("\n");
//     var svg_text_html = '';
//     var textW = parseInt(textCanvas.width);
//     var textH = parseInt(textCanvas.height);
//     var textX = parseInt(textCanvas.left);
//     var textY = parseInt(textCanvas.top);

//     if (textCanvas.originX === 'center') {
//         textX -= textW / 2;
//     } else if (textCanvas.originX === 'right') {
//         textX -= textW;
//     }

//     var lineHeight = parseInt(textCanvas.fontSize) * 1.2;
//     var textSpanY = textY;

//     $.each(textArr, function(key, value) {
//         var mtextW = parseInt(textCanvas.__lineWidths[key]);
//         var mtextX = textCanvas.left;
//         if (textCanvas.originX === 'center') {
//             mtextX -= mtextW / 2;
//         } else if (textCanvas.originX === 'right') {
//             mtextX -= mtextW;
//         }
//         newTextHtml += `<tspan y="${textSpanY}" x="${mtextX}" textLength="${mtextW}">${value}</tspan>`;
//         newTextHtmlDis += `<tspan y="${textSpanY}" x="${mtextX}" textLength="${mtextW}">${value}</tspan>`;
//         textSpanY += lineHeight;
//     });

//     var svg_text_html = `<text 
//                           x="${textX}" 
//                           y="${textY}" 
//                           width="${textW}" 
//                           height="${textH}" 
//                           font-family="${textCanvas.fontFamily}"
//                           font-size="${textCanvas.fontSize}px"
//                           fill="${textCanvas.fill}"
//                           style="font-size: ${textCanvas.fontSize}px;">
//                           ${newTextHtml}
//                         </text>`;

//     var product_main_logo_viewing = $("#product_main_logo_viewing").val();
//     if(product_main_logo_viewing == "Logo Mockup"){ 
//        $(".product__media__wrapper").find(".product__main-photos_custom").each(function(index) {
//           $(this).find(".logo-image-svg-text").html(svg_text_html);
//       });
//     }else{
//      $(".product__main-photos_" + location_suffix_id).find(".logo-image-svg-text").html(svg_text_html);
//     } 

//     var input_svg_text_html = `<hr>
//                                <text 
//                                   x="${parseInt(textCanvas.left)}" 
//                                   y="${parseInt(textCanvas.top) + parseInt(textCanvas.height)}" 
//                                   width="${parseInt(textCanvas.width)}" 
//                                   height="${parseInt(textCanvas.height)}" 
//                                   font-family="${textCanvas.fontFamily}"
//                                   fill="${textCanvas.fill}"
//                                   data-value="${textCanvas.text}"
//                                   font-size="${textCanvas.fontSize}px"
//                                   style="font-family:${textCanvas.fontFamily}; color: ${textCanvas.fill}"
//                                 >
//                                   ${newTextHtmlDis}
//                                 </text>`;

//       $(".logo_customization_view_" + suffix_id).each(function(index) {
//           $(this).find(".logo-image-svg-text").html(input_svg_text_html);
//           if ($(this).attr("display-type") == "Popup") {
//               $(this).find(".logo-image-svg-text").find("text").css("font-size", textCanvas.fontSize + "px");
//           }
//       });
//   } else {
//       $(".product__main-photos_" + location_suffix_id).find(".logo-image-svg-text").html("");
//       $(".logo_customization_view_" + suffix_id).each(function(index) {
//           $(this).find(".logo-image-svg-text").html("");
//       });
//      $(".product__media__wrapper").find(".product__main-photos_custom").each(function(index) {
//         $(this).find(".logo-image-svg-text").html("");
//     });
//   }
// }

$(document).on("click", ".tab_customization_btn", function(e) {
  e.preventdefault;
  var location_suffix_id = $(this).attr("data-location-suffix");
  var suffix_id = $(this).attr("data-suffix");
  var tab_val = $(this).attr("tab-val");
  var data_variant_id = $(this).attr("data-variant-logo");
  var canvas_id = 'canvaslogo-image-svg-canvas-' + suffix_id + "-" + data_variant_id;
  var canvasObj = canvases[canvas_id];

  if (tab_val == "Personalize") {
    var setActiveObjectData = canvasObj.getObjects('i-text')[0];
  } else {
    var allObjects = canvasObj.getObjects();
    var objectKeys = 2;
    allObjects.forEach(function(obj,index) {  
      if(obj.type == "group"){
         objectKeys = index; 
      } 
    });
    var setActiveObjectData = allObjects[objectKeys];
  } 
  if (setActiveObjectData) {
    canvasObj.setActiveObject(setActiveObjectData);
    canvasObj.renderAll();
  }
});

function setThreadColorsUpdateCanvas(canvas_id, thread_colors_layer_id, thread_colors_value) {
  var activeObject = canvases[canvas_id].getActiveObject();
  if (thread_colors_layer_id == "text_layer_1") {
    var textCanvas = canvases[canvas_id];
    
    var currentText = textCanvas.getObjects('i-text')[0];
    if (currentText) {
      currentText.set({
        fill: thread_colors_value
      });
      textCanvas.renderAll();
    }
  } else {
    if(activeObject === null || activeObject.text!=""){
      var canvasObj = canvases[canvas_id];
      var allObjects = canvasObj.getObjects();
     
      var objectKeys = 2;
      allObjects.forEach(function(obj,index) {  
        if(obj.type == "group"){
           objectKeys = index; 
        } 
      });
      activeObject = allObjects[objectKeys];
      canvasObj.setActiveObject(activeObject);
      canvases[canvas_id].renderAll();
    }
    activeObject._objects.forEach(function(path) {
      if (path.id == thread_colors_layer_id) {
        path.fill = thread_colors_value
      }
    });
    canvases[canvas_id].renderAll();
  }
}

function logoLayerRender(svgHtml, logoUrl, base64_id, suffix_id = "", location_suffix_id = "") {
  if (typeof logoUrl !== 'undefined') {
    let extension = logoUrl.substring(logoUrl.lastIndexOf('.') + 1);
    if (extension == "svg") {
      $(".product__main-photos" + location_suffix_id).find(".logo-image-svg").each(function(index) {
        var variant_id = $(this).attr("data-variant-logo");
        $(this).closest(".logo-image-png").hide();
        $(this).html(svgHtml).show();
        $(this).removeAttr("transform");
        $(this).find("svg").attr({
          // "viewBox":"0 0 2048 2048",
          "width": $(this).attr("width"),
          "height": $(this).attr("height"),
          "x": $(this).attr("x"),
          "y": $(this).attr("y")
        });
        $(this).find("image").attr("style", "mix-blend-mode: multiply;");
      });

    } else {
      $(".logo-image-svg").hide();
      $(".logo-image-png").show();
    }
  }
}

async function getFixdThreadConeSvg(logoUrl = 'https://cdn.shopify.com/s/files/1/0733/4425/4206/files/Thread_Cone.svg') {
  return await new Promise((resolve, reject) => {
    setTimeout(() => {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", logoUrl);
      xhr.onreadystatechange = function() {
        if (xhr.readyState === 4) {
          var response = xhr.response;
          var success = $($.parseHTML(response)).filter("svg");
          if (success.length == 1) {
            resolve(response);
          }
        }
      }
      xhr.send();
    }, 100);
  });
}

function sectionSetup(section_id) {
  const answerPaddingTop = 10;
  const answerPaddingBottom = 30;

  const faqs = document.querySelectorAll(
    '.faq-' + section_id
  );
  const buttons = document.querySelectorAll(
    '.faq-' + section_id + ' .button-' + section_id
  );
  const answers = document.querySelectorAll(
    '.faq-' + section_id + ' .answer-' + section_id
  );
  const icons = document.querySelectorAll(
    '.faq-' + section_id + ' .icon-' + section_id
  );

  let activeIndex = -1;

  function openAnswer(index, paginationUrl) {
    var product_main_logo_viewing = $("#product_main_logo_viewing").val();
    if(product_main_logo_viewing == "Logo Mockup"){
      var layerText = 'text_layer_1';
      var index = 0;
    }else{
     var layerText = $(answers[index]).find('.main_color_thread .threadCon').attr("data-text");
    } 
    $(answers[index]).find('.main_color_thread .threadCon').html('');
    $(answers[index]).find(".pagination").html('');
    var collection_product_url = $("#collection_product_url").val();
    var product_base_url = window.location.origin + collection_product_url;
    
    if ($(answers[index]).find('.main_color_thread .color_main_thread').length == 0) { 
      $(answers[index]).find(".main_color_thread").attr("style", "display: none;");
      $(answers[index]).find('.spinner').show();      
       
      if (paginationUrl.trim() == "") {
        var url = product_base_url+`?view=meta-logo-thread-color`;
      } else {
        var url = paginationUrl;
      }
      var searchValue = "";
      if(url.indexOf("search") > 0){
        url = url.replace("meta-logo-thread-color", "meta-logo-thread-color-all");
        var searchUrl = true;        
        let paramString = url.split('?')[1];
        let queryString = new URLSearchParams(paramString);
        for (let pair of queryString.entries()) { 
          if(pair[0] == "search"){
            searchValue = pair[1].trim();
          }
        } 
      }else{
        var searchUrl = false;        
      }
      $.ajax({
        url: url,
        method: "GET",
        success: function(data) {
          const $data = $(data); 
          var new_html = $data.find(".thread_clone_color .color_main_thread"); 
          var old_html = $(answers[index]).find('.main_color_thread');
          var pagination = $data.find(".thread_clone_color .pagination"); 
           
          $(new_html).each(function(key_1, value1) {
            if(searchValue != ""){ 
              if($(value1).find(".thread_colors_title_code").text().toLowerCase().indexOf(searchValue.toLowerCase()) >= 0){
                var found = 1;
              }else if($(value1).find(".thread_colors_title_code").attr('data-color-tag').toLowerCase().indexOf(searchValue.toLowerCase()) >= 0){
                var found = 1;
              }else{
                var found = 0;
              }
            }else{
              var found = 1;
            } 
            if(found == 1){
              var newHex = $(value1).find(".logo_customization_thread_cone_img").attr("data-thread-cone-code").replace("#", "");
              $(".threadCon_" + newHex + "-" + layerText).html('');
              $(".threadCon_" + newHex + "-" + layerText).parents(".main_color_thread").show();
              $(".threadCon_" + newHex + "-" + layerText).append(value1);
            }
          });
          $(answers[index]).find('.spinner').hide();
          $(answers[index]).find(".pagination").append($(pagination).html());
        },
        error: function() {
          alert("Failed to load products. Please try again.");
        }
      });
    }
    answers[index].style.display = 'block';
    setTimeout(() => {
      answers[index].style.paddingTop = `${answerPaddingTop}px`;
      answers[index].style.paddingBottom = `${answerPaddingBottom}px`;
      answers[index].style.height = `360px`;
      icons[index].style.setProperty('--rotate', '180deg');
    });
  }

  //$(document).off("click", ".pagination_layer a");
  $(document).on("click", ".pagination_layer a", function(e) {
    e.preventDefault();
    var paginationUrl = $(this).attr("href");
    var index = $(this).parents(".tab_container").find(".logoCustom.active").data("index");
    $(answers[index]).find('.main_color_thread .threadCon').html('');
    openAnswer(index, paginationUrl);
  });

  $(document).off("click", "button.input-thread-colors-search");
  $(document).on("click", "button.input-thread-colors-search", function(event) {
    var value = $(this).prev().val().toLowerCase();
    var collection_product_url = $("#collection_product_url").val();
    var product_base_url = window.location.origin + collection_product_url;
    if (value.length > 0) {
      var searchUrl = product_base_url+`?view=meta-logo-thread-color&search=` + value;
    } else {
      var searchUrl = product_base_url+`?view=meta-logo-thread-color`;
    }
    var index = $(this).parents(".tab_container").find(".logoCustom.active").data("index");
    openAnswer(index, searchUrl);
  });

  $(document).off("click", "button.input-thread-colors-search-clear");
  $(document).on("click", "button.input-thread-colors-search-clear", function(event) {
    var collection_product_url = $("#collection_product_url").val();
    var product_base_url = window.location.origin + collection_product_url;
    
    var value = $(this).parent().find('input.input-thread-colors-search').val('');
    var searchUrl = product_base_url+`?view=meta-logo-thread-color`;
    var index = $(this).parents(".tab_container").find(".logoCustom.active").data("index");
    openAnswer(index, searchUrl);
  });

  function closeAnswer(index) {
    answers[index].style.paddingTop = 0;
    answers[index].style.paddingBottom = 0;
    answers[index].style.height = 0;
    icons[index].style.setProperty('--rotate', '0deg');

    setTimeout(() => {
      answers[index].style.display = 'none';
      $(answers[index]).removeClass("active");
      $(".input-thread-colors-search").val('');
    }, 300);
  }

  function toggleAnswer(index) {
    if (answers[index].style.display === 'none') {
      openAnswer(index, '');
      activeIndex = index;
      $(answers[index]).addClass("active");
    } else {
      closeAnswer(index);
      activeIndex = -1;
    }
  }

  function closeAllAnswerBut(index) {
    answers.forEach((answer, i) => {
      if (i !== index) {
        closeAnswer(i);
      }
    });
  }

  buttons.forEach((button, index) => {
    button.addEventListener('click', () => {
      var thread_layer_id = button.getAttribute("thread_layer_id");
      var product_main_logo_viewing = $("#product_main_logo_viewing").val();
      if(product_main_logo_viewing == "Logo Mockup" || product_main_logo_viewing == "Logo Location"){  
        var personalize_customization_assigned_thread = $('.personalize_customization_use_assigned').attr("use-assigned-thread"); 
        if(personalize_customization_assigned_thread == "false" && thread_layer_id == 'text_layer_1'){  
          return false;
        } 
      }
      toggleAnswer(index);
      closeAllAnswerBut(index);
    });
  });

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (activeIndex !== -1) {
        answers[activeIndex].style.height = `360px`;
      }
    }, 250);
  });
}

$(document).ready(function() {
  var product_main_logo_viewing = $("#product_main_logo_viewing").val();
  var variant_wrapper_custom_div = $("#variant_wrapper_custom_div").html();
  if(variant_wrapper_custom_div!=''){
    $("#variant_wrapper_custom_div").html("");
    $('.product__block__variants').last().after(variant_wrapper_custom_div);
    if(product_main_logo_viewing == "Logo Mockup"){ 
      $(".product__main__content").find(".variant-wrapper-custom").hide();
    }
  }
  
  pageOnLoadEvents();
  
});

$(document).on("click", "ul.tabs li", function(e) { 
  var parent = $(this).parents('.tab-container');
  $(parent).find(".tab_content").hide();
  var activeTab = $(this).attr("rel");
  $(parent).find("#" + activeTab).fadeIn();
  $(parent).find("ul.tabs li").removeClass("active");
  $(this).addClass("active");
});

function pageOnLoadEvents() {
  var inputElements = $('.meta_logo_custom_section input');
  var custom_form_id = $("#custom_form_id").val();
  inputElements.each(function() {
    $(this).attr('form', custom_form_id);
  });

  var variant_wrapper_custom = $('.variant-wrapper-custom input');
  variant_wrapper_custom.each(function() {
    $(this).attr('form', custom_form_id);
  });

  var main_variant_logos_wrapper = $('.main_variant_logos_wrapper input');
  main_variant_logos_wrapper.each(function() {
    $(this).attr('form', custom_form_id);
  });
  
  $(".tab-container .tab_content").hide();
  $('.tab-container').each(function(k, v) {
    $(v).find('.tab_content:first').show();
  });

  $('ul.tabs li').last().addClass("tab_last");

  $('.checkbox-dropdown .checkbox').each(function(index) {
    var is_checked = $(this).prop('checked');
    var thisval = $(this).attr("data-location");
    if (is_checked == true) {
      metaLogoCustomSectionInput("meta_logo_custom_section_" + thisval, false);
    } else {
      metaLogoCustomSectionInput("meta_logo_custom_section_" + thisval, true);
    }
  });
}

$(document).on("change", ".meta-variant-dropdown", function(e) {
  e.preventdefault;
  var is_checked = $(this).prop('checked');
  var thisval = $(this).attr("data-location");
  var data_image_index = $(this).attr("data-image-index");
  
  if (is_checked == true) {
    $('.custom-product-slideshow').slick('slickGoTo', data_image_index);
    if($(".variant-input-wrap-custom").find(".add_logo_error").length > 0){
      $(".variant-input-wrap-custom").find(".add_logo_error").remove();  
    }
    $(".meta_logo_custom_index_section_" + thisval).removeClass("hide");
    $("#LogoSection-" + thisval + "-logos").show();
    $(".ImageSection-" + thisval + "-logos").show();
    metaLogoCustomSectionInput("meta_logo_custom_section_" + thisval, false);
    var logoSectionFirstChecked = $("#LogoSection-" + thisval + "-logos").find(".logo-inner").find('input:checked');
    if (logoSectionFirstChecked.length == 0) {
      var urlObj = new URL(window.location.href);
      var sLogoValue = urlObj.searchParams.get("sLogo");
      var logoSection = $("#LogoSection-" + thisval + "-logos").find(".logo_inner_input_"+thisval+"_"+sLogoValue).find('input');
      if(sLogoValue!== null){ 
        logoSection.trigger('click'); logoSection.prop("checked", true); 
      }else{
        if(window.location.href.includes("pages/cart-details") || window.location.href.includes("account/orders")){ 
          setTimeout(function() {
            var logoSectionFirst = $("#LogoSection-" + thisval + "-logos").find(".logo-inner").first().find('input'); 
            logoSectionFirst.trigger('click');
          }, 700);
        }else{
          var logoSectionFirst = $("#LogoSection-" + thisval + "-logos").find(".logo-inner").first().find('input'); 
          logoSectionFirst.trigger('click');
        }
      }
    }
  } else {
    var $checkedInput = $(".meta-variant-dropdown").find("input:checked").last();
    var data_image_index = $checkedInput.attr("data-image-index");
    if (data_image_index != null && data_image_index !== "") {
      $('.custom-product-slideshow').slick('slickGoTo', parseInt(data_image_index, 10));
    } else {
      $('.custom-product-slideshow').slick('slickGoTo', 0);
    }
    $(".meta_logo_custom_index_section_" + thisval).addClass("hide");
    $("#LogoSection-" + thisval + "-logos").hide();
    $(".ImageSection-" + thisval + "-logos").hide();
    metaLogoCustomSectionInput("meta_logo_custom_section_" + thisval, true);
  }

  if($('.checkbox-dropdown .checkbox:checked').length > 0){
    $(".product__main-photos_common").find(".logo-image-svg").show();
    $(".product__main-photos_common").find(".logo-image-svg-text").show();
  }else{
    $(".product__main-photos_common").find(".logo-image-svg").hide();
    $(".product__main-photos_common").find(".logo-image-svg-text").hide();
  }
});

$(document).ready(function() {
  $(document).on("click", ".checkbox-dropdown .dropdown-button", function(e) {
    e.stopPropagation(); 
    $(this).parent('.checkbox-dropdown').toggleClass('open');
  });

  $(document).on('click', function(e) {
    if (!$(e.target).closest('.checkbox-dropdown').length) {
      $('.checkbox-dropdown').removeClass('open');
    }
  });

  $(document).on("click", ".checkbox-dropdown .dropdown-menu", function(e) {
    e.stopPropagation();
  });
  checkboxDropdownUpdate();
  $(document).on("change", ".checkbox-dropdown .checkbox", function(e) {
    checkboxDropdownUpdate();
  });

  $('.meta_logo_custom_section').each(function(index) { 
    if (!$(this).hasClass("meta-logo-grid-style")) {
      $(this).addClass("meta-logo-grid-style");
    } 
  });
});

function checkboxDropdownUpdate() {
  var selectedOptions = [];
  $('.checkbox-dropdown .checkbox:checked').each(function() {
    selectedOptions.push($(this).parent().text().trim());
  });
  $('.checkbox-dropdown .dropdown-button').html((selectedOptions.length ? selectedOptions.join(', ') : 'Select Options') + `<svg width="30px" height="30px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#000000">
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
        <g id="SVGRepo_iconCarrier"> 
          <rect x="0" fill="none" width="24" height="24"></rect> 
          <g> <path d="M7 10l5 5 5-5"></path> </g> 
        </g>
      </svg>`);
}

function metaLogoCustomSectionInput(sectionClass, inputVal, isCheckVal = false, loopIndex = '') {
  var inputElements = $('.' + sectionClass + ' input');
  inputElements.each(function() {
    $(this).attr('disabled', inputVal);
  });
}

$(window).on('load', function () {
  setTimeout(function () {
    const $selectedInputs = $(".template-product .product-section .swatch__button_variant_options_main input:checked");

    if ($selectedInputs.length) {
      const id = $selectedInputs.first().data("media-id");
      $(".product-section").find(`.product__thumb-item[data-index-id="${id}"]`).trigger("click");
    }
    const $logoSwatches = $('.logo_product-form__swatch__item');
    if ($logoSwatches.length) {
      $logoSwatches.eq(0).find('input').trigger('click');
    }
  }, 1000);
});

// document.addEventListener('theme:variant:change', function(event) {
//   var product_main_logo_viewing = $("#product_main_logo_viewing").val();
//   var suffix_id = $('.custom_logo_customization_popup_btn').data('suffix');
//   var input_personalize_text =  $(".input-personalize-text").val();
//   if(product_main_logo_viewing == "Logo Mockup" && event.detail.variant.id!="" && input_personalize_text!=''){ 
//     $(".input-personalize-text").val("");
//     $(".input-personalize-text").trigger('keyup'); 
//   }
//   if (event.detail.variant.featured_media != null) {
//     let imageId = event.detail.variant.featured_media.id;
//     let $thumbnailImages = $(".product__thumb-item");
//     let isThumbnailImage = true;
//     if ($thumbnailImages.length) {
//       $thumbnailImages.each(function () {
//         let $this = $(this);
//         let dataId = Number($this.attr("data-index-id")); 
//         if (dataId === imageId && isThumbnailImage) {
//           $this.trigger("click");
//           isThumbnailImage = false;
//         }
//       });
//     }
  
//     let $propertyOfImage = $('[name="properties[_product_image]"]');
//     if ($propertyOfImage.length) {
//       $propertyOfImage.val(`https:${event.detail.variant.featured_media.preview_image.src}`);
//     }
//   } else {
//     let productDefaultImage = $("#product_default_image").val();
//     let $propertyOfImage = $('[name="properties[_product_image]"]');
//     if ($propertyOfImage.length) {
//       $propertyOfImage.val(productDefaultImage);
//     }
//   }

//   var current_variant_id = parseInt($("#tmp_current_variant_id").val());
//   let variantId = event.detail.variant.id;  
//   if(current_variant_id != variantId){
//     $("#tmp_current_variant_id").val(variantId);
//     var product_section_id = $(".product-section").attr("data-section-id");
//     //$("#ajax_loader").show();
//     $('body').append('<style id="logo_hide">.product__main-photos_custom .logo-image-svg{display: none !important;}</style>');
//     $.ajax({
//       url: `${window.location.pathname}/?sections=${product_section_id},meta-logo-personalized&variant=${variantId}`,
//       type: 'GET',
//       dataType: 'html',
//       success: function(data) {
//       //  $("#ajax_loader").hide(); 
//         let jsonData =  JSON.parse(data);
//         if(product_main_logo_viewing == "Logo Mockup"){  
//           var checkboxLogo = $('input[name="properties[Logo]"]:checked').val(); 
//           var meta_logo_custom_section_only = $(jsonData[product_section_id]).find(".meta_logo_custom_section_only").html(); 
//           var form__swatch = $(jsonData[product_section_id]).find(".custom_logo_product-form__swatch").html(); 
//           $('.meta_logo_custom_section_only').html(meta_logo_custom_section_only);
//           $(".custom_logo_product-form__swatch").html(form__swatch); 
//           $('.section_custom_meta_logo_personalized').parent(".shopify-section").html(jsonData['meta-logo-personalized']); 
//         }else if(product_main_logo_viewing == "Logo Swatch"){
          
//         }else{
//           if(product_main_logo_viewing != ""){  
//             var main_product = $(jsonData[product_section_id]).find(".custom-product-images-wrapper").html();
//             $(".product__thumb-item").find(".custom-product-images-wrapper").html(main_product); 
//             productSlickSlideshow();
//           }
//           $('.section_custom_meta_logo_personalized').parent(".shopify-section").html(jsonData['meta-logo-personalized']);
//         }
//         logoInputSvgLoad();
//         logoImageSvgLoad();  
//         var variant_wrapper_custom_div = $("#variant_wrapper_custom_div").html();
//         if(variant_wrapper_custom_div!=''){
//           $(".product__main__content").find(".variant-wrapper-custom").remove();
//           $("#variant_wrapper_custom_div").html("");
//            $(".product__main__content").find('.product__block__variants').last().after(variant_wrapper_custom_div);
//           if(product_main_logo_viewing == "Logo Mockup"){ 
//             $(".product__main__content").find(".variant-wrapper-custom").hide();
//           } 
//         }
        
//         if(product_main_logo_viewing == "Logo Mockup"){  
//           // $(".logo-input-svg-variant-"+event.detail.variant.id).trigger('click');
//           // console.log($(".LogoSelect-"+variantId+"-logo-"+checkboxLogo).parent(".logo_product-form__swatch__item"));
//           // $(".LogoSelect-"+variantId+"-logo-"+checkboxLogo).parent(".logo_product-form__swatch__item").trigger('click');
//           setTimeout(function() {
//             let logoSelector = ".LogoSelect-" + variantId + "-logo-" + checkboxLogo;
//             $(logoSelector).trigger('click');
//             let target = $(logoSelector).parent(".logo_product-form__swatch__item");
//             if (target.length) {
//               target.trigger('click');
//             } else {
//               console.warn("Logo element not found:", logoSelector);
//             }
//           }, 800);
//           setTimeout(function() {
//             $('#logo_hide').remove();
//           },1500);
//           setTimeout(function() { 
//             if(input_personalize_text!=''){
//                 $(".input-personalize-text").val(input_personalize_text);
//                 $(".input-personalize-text").trigger('keyup');
//                 $("[class^='personalization_properties_']").each(function() { 
//                     $(this).removeAttr('disabled');
//                 });
//             } 
//           }, 2000);
//         }else{
//            $('#logo_hide').remove();
//         }
//         checkboxDropdownUpdate();
//         pageOnLoadEvents(); 
//       },
//       error: function(jqXHR, textStatus, errorThrown) {
//         console.error("Error fetching meta-logo-personalized content:", errorThrown);
//       }
//     });
//   }
// });

document.addEventListener('theme:variant:change', function (event) {
  const variant = event.detail?.variant;
  if (!variant) return;

  const $mainView = $("#product_main_logo_viewing");
  const product_main_logo_viewing = $mainView.val();
  const input_personalize_text = $(".input-personalize-text").val();

  if (product_main_logo_viewing === "Logo Mockup" && variant.id && input_personalize_text) {
    $(".input-personalize-text").val("").trigger("keyup");
  }

  updateThumbnailAndImageProperty(variant);

  const $variantIdHolder = $("#tmp_current_variant_id");
  const current_variant_id = parseInt($variantIdHolder.val(), 10);

  if (current_variant_id !== variant.id) {
    $variantIdHolder.val(variant.id);
    fetchUpdatedSections(variant.id, product_main_logo_viewing, input_personalize_text);
  }
});

// --- Helper Functions --- //

function updateThumbnailAndImageProperty(variant) {
  const imageId = variant.featured_media?.id;
  const $propertyImage = $('[name="properties[_product_image]"]');

  if (imageId) {
    const imageUrl = `https:${variant.featured_media.preview_image.src}`;
    $propertyImage.val(imageUrl);

    const $thumbs = $(".product__thumb-item");
    for (let i = 0; i < $thumbs.length; i++) {
      const $thumb = $($thumbs[i]);
      if (Number($thumb.attr("data-index-id")) === imageId) {
        $thumb.trigger("click");
        break;
      }
    }
  } else {
    $propertyImage.val($("#product_default_image").val());
  }
}

function fetchUpdatedSections(variantId, viewType, inputText) {
  const product_section_id = $(".product-section").attr("data-section-id");
  if (!product_section_id) return;

  if (!document.getElementById("logo_hide")) {
    $("body").append('<style id="logo_hide">.product__main-photos_custom .logo-image-svg{display: none !important;}</style>');
  }

  $.ajax({
    url: `${window.location.pathname}/?sections=${product_section_id},meta-logo-personalized&variant=${variantId}`,
    type: "GET",
    dataType: "html",
    success: function (data) {
      let jsonData;
      try {
        jsonData = JSON.parse(data);
      } catch (e) {
        console.error("Failed to parse JSON:", e);
        return;
      }

      if (viewType === "Logo Mockup" || viewType === "Logo Swatch") {
        handleLogoMockup(jsonData, variantId, inputText, product_section_id);
      } else {
        handleDefaultImageSwap(jsonData, viewType, product_section_id);
      }

      handleVariantWrapperSwap(viewType);
      checkboxDropdownUpdate();
      pageOnLoadEvents();
    },
    error: function (jqXHR, textStatus, errorThrown) {
      console.error("Error fetching updated sections:", errorThrown);
    }
  });
}

function handleLogoMockup(jsonData, variantId, inputText, sectionId) {
  const $section = $(jsonData[sectionId]);
  const $metaHtml = jsonData["meta-logo-personalized"];
  const selectedLogo = $('input[name="properties[Logo]"]:checked').val();

  const mainImages = $section.find(".custom-product-images-wrapper").html();
  $(".product__media__wrapper").find(".custom-product-images-wrapper").html(mainImages);
  productSlickSlideshow("product__media__wrapper");
  
  $(".meta_logo_custom_section_only").html($section.find(".meta_logo_custom_section_only").html());
  $(".custom_logo_product-form__swatch").html($section.find(".custom_logo_product-form__swatch").html());
  $(".section_custom_meta_logo_personalized").parent(".shopify-section").html($metaHtml);

  logoInputSvgLoad();
  logoImageSvgLoad();

  const logoSelector = `.LogoSelect-${variantId}-logo-${selectedLogo}`;
  const $target = $(logoSelector).parent(".logo_product-form__swatch__item");

  setTimeout(() => {
    $(logoSelector).trigger("click");
    if ($target.length) $target.trigger("click");

    setTimeout(() => $("#logo_hide").remove(), 200);
    if (inputText) {
      setTimeout(() => {
        $(".input-personalize-text").val(inputText).trigger("keyup");
        $("[class^='personalization_properties_']").removeAttr("disabled");
      }, 1200);
    }
  }, 400);  
}

function handleDefaultImageSwap(jsonData, viewType, sectionId) {
  if (viewType) {
    const mainImages = $(jsonData[sectionId]).find(".custom-product-images-wrapper").html();
    $("#shopify-section-"+sectionId).find(".product__media__wrapper").find(".custom-product-images-wrapper").html(mainImages);
    productSlickSlideshow();
  }
  $(".section_custom_meta_logo_personalized").parent(".shopify-section").html(jsonData["meta-logo-personalized"]);
  $("#logo_hide").remove();

  logoInputSvgLoad();
  logoImageSvgLoad();
}

// function handleDefaultImageSwap(jsonData, viewType, sectionId) {
//   if (viewType) {
//     const mainImages = $(jsonData[sectionId]).find(".custom-product-images-wrapper").html();
//     $(".custom-product-images-wrapper").html(mainImages);
//     productSlickSlideshow();
//   }
//   $(".section_custom_meta_logo_personalized").parent(".shopify-section").html(jsonData["meta-logo-personalized"]);
//   $("#logo_hide").remove();
// }

function handleVariantWrapperSwap(viewType) {
  const $wrapperHTML = $("#variant_wrapper_custom_div").html();
  if (!$wrapperHTML) return;

  const $productContent = $(".product__main__content");
  $productContent.find(".variant-wrapper-custom").remove();
  $("#variant_wrapper_custom_div").empty();

  const $insertAfter = $productContent.find(".product__block__variants").last();
  $insertAfter.after($wrapperHTML);

  if (viewType === "Logo Mockup" || logo_viewing === "Logo Swatch") {
    $productContent.find(".variant-wrapper-custom").hide();
  }
}



$(document).ready(function() {
  var order_page_type = $("#order_page_type").val();
  if(order_page_type == "order_info"){ 
    $('#fetch-order').click();
  }else{
    autoFatchOrderDetails();
  }
});

$(document).on('click', '#fetch-order', function() {
  const orderNumber = $('#order-number').val().trim().replace('#', '');
  if(!orderNumber) {
    alert('Please enter an order number.');
    return;
  }
  var isApiCall = true;
  var getLocalOrder = get_local_storage("OrderDetails");
  if(getLocalOrder != null) {
    let parsedOrders = JSON.parse(getLocalOrder); 
    if(orderNumber == parsedOrders.name.replace('#', '')){
      var isApiCall = false;
      orderHtmlDisplay(parsedOrders.line_items, parsedOrders);
      $("#ajax_loader").hide();
    } 
  }
  if(isApiCall){  
    $("#ajax_loader").show();
    $.ajax({
      url: 'https://qetail.com/apps/get_order_details_bk/getOrderDetailsDreamgolf.php',
      type: 'POST',
      dataType: 'json',
      data: {
        OrderNumber: orderNumber,
        hostname: js_permanent_domain,
      },
      success: function(res) {
        $("#ajax_loader").hide();
        var data = res.order_details; 
        if(data) {
          update_local_storage("OrderDetails", data); 
          const products = data.line_items;
          orderHtmlDisplay(products, data);
        } else {
          $('#order-products').html('<p>No products found for this order.</p>');
        }
      },
      error: function(err) {
        console.error('Error Order Details get:', err);
      }
    });
  }
});

$(document).on('click', '.order_reset', function() {
  $("#ajax_loader").show();
  autoFatchOrderDetails(true);
});

$(document).on('click', '.split-button', function() {
  var splitItem = $(this).closest('.product-item');
  var splitItemIndex = $(this).attr("splitItemIndex");
  $('html').addClass('js-drawer-open lock-scroll');

  let qtyField = splitItem.find('.input-box');
  let maxQty = parseInt(qtyField.val(), 10);

  $("#confirmSplit").attr("splitItemIndex", splitItemIndex);
  $('#splitQtyInput').attr('max', maxQty - 1).val(1);
  $('#splitModal').show();
});

$(document).on('click', '.approve_order_modal', function() { 
  $('html').addClass('js-drawer-open lock-scroll'); 
  $('#approveOrderModal').show();
});

$(document).on('click', '.edit_address_btn', function() { 
  $('.error').html('');
  var button_type = $(this).attr("data-button-type");
  $("#order_save_address").attr("data-address-type",button_type);
  let cart = getCartDetails();

  if(button_type == "billing_address"){
    var addressData = cart.billing_address;
    $(".address_edit_text").html("billing");
  } else {
    var addressData = cart.shipping_address;
    $(".address_edit_text").html("shipping");
  }

  if(addressData!=''){
    $("#address_first_name").val(addressData.first_name);
    $("#address_last_name").val(addressData.last_name);
    $("#address_address1").val(addressData.address1);
    $("#address_address2").val(addressData.address2);
    $("#address_city").val(addressData.city);
    $("#address_country").val(addressData.country);
    $("#address_province").attr("data-default",addressData.province);
    $("#address_country").trigger("change"); 
    $("#address_zip").val(addressData.zip);
    $("#address_phone").val(addressData.phone); 
  }
  $('html').addClass('js-drawer-open lock-scroll'); 
  $('#AddressEditModal').show();
});

$(document).on('change', '#address_country', function() {  
  var selectedValue = $(this).val();  
  var selectedOption = $(this).find('option:selected');  
  var dataProvince = selectedOption.attr('data-provinces');
  if(dataProvince!=""){
    dataProvince = JSON.parse(dataProvince);
    $("#address_province").html("");
    var seletedval = $("#address_province").attr("data-default");
    $.each(dataProvince, function(index, state) {
      $('#address_province').append($('<option>', {
        value: state[0],
        text: state[1]
      }));
    });
    if(seletedval!=""){
      $('#address_province').val(seletedval);
    }
  }else{
    $("#address_province_div").hide();
  }
});

$(document).on('click', '#order_save_address', function(e) {  
    e.preventDefault();
    $('.error').html('');
    var button_type = $(this).attr("data-address-type");
    var firstName = $('#address_first_name').val().trim();
    var lastName = $('#address_last_name').val().trim();
    var address1 = $('#address_address1').val().trim();
    var address2 = $('#address_address2').val().trim();
    var city = $('#address_city').val().trim();
    var country = $('#address_country').val().trim();
    var province = $('#address_province').val().trim();
    var zip = $('#address_zip').val().trim();
    var phone = $('#address_phone').val().trim();
    var isValid = true;

    if (firstName === '') {
        $('#err_address_first_name').html('First name is required');
        isValid = false;
    }

    if (lastName === '') {
        $('#err_address_last_name').html('Last name is required');
        isValid = false;
    }

    if (address1 === '') {
        $('#err_address_address1').html('Address 1 is required');
        isValid = false;
    }

    if (city === '') {
        $('#err_address_city').html('City is required');
        isValid = false;
    }

    if (country === '') {
        $('#err_address_country').html('Please select a country');
        isValid = false;
    }

    // if (province === '') {
    //     $('#err_address_province').html('Please select a province');
    //     isValid = false;
    // }

    if (zip === '') {
        $('#err_address_zip').html('Postal/Zip code is required');
        isValid = false;
    } else if (!/^\d{5}(-\d{4})?$/.test(zip)) {
        $('#err_address_zip').html('Invalid postal code format');
        isValid = false;
    }
 
    if (phone != '' && !/^\d{10}$/.test(phone)) {
        $('#err_address_phone').html('Phone number should be 10 digits');
        isValid = false;
    }
 
    if (isValid) {
      if (confirm("Are you sure you want to update address?")) { 
        let cart = getCartDetails();
  
        if(button_type != ""){
          cart[button_type]["first_name"] = firstName;
          cart[button_type]["last_name"] = lastName;
          cart[button_type]["address1"] = address1;
          if (address2 != ''){
            cart[button_type]["address2"] = address2;
          }
          cart[button_type]["city"] = city;
          if (country != ''){
            cart[button_type]["country"] = country;
          }
          cart[button_type]["province"] = province;
          cart[button_type]["zip"] = zip;
          if (phone != ''){
            cart[button_type]["phone"] = phone;
          }
          update_local_storage("OrderDetails", cart); 
          autoFatchOrderDetails();
          $('#AddressEditModal').hide();
          $('html').removeClass('js-drawer-open lock-scroll');
        }
      }
    }
}); 

$(document).on('click', '.close', function() {
  var close_id = $(this).attr("data-close-id");
  $('#'+close_id).hide();
  $('html').removeClass('js-drawer-open lock-scroll');
});

$(document).on('click', '#confirmSplit', function() {
  var splitItemIndex = $(this).attr("splitItemIndex");
  let qtyField = $('.input-box_' + splitItemIndex);
  let currentQty = parseInt(qtyField.val(), 10);
  let splitQty = parseInt($('#splitQtyInput').val(), 10);
  let max_qty_split = currentQty - 1;
  if(splitQty >= currentQty || splitQty <= 0) {
    alert("Invalid split quantity. You have only " + max_qty_split + " quantity split");
    return;
  }

  let remainingQty = currentQty - splitQty;
  qtyField.val(remainingQty);
  let cart = getCartDetails();

  let line_items = {};
  cart.line_items.forEach((prop) => {
    line_items[prop.id] = prop;
  });
  
  let originalItem = line_items[splitItemIndex];

  if(!originalItem) {
    alert("Error: Original item not found.");
    return;
  }

  originalItem.quantity = remainingQty;
  let splitButton = $('.split-button_' + splitItemIndex);
  if(remainingQty === 1 && splitButton.length) {
    splitButton.remove();
  }

  var tmp_item_id = Date.now();
  let newItem = {
    admin_graphql_api_id: originalItem.admin_graphql_api_id,
    attributed_staffs: originalItem.attributed_staffs,
    handle: originalItem.handle,
    sku: originalItem.sku,
    name: 'split_product',
    id: tmp_item_id,
    title: originalItem.title,
    product_id:originalItem.product_id,
    quantity: splitQty,
    price: originalItem.price,
    variant_id: originalItem.variant_id,
    images: originalItem.images,
    properties: []
  };

  cart.line_items.push(newItem);
  updateCartDetails(cart);
  $('#splitModal').hide();
  $('html').removeClass('js-drawer-open lock-scroll');
});

$(document).on('click', '.plus, .minus', function() {
  let productItem = $(this).closest('.product-item');
  let qtyField = productItem.find('.input-box');
  let currentQty = parseInt(qtyField.val(), 10);
  let itemId = productItem.data('item-id');
  let cart = getCartDetails();
  let item = cart.line_items.find(item => item.id === parseInt(itemId));
  if(!item) {
    alert("Error: Item not found in cart.");
    return;
  }
  if($(this).hasClass('plus')) {
    item.quantity += 1;
    qtyField.val(item.quantity);
  } else if($(this).hasClass('minus') && item.quantity > 1) {
    item.quantity -= 1;
    qtyField.val(item.quantity);
  }
  updateCartDetails(cart); 
});

$(document).on("click", ".pro_add_edit_logo", function(e) {
  e.preventDefault();
  $(".add_edit_order_logo_customization_div").html("");
  var button_type = $(this).attr("data-button-type");
  var product_handle = $(this).attr("data-product-handle");
  var current_item_id = $(this).attr("data-item-id");
  var customer_logos = $(this).attr("data-customer-logos");
  var course_code = $(this).attr("data-course-code");
  var productsUrl = "/products/" + product_handle + "?viewType=" + button_type;
  if (course_code != '' && customer_logos != ''){
    productsUrl += "&courseCode=" + course_code;
    productsUrl += "&customerLogos=" + customer_logos;
  }     
      
  $("#ajax_loader").show();
  $.ajax({
    url: productsUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML) {
      $("#ajax_loader").hide();
      if($(responseHTML).find('[id*="meta_logo_personalized"]').length) {
        var cart_product_single_form = `<form method="" id="cart_product_single_form" class="product-single__form">
              <input type="hidden" name="id" id="current_item_id" value="${current_item_id}">
              <input type="hidden" name="custom_form_id" id="custom_form_id" value="cart_product_single_form">
              <div id="edit_order_logo_customization"></div>
            </form>`;
        $("#add_edit_order_logo_customization_div__" + current_item_id).html(cart_product_single_form);
        var content = $(responseHTML).find('[id*="meta_logo_personalized"]').html();
        $("#edit_order_logo_customization").html(content);
        logoImageSvgLoad();
        logoInputSvgLoad();
        checkboxDropdownUpdate();
        pageOnLoadEvents();
        var addLogoMainHtml = `<div class="add-logo-main">
                                <button type="button" class="pro_add_edit_logo_save" data-button-type="SaveLogo" >Save Changes</button>
                              </div>`;
        $("#cart_variant_wrapper_custom_div").find(".variant-input-wrap-custom").append(addLogoMainHtml);
        var closeBtnHtml = `<div class="add-logo-main-icon"> 
                              <button type="button" class="pro_add_edit_logo_close" data-button-type="Close" >
                               <svg width="78" height="78" viewBox="0 0 78 78" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M43.5955 39L59.683 22.9125C60.275 22.2996 60.6026 21.4786 60.5952 20.6265C60.5878 19.7743 60.246 18.9592 59.6434 18.3566C59.0408 17.754 58.2257 17.4122 57.3736 17.4048C56.5214 17.3974 55.7005 17.725 55.0875 18.317L39 34.4045L22.9125 18.317C22.2996 17.725 21.4786 17.3974 20.6265 17.4048C19.7743 17.4122 18.9592 17.754 18.3566 18.3566C17.754 18.9592 17.4122 19.7743 17.4048 20.6265C17.3974 21.4786 17.725 22.2996 18.317 22.9125L34.4045 39L18.317 55.0875C17.725 55.7005 17.3974 56.5214 17.4048 57.3736C17.4122 58.2257 17.754 59.0408 18.3566 59.6434C18.9592 60.246 19.7743 60.5878 20.6265 60.5952C21.4786 60.6026 22.2996 60.275 22.9125 59.683L39 43.5955L55.0875 59.683C55.7005 60.275 56.5214 60.6026 57.3736 60.5952C58.2257 60.5878 59.0408 60.246 59.6434 59.6434C60.246 59.0408 60.5878 58.2257 60.5952 57.3736C60.6026 56.5214 60.275 55.7005 59.683 55.0875L43.5955 39Z"
                                        fill="black" />
                                </svg>
                              </button>
                            </div>`;
        $("#cart_variant_wrapper_custom_div").append(closeBtnHtml);
        logoLocationCheckUpdate(current_item_id);
        setTimeout(function() {
          editCustomizeLogoLocation();
        }, 1500);
        
        var element = $("#edit_order_logo_customization")[0]; // Get the DOM element
        if(element) {
          window.scrollTo({
            top: element.offsetTop,
            behavior: 'smooth'
          });
        }
      }
    },
    complete: function() {
      $("#ajax_loader").hide();
    },
  });
});

$(document).on("click", ".pro_add_edit_logo_close", function(e) {
  e.preventDefault();
  $(".add_edit_order_logo_customization_div").html("");
});

$(document).on("click", ".product-line-delete", function(e) {
  e.preventDefault();
  if (confirm("Are you sure you want to delete this item?")) { 
    var current_item_id = $(this).attr("data-item-id");
    let cart = getCartDetails();
    $.each(cart.line_items, function(index, item) { 
      if(!$.isEmptyObject(item)){
        if (item.id == current_item_id) {
          cart.line_items.splice(index, 1); 
        }
      } 
    });  
    updateCartDetails(cart);
    autoFatchOrderDetails();
  }
});

$(document).on("click", ".pro_add_edit_logo_save", function(e) {
  e.preventDefault();
  var count = 1;
  if ($(".checkbox-dropdown .checkbox:checked").length > 0) {
    $("#ajax_loader").show();
    svgToPngBase64($(".checkbox-dropdown .checkbox:checked").eq(0), count);
  } else {
    if (confirm("Are you sure you want to save this changes?")) { 
      var current_item_id = parseInt($("#current_item_id").val());  
      let cart = getCartDetails();
      cart.line_items.forEach((item, index) => {
        if (item.id === current_item_id) { 
          cart.line_items[index]['properties'] = []; 
        }
      });  
      updateCartDetails(cart);
      autoFatchOrderDetails();
    }
  }
});

function getCartDetails_order() {
  let cart = localStorage.getItem("OrderDetails");
  if (!cart || cart.length === 0) {
    console.log("Cart is empty");
    return null;
  }
  return cart;
}

$(document).on("click", "#save_cart", function(e) {
  e.preventDefault();
  var cartDetails = getCartDetails_order();
  if (confirm("Are you sure you want to create draft?")) { 
   if (cartDetails) {
      $("#ajax_loader").show();
      $.ajax({
        url: 'https://qetail.com/apps/get_order_details_bk/create_draft_order_Dreamgolf.php',
        type: 'POST',
        dataType: 'json',
        contentType: "application/json",
        data: cartDetails,
        success: function(res) {
          localStorage.removeItem("OrderDetails");
          $('.draft_order_response').text('Draft Order Created Successfully');
          setTimeout(function(){
            window.location.reload();
          },3000);
        },
        error: function(err) {
          console.error("Error Order Details get:", err);
        }
      });
    } else {
      console.error("Cart Details are empty!");
    }
  } else { 
    console.log("Create Draft Order canceled.");
  }
});

function validateName(name) {
    const namePattern = /^[A-Za-z\s-]+$/;
    return namePattern.test(name);
}

function validateEmail(email) {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
}

$(document).on("click", "#order_create", function(e) {
  e.preventDefault();
  var m_error_check = true;
  $(".m_error").html("");
  var approve_order_name = $("#approve_order_name").val();
  var approve_order_email_id = $("#approve_order_email_id").val();
  
  if(approve_order_name==""){
    m_error_check = false;
    $("#err_approve_order_name").text("Please Enter Name");
  }else if (!validateName(approve_order_name)) { 
     m_error_check = false;
    $("#err_approve_order_name").text("Please Enter valid Name");
  }

  if(approve_order_email_id==""){
     m_error_check = false;
    $("#err_approve_order_email_id").text("Please Enter Email ID");
  }else if (!validateEmail(approve_order_email_id)) {
     m_error_check = false;
    $("#err_approve_order_email_id").text("Please Enter valid Email ID");
  }

  if(m_error_check){
    let cart = getCartDetails();
    if (!$.isEmptyObject(cart.note_attributes)) {
      var approveNameExists = false;
      var approveEmailExists = false;
      cart.note_attributes.forEach(function(attribute) {
        if (attribute.name === "Approve Order Name") {
          approveNameExists = true;
          attribute.value = approve_order_name;
        }
        if (attribute.name === "Approve Order Email id") {
          approveEmailExists = true;
          attribute.value = approve_order_email_id;
        }
      });
      if (!approveNameExists) {
        cart.note_attributes.push({
          "name": "Approve Order Name",
          "value": approve_order_name
        });
      }
    
      if (!approveEmailExists) {
        cart.note_attributes.push({
          "name": "Approve Order Email id",
          "value": approve_order_email_id
        });
      }
      updateCartDetails(cart);
    }
    
    var cartDetails = getCartDetails_order(); 
    if (confirm("Are you sure you want to create Order?")) {
     if (cartDetails) {  // Check if cartDetails is valid
        $("#ajax_loader").show();
        $.ajax({
          url: 'https://qetail.com/apps/get_order_details_bk/createOrderDreamgolf.php',
          type: 'POST',
          dataType: 'json', 
          data: cartDetails,
          success: function(res) {
            localStorage.removeItem("OrderDetails"); 
            $('.draft_order_response').text('Order Created Successfully');
            setTimeout(function(){
              window.location.reload();
            },500);
          },
          error: function(err) {
            console.error("Error Order Details get:", err);
          }
        });
      } else {
        alert("Cart Details are empty!"); 
      }
    }
  }
  
});

function orderHtmlDisplay(orderData, fullOrderData) {
  let productHTML = '';
  if(fullOrderData.tags == 'Draft Order'){
    document.getElementById('product_order_create').innerHTML = '<button type="button" id="order_create_btn" class="save_cart approve_order_modal">Approve Order</button>';
  } 
  
  const keysToMove = ['8824556028158', '8824551899390', '8824549310718'];
  
  $.each(orderData, function(index, item) {
    var tmp_product_id = ((item.product_id != undefined  && item.product_id !="")?item.product_id.toString():'');
    var properties = cart_property_display(item.properties, item.handle, item, fullOrderData);
    if ($.inArray(tmp_product_id, keysToMove) == -1) {
      productHTML += `
                <div class="product-item-div" >
               <div class="product-item" data-item-id="${item.id}">
                <div class="product-details-main">
                  <div class="product-image">
                    <img src="${item.images.src}" alt="${item.title}" style="width: 100px;" />
                  </div>
                  <div class="product-info">
                    <div class="product-title"><a href="/products/${item.handle}?view_type=addOrder" >${item.title}</a></div>
                    <div class="product-properties">${properties}</div>`;
  
      productHTML += `
                  </div>
                </div>`;
  
      if(item.product_id == "8824556028158" || item.product_id == "8824551899390" || item.product_id == "8824549310718") {
        productHTML += `
                <div class="product-line-qty">
                  <div class="product-qty"> 
                    <input type="text" class="input-box" value="${item.quantity}" readonly/> 
                  </div> 
                </div>`;
      } else { 
        productHTML += `  
                  <div class="product-line-qty">
                    <div class="product-qty">
                      <button type="button" class="minus">-</button>
                        <input type="text" class="input-box input-box_${item.id}" value="${item.quantity}" readonly/>
                      <button type="button" class="plus">+</button>
                    </div>
                    ${item.quantity > 1 && item.properties.length > 0 ? `<div class="product-split"><button type="button" class="split-button split-button_${item.id}" splitItemIndex="${item.id}" >Split</button></div>` : ''}
                  </div>`;
      }
      productHTML += `
                <div class="product-line-price">
                  <span class="price">$${item.price}</span>
                </div>`; 
      
      if ($.inArray(tmp_product_id, keysToMove) == -1) {
        productHTML +=`<div class="product-line-delete" data-item-id="${item.id}" >
                        <span class="delete_line_item">
                          <?xml version="1.0"?>
                          <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 30 30" width="30px" height="30px">
                            <path d="M 14.984375 2.4863281 A 1.0001 1.0001 0 0 0 14 3.5 L 14 4 L 8.5 4 A 1.0001 1.0001 0 0 0 7.4863281 5 L 6 5 A 1.0001 1.0001 0 1 0 6 7 L 24 7 A 1.0001 1.0001 0 1 0 24 5 L 22.513672 5 A 1.0001 1.0001 0 0 0 21.5 4 L 16 4 L 16 3.5 A 1.0001 1.0001 0 0 0 14.984375 2.4863281 z M 6 9 L 7.7929688 24.234375 C 7.9109687 25.241375 8.7633438 26 9.7773438 26 L 20.222656 26 C 21.236656 26 22.088031 25.241375 22.207031 24.234375 L 24 9 L 6 9 z"/>
                          </svg>
                        </span>
                      </div>`;
      }
      productHTML +=`</div>
              <div id="add_edit_order_logo_customization_div__${item.id}" class="add_edit_order_logo_customization_div"></div>
              </div>`;
    }
  });

  $.each(orderData, function(index, item) {
    var tmp_product_id = ((item.product_id != undefined  && item.product_id !="")?item.product_id.toString():'');
    var properties = cart_property_display(item.properties, item.handle, item, fullOrderData);
    if(item.product_id == "8824556028158" || item.product_id == "8824551899390" || item.product_id == "8824549310718") {
      productHTML += `
                <div class="product-item-div" >
               <div class="product-item" data-item-id="${item.id}">
                <div class="product-details-main">
                  <div class="product-image">
                    <img src="${item.images.src}" alt="${item.title}" style="width: 100px;" />
                  </div>
                  <div class="product-info">
                    <div class="product-title"><a href="/products/${item.handle}?view_type=addOrder" >${item.title}</a></div>
                    <div class="product-properties">${properties}</div>`;
  
      productHTML += `
                  </div>
                </div>`;
  
      if(item.product_id == "8824556028158" || item.product_id == "8824551899390" || item.product_id == "8824549310718") {
        productHTML += `
                <div class="product-line-qty">
                  <div class="product-qty"> 
                    <input type="text" class="input-box" value="${item.quantity}" readonly/> 
                  </div> 
                </div>`;
      } else { 
        productHTML += `  
                  <div class="product-line-qty">
                    <div class="product-qty">
                      <button type="button" class="minus">-</button>
                        <input type="text" class="input-box input-box_${item.id}" value="${item.quantity}" readonly/>
                      <button type="button" class="plus">+</button>
                    </div>
                    ${item.quantity > 1 && item.properties.length > 0 ? `<div class="product-split"><button type="button" class="split-button split-button_${item.id}" splitItemIndex="${item.id}" >Split</button></div>` : ''}
                  </div>`;
      }
      productHTML += `
                <div class="product-line-price">
                  <span class="price">$${item.price}</span>
                </div>`; 
      
      if ($.inArray(tmp_product_id, keysToMove) == -1) {
        productHTML +=`<div class="product-line-delete" data-item-id="${item.id}" >
                        <span class="delete_line_item">
                          <?xml version="1.0"?>
                          <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 30 30" width="30px" height="30px">
                            <path d="M 14.984375 2.4863281 A 1.0001 1.0001 0 0 0 14 3.5 L 14 4 L 8.5 4 A 1.0001 1.0001 0 0 0 7.4863281 5 L 6 5 A 1.0001 1.0001 0 1 0 6 7 L 24 7 A 1.0001 1.0001 0 1 0 24 5 L 22.513672 5 A 1.0001 1.0001 0 0 0 21.5 4 L 16 4 L 16 3.5 A 1.0001 1.0001 0 0 0 14.984375 2.4863281 z M 6 9 L 7.7929688 24.234375 C 7.9109687 25.241375 8.7633438 26 9.7773438 26 L 20.222656 26 C 21.236656 26 22.088031 25.241375 22.207031 24.234375 L 24 9 L 6 9 z"/>
                          </svg>
                        </span>
                      </div>`;
      }
      productHTML +=`</div>
              <div id="add_edit_order_logo_customization_div__${item.id}" class="add_edit_order_logo_customization_div"></div>
              </div>`;
    }
  });

  var billingInfoHtml = shippingInfoHtml = "";

  if(fullOrderData.billing_address != ''){
    var billAdd = fullOrderData.billing_address;
    billingInfoHtml = `<h3>Billing address</h3>
                       ${fullOrderData.financial_status != undefined ? `<p><strong>Payment status:</strong> ${fullOrderData.financial_status}</p>` : ''}  
                        <p class="h5">${billAdd.first_name} ${billAdd.last_name}</p>
                        <p>
                          ${billAdd.address1} ${billAdd.address2 != null && billAdd.address2 != '' ? `${billAdd.address2}` : ''}<br>
                          ${billAdd.city}, ${billAdd.province}, ${billAdd.zip}, ${billAdd.country}<br>
                        </p>  
                        <button type="button" class="black_button edit_address_btn" data-button-type="billing_address" >Edit</button>
                        `; 
    $("#order_billing_info").html(billingInfoHtml);
  }

  if(fullOrderData.shipping_address != ''){
    var shipAdd = fullOrderData.shipping_address; 
    shippingInfoHtml = `<h3>Shipping address</h3>
                        ${fullOrderData.fulfillment_status != undefined ? `<p><strong>Fulfillment status:</strong> ${fullOrderData.fulfillment_status}</p>` : '<p><strong>Fulfillment status:</strong> Unfulfilled</p>'}  
                        <p class="h5">${shipAdd.first_name} ${shipAdd.last_name}</p>
                        <p>
                          ${shipAdd.address1} ${shipAdd.address2 != null && shipAdd.address2 != '' ? `${shipAdd.address2}` : ''}<br>
                          ${shipAdd.city}, ${shipAdd.province}, ${shipAdd.zip}, ${shipAdd.country}<br>
                        </p> 
                        <button type="button" class="black_button edit_address_btn" data-button-type="shipping_address" >Edit</button>
                        `;
     $("#order_shipping_info").html(shippingInfoHtml);
  }
  document.getElementById('order-products').innerHTML = productHTML;
  $('.order-products-main').removeClass('hide');
}

function cart_property_display(properties, handle, item, fullOrderData) {
  var customerMetafieldsData = fullOrderData['customer']['metafields'];
  var logos = '';
  var course_code = '';
  if(customerMetafieldsData != undefined){
    if(!$.isEmptyObject(customerMetafieldsData['logos']) && customerMetafieldsData['logos']['value'] != '') {
      tmpLogos = JSON.parse(customerMetafieldsData['logos']['value']);
      logos = tmpLogos.join('__');
    }

    if(!$.isEmptyObject(customerMetafieldsData['course_code']) && customerMetafieldsData['course_code']['value'] != '') {
      course_code = customerMetafieldsData['course_code']['value']; 
    }
  }

  var return_html = '';
  let property_size = properties.length;
  var isEditBtn = false;
  let accordionHTML = "";
  if(property_size > 0) {
    accordionHTML = '<div class="accordion-cart-main">';

    for(let accordionI = 1; accordionI <= 5; accordionI++) {
      let tmpdata = "Location " + accordionI;
      let formattedArray = properties;
      let productProperties = {};
      formattedArray.forEach((prop) => {
        productProperties[prop.name] = prop.value;
      });

      if(productProperties[tmpdata] !== undefined && productProperties[tmpdata] !== "") {
        isEditBtn = true;
        accordionHTML += `<div class="accordion-container">
                    <button type="button" class="accordion"> Location ${accordionI}
                        <span class="arrow">
                            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16">
                                <path d="m1.57 1.59 12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none"></path>
                            </svg>
                        </span>
                    </button>
                    <div class="panel" style="display: none;">
                        <div class="collapsible-content__inner rte">`;

        $.each(productProperties, function(key, value) {
          if(key.includes(accordionI)) {
            if(value !== "" && key.charAt(0) !== "_") {
              accordionHTML += `<div class="cart__item--properties">
                            <span>${key}:</span>`;
              if(value.includes(".svg") || value.includes(".png")) {
                accordionHTML += `<span class="logo-image" style="border: 1px solid; display: inline-block;">
                                <a href="${value}" target="_blank"><img src="${value}" width="40px" height="40px"> </a>
                            </span>`;
              } else if(value.includes("/uploads/")) {
                let fileName = value.split('/').pop();
                accordionHTML += fileName;
              } else {
                accordionHTML += value;
              }
              accordionHTML += `</div>`;
            }
          }
        });
        accordionHTML += `</div>
                    </div>
                </div>`;
      }
    }

    accordionHTML += '</div>';
  }

  if(item.product_id != "8824556028158" && item.product_id != "8824551899390" && item.product_id != "8824549310718") {
    if(isEditBtn) {
      accordionHTML += `<div class="pro_add_edit_logo_main">
                        <button type="button" class="pro_add_edit_logo" data-button-type="EditLogo" data-product-handle="${handle}" data-item-id="${item.id}" data-customer-logos="${logos}" data-course-code="${course_code}">
                          <span>
                            <svg fill="#000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  width="17px" height="17px" viewBox="0 0 494.936 494.936" xml:space="preserve">
                                <g fill="#fff">
                                    <path d="M389.844,182.85c-6.743,0-12.21,5.467-12.21,12.21v222.968c0,23.562-19.174,42.735-42.736,42.735H67.157
                                        c-23.562,0-42.736-19.174-42.736-42.735V150.285c0-23.562,19.174-42.735,42.736-42.735h267.741c6.743,0,12.21-5.467,12.21-12.21
                                        s-5.467-12.21-12.21-12.21H67.157C30.126,83.13,0,113.255,0,150.285v267.743c0,37.029,30.126,67.155,67.157,67.155h267.741
                                        c37.03,0,67.156-30.126,67.156-67.155V195.061C402.054,188.318,396.587,182.85,389.844,182.85z"/>
                                    <path d="M483.876,20.791c-14.72-14.72-38.669-14.714-53.377,0L221.352,229.944c-0.28,0.28-3.434,3.559-4.251,5.396l-28.963,65.069
                                        c-2.057,4.619-1.056,10.027,2.521,13.6c2.337,2.336,5.461,3.576,8.639,3.576c1.675,0,3.362-0.346,4.96-1.057l65.07-28.963
                                        c1.83-0.815,5.114-3.97,5.396-4.25L483.876,74.169c7.131-7.131,11.06-16.61,11.06-26.692
                                        C494.936,37.396,491.007,27.915,483.876,20.791z M466.61,56.897L257.457,266.05c-0.035,0.036-0.055,0.078-0.089,0.107
                                        l-33.989,15.131L238.51,247.3c0.03-0.036,0.071-0.055,0.107-0.09L447.765,38.058c5.038-5.039,13.819-5.033,18.846,0.005
                                        c2.518,2.51,3.905,5.855,3.905,9.414C470.516,51.036,469.127,54.38,466.61,56.897z"/>
                                </g>
                              </svg>
                          </span> Customize
                        </button>
                      </div>`;
    } else {
      if(customerMetafieldsData != undefined){
        accordionHTML += `<div class="add-logo-main"><button type="button" class="pro_add_edit_logo" data-button-type="AddLogo" data-product-handle="${handle}" data-item-id="${item.id}" data-customer-logos="${logos}" data-course-code="${customerMetafieldsData['course_code']['value']}" >Add Logo</button></div>`;
      }else{
        accordionHTML += `<div class="add-logo-main"><button type="button" class="pro_add_edit_logo" data-button-type="AddLogo" data-product-handle="${handle}" data-item-id="${item.id}" data-customer-logos="${logos}" data-course-code="" >Add Logo</button></div>`;  
      }
      }
  }
  return accordionHTML;
}

function autoFatchOrderDetails(isReset = false){
  var OrderDetails = get_local_storage('OrderDetails');
  if(OrderDetails != null) {
    var OrderDetailsData = JSON.parse(OrderDetails);
    $('#order-number').val(OrderDetailsData.name.replace('#', ''));
    if(isReset){
      localStorage.removeItem("OrderDetails");
    }
    setTimeout(function() {
      $('#fetch-order').click();
    }, 1000);
  }
}

function get_local_storage(id) {
  return localStorage.getItem(id);
}

function update_local_storage(id, data_value) {
  let ordersJSON = JSON.stringify(data_value);
  localStorage.setItem(id, ordersJSON);
}

function getCartDetails() { 
  let cart = localStorage.getItem("OrderDetails");
  return cart ? JSON.parse(cart) : [];
}

function updateCartDetails(cart) { 
  localStorage.setItem("OrderDetails", JSON.stringify(cart));
  setTimeout(function(){
    addUpdatePersonalizeProductOnLocalstorage();
  },500);
}

function propertiesSerializeForm(form) {
  let formDataVal = form.serializeArray();
  let formData = {};
  formDataVal.forEach((prop) => {
    formData[prop.name] = prop.value;
  }); 
  let properties = [];
  Object.entries(formData).forEach(([key, value]) => { 
    if ((key.startsWith('properties[') || key.startsWith('attributes[')) && value !== '') { 
      let cleanedKey = key.replace(/^properties\[|\]$/g, "").replace(/^attributes\[|\]$/g, "");
      properties.push({ name: cleanedKey, value: value });
    }
  });
  return properties;
}

function addUpdatePersonalizeProductOnLocalstorage() {
  const cart = getCartDetails();
  var logoLocationFirst = additionalLogoLocation = personalizaLogoLocation = 0;
  $.each(cart.line_items, function(index, item) {
    var quantity = parseInt(item.quantity);
    var formattedArray = item["properties"];
    let properties = {};
    formattedArray.forEach((prop) => {
      properties[prop.name] = prop.value;
    });
    if(item.product_id != "8824556028158" && item.product_id != "8824551899390" && item.product_id != "8824549310718" && !$.isEmptyObject(properties)) {
      let logoCount = 0;
      let personalizationCount = 0;

      for(const logoKey in properties) {
        var logoValue = properties[logoKey];
        if(logoKey.toLowerCase().startsWith("logo") && logoValue.trim() !== "") {
          logoCount++;
        }
        if(logoKey.toLowerCase().startsWith("_personalization") && logoKey.toLowerCase().includes("coordinates") && logoValue.trim() !== "") {
          personalizationCount++;
        }
      }

      if(logoCount > 0) {
        if(logoCount > 1) {
          logoLocationFirst = logoLocationFirst + (quantity * 1);
          var AddLogoCount = logoCount - 1;
          additionalLogoLocation = additionalLogoLocation + (quantity * AddLogoCount);
        } else {
          logoLocationFirst = logoLocationFirst + (quantity * 1);
        }
      }
      if(personalizationCount > 0) {
        personalizaLogoLocation = personalizaLogoLocation + (quantity * personalizationCount);
      }
    }
  });

  var logoLocationFirst12_5 = logoLocationFirst7_5 = logoLocationFirst2_5 = 0;
  if(logoLocationFirst == 1) {
    logoLocationFirst12_5 = logoLocationFirst;
  } else if(logoLocationFirst > 1 && logoLocationFirst < 72) {
    logoLocationFirst7_5 = logoLocationFirst;
  } else if(logoLocationFirst > 72) {
    logoLocationFirst2_5 = logoLocationFirst;
  }

  var response = {
    "46351645049086": {
      "id": 46351645049086,
      "quantity": logoLocationFirst12_5,
      "variant_id": 46351645049086,
      "title": "1st Logo Location",
      "name": "1st Logo Location",
      "price": 12.50,
      "product_id": 8824556028158,
      "handle": "embroidery",
      "sku": "EMB-1",
      "vendor": "Wholesale Jones",
      "images": {
        "src": "https://cdn.shopify.com/s/files/1/0733/4425/4206/files/Item-Personalization_18810383-86e1-4887-82e3-6466aa0755a9.jpg?v=1740983786"
      },
      "properties": [],
    },
    "46351645081854": {
      "id": 46351645081854,
      "quantity": logoLocationFirst7_5,
      "variant_id": 46351645081854,
      "title": "1st Logo Location",
      "name": "1st Logo Location",
      "price": 7.50,
      "product_id": 8824556028158,
      "handle": "embroidery",
      "sku": "EMB-2",
      "vendor": "Wholesale Jones",
      "images": {
        "src": "https://cdn.shopify.com/s/files/1/0733/4425/4206/files/Item-Personalization_18810383-86e1-4887-82e3-6466aa0755a9.jpg?v=1740983786"
      },
      "properties": [],
    },
    "46351645114622": {
      "id": 46351645114622,
      "quantity": logoLocationFirst2_5,
      "variant_id": 46351645114622,
      "title": "1st Logo Location",
      "name": "1st Logo Location",
      "price": 2.50,
      "product_id": 8824556028158,
      "handle": "embroidery",
      "sku": "EMB-3",
      "vendor": "Wholesale Jones",
      "images": {
        "src": "https://cdn.shopify.com/s/files/1/0733/4425/4206/files/Item-Personalization_18810383-86e1-4887-82e3-6466aa0755a9.jpg?v=1740983786"
      },
      "properties": [],
    },
    "46351627419902": {
      "id": 46351627419902,
      "quantity": additionalLogoLocation,
      "variant_id": 46351627419902,
      "title": "Additional Logo Locations",
      "name": "Additional Logo Locations",
      "price": 7.50,
      "product_id": 8824551899390,
      "handle": "adittional-logo-locations",
      "sku": "",
      "vendor": "Wholesale Jones",
      "images": {
        "src": "https://cdn.shopify.com/s/files/1/0733/4425/4206/files/Item-Personalization_18810383-86e1-4887-82e3-6466aa0755a9.jpg?v=1740983786"
      },
      "properties": [],
    },
    "46351615361278": {
      "id": 46351615361278,
      "quantity": personalizaLogoLocation,
      "variant_id": 46351615361278,
      "title": "Personalization",
      "name": "Personalization",
      "price": 12.50,
      "product_id": 8824549310718,
      "handle": "personalization",
      "sku": "",
      "vendor": "Wholesale Jones",
      "images": {
        "src": "https://cdn.shopify.com/s/files/1/0733/4425/4206/files/Item-Personalization_18810383-86e1-4887-82e3-6466aa0755a9.jpg?v=1740983786"
      },
      "properties": [],
    }
  };

  let updates = Object.keys(response).reduce((acc, key) => {
    let product = response[key];  
    let itemIndex = cart.line_items.findIndex(item => item.variant_id === product.id);
    let existingItem = cart.line_items.find(item => item.variant_id === product.id);

    if(existingItem) {
      if(product.quantity > 0) {
        cart.line_items[itemIndex].quantity = product.quantity;
      } else {
        cart.line_items.splice(itemIndex, 1);
      }
    } else if(product.quantity > 0) {
      cart.line_items.push(product);
    } 
    return acc;
  }, {});
  
  localStorage.setItem("OrderDetails", JSON.stringify(cart));
  autoFatchOrderDetails();
}

function logoLocationCheckUpdate(item_id) {
  const cart = getCartDetails();
  var logoLocationArr = [];
  $.each(cart.line_items, function(index, item) { 
    var formattedArray = item["properties"];
    let properties = {};
    formattedArray.forEach((prop) => {
      properties[prop.name] = prop.value;
    });
    if(item.id == item_id && !$.isEmptyObject(properties)) {
      
      for(const logoKey in properties) {
        var logoValue = properties[logoKey];
        if(logoKey.toLowerCase().startsWith("location") && logoKey.toLowerCase().includes("image") && logoValue.trim() !== "") {
          var locationKey = logoKey.replace(" Image","");            
          var locationValue = properties[locationKey].replace(" ","_");
          logoLocationArr.push(locationValue);
        } 
      } 
    }
  });

  if(!$.isEmptyObject(logoLocationArr)){ 
    $('.checkbox-dropdown .meta-variant-dropdown').each(function(index) {
      var is_checked = $(this).prop('checked');
      var thisval = $(this).attr("data-location");
      if ($.inArray(thisval, logoLocationArr) !== -1) {
        if(!is_checked){  
          $(this).trigger("click"); 
        } 
      } else if(is_checked){ 
        $(this).trigger("click");
      } 
    });
  }
}

function editCustomizeLogoLocation() {
  var current_item_id = $("#current_item_id").val();
  const cart = getCartDetails();
  var logoLocationArr = [];
  $.each(cart.line_items, function(index, item) { 
    var formattedArray = item["properties"];
    let properties = {};
    formattedArray.forEach((prop) => {
      properties[prop.name] = prop.value;
    });
    if(item.id == current_item_id && !$.isEmptyObject(properties)) {
      for(const logosKey in properties) {
        var logosValue = properties[logosKey];
         if(logosValue.trim() !== ""){
            if(!logosKey.toLowerCase().startsWith("_logo") && !logosKey.toLowerCase().includes("Code")) { 
              $('input[name="properties['+logosKey+']"]').val(logosValue);
            }
            $('input[name="editProductProperties['+logosKey+']"]').val(logosValue);
        }
      }
      for(const logoKey in properties) {
        var logoValue = properties[logoKey]; 
        if(logoKey.toLowerCase().startsWith("location") && logoKey.toLowerCase().includes("image") && logoValue.trim() !== "") { 
          var logoKeyNumber = logoKey.replace("Location","").replace(" Image","").replace(" ","").trim();
          var logoKeytmp = logoKey.replace("Location","Logo").replace(" Image","");           
          var logoHasKey = "_"+logoKeytmp.toLowerCase().replace(" ","")+"Code";
          var sLogoValue = properties[logoHasKey].split('.')[1];    
          var location_suffix_id = properties[logoKey.replace(" Image","")].replace(" ","_");
          var suffix_id = location_suffix_id + "_" + sLogoValue;
          var logoSection = $("#LogoSection-" + location_suffix_id + "-logos").find(".logo_inner_input_"+location_suffix_id+"_"+sLogoValue).find('input');
          logoSection.trigger('click'); logoSection.prop("checked", true); 
         
          var personalization_edit_font = properties["Personalization "+ logoKeyNumber + " Font"];            
          if(personalization_edit_font != undefined && personalization_edit_font != ""){
            $("#input_personalize_font_"+suffix_id).val(personalization_edit_font.toLowerCase().replace("font","")); 
          }
          var personalization_edit_font_size = properties["Personalization "+ logoKeyNumber + " Font Size"];  
          if(personalization_edit_font_size != undefined && personalization_edit_font_size != ""){
            $("#input_personalize_font_size_"+suffix_id).val(personalization_edit_font_size.replace("px","")); 
          }
 
          var personalization_edit_text = properties["Personalization "+ logoKeyNumber];            
          if(personalization_edit_text != undefined && personalization_edit_text != ""){  
            var personalization_edit_font_position = properties["_personalization"+ logoKeyNumber + "TextPosition"]; 
            
            personalization_edit_text_trigger(personalization_edit_text,location_suffix_id, suffix_id,personalization_edit_font_position);
          }

          $("#logo_customization_view_" + suffix_id).removeClass("logo-hidden");
          $(".logo_inner_input_" + suffix_id).addClass('hide');
          
          $(".logo-input-customization-" + location_suffix_id).each(function(index) {
            $(this).find(".logo-input").removeClass("active");
          });
          $("#logo_customization_view_" + suffix_id).find(".logo-input").addClass("active");

          
          thread_colors_trigger(location_suffix_id, suffix_id);   
        }    
      } 
      setTimeout(() => {
        for(const logosKey in properties) {
          var logosValue = properties[logosKey];
           if(logosValue.trim() !== ""){
            if(!logosKey.toLowerCase().startsWith("_logo") && !logosKey.toLowerCase().includes("Code")) { 
              $('input[name="properties['+logosKey+']"]').val(logosValue);
            } 
          }
        }
      }, 1500);
    }
  });
}

function personalization_edit_text_trigger(personalization_edit_text,location_suffix_id, suffix_id,personalization_edit_font_position) {
  setTimeout(() => {
    $("#input_personalize_text_"+suffix_id).val(personalization_edit_text);
    $("#input_personalize_text_" + suffix_id).trigger('keyup');
     
    if(personalization_edit_font_position != undefined && personalization_edit_font_position != ""){
      $("#input_personalize_font_position_"+suffix_id).val(personalization_edit_font_position);
    }
  }, 700);
}

function thread_colors_trigger(location_suffix_id, suffix_id) {
  setTimeout(() => {  
    var logo_edit_colors = $("#_logo_edit_" + location_suffix_id + "_thread_colors").val();
    if (logo_edit_colors != undefined && logo_edit_colors != "") {
      var colors_code = logo_edit_colors.split('_');
      $.each(colors_code, function (hindex, hex) {
        var color_hex_code_only = hex.replace("#", "");
        var layer_index = hindex + 1;
        if (color_hex_code_only != '') {
          var thread_colors_update_checked_hex = $(".thread_colors_" + suffix_id + "_layer_" + layer_index + "_" + color_hex_code_only).find("input"); 
          if (thread_colors_update_checked_hex.length > 0) {
            thread_colors_update_checked_hex.trigger('click');
          }
        }
      });
    }
  }, 2000);
}

let allInputElm = document.querySelectorAll(".swatch__button");
if(allInputElm.length > 0 && !document.body.classList.contains('template-product')){
  allInputElm.forEach((elm) => {
    elm.addEventListener("click",(event) => {
      let swatchId = event.target.closest(".swatch__button").getAttribute("data-index-id");
      if(swatchId){ 
        let imageElm = event.target.closest(".swatch__button").closest(".product__block__variants").closest(".product-grid-item").querySelector(".product-grid-item__content").querySelectorAll(".product__main-photos_custom");
        imageElm.forEach((imgel) => {
          let imgId = imgel.getAttribute("data-grid-image-target");
          // console.log(imgId);
          if(swatchId == imgId){  
            imgel.style.display = "block";
            imgel.style.left = "0px";
            imgel.style.opacity = '1';
          }else {
            imgel.style.display = "none";
          }
        });
      }
    })
  })
} 

// scroll of color swatch in collection page

document.addEventListener('DOMContentLoaded', function() {
  // Find all swatch containers
  const swatchGroups = document.querySelectorAll('.swatch-group');

  swatchGroups.forEach(group => {
    const swatchContainer = group.querySelector('.radio__inputs.radio__inputs--swatch');
    const prevButton = group.querySelector('.slider-button--prev');
    const nextButton = group.querySelector('.slider-button--next');

    if (swatchContainer && prevButton && nextButton) {
      // Calculate scroll step based on color box width
      const firstColorBox = swatchContainer.querySelector('.color_box');
      let scrollStep = 200; // Default fallback
      
      if (firstColorBox) {
        const style = window.getComputedStyle(firstColorBox);
        scrollStep = firstColorBox.offsetWidth + 
                     parseInt(style.marginRight) + 
                     parseInt(style.marginLeft);
      }

      // Button click handlers
      prevButton.addEventListener('click', () => {
        console.log("preee")
        swatchContainer.scrollBy({ left: -scrollStep, behavior: 'smooth' });
      });

      nextButton.addEventListener('click', () => {
          console.log("nextttt")
        swatchContainer.scrollBy({ left: scrollStep, behavior: 'smooth' });
      });

      // Update button states
      function updateButtonStates() {
        const { scrollLeft, scrollWidth, clientWidth } = swatchContainer;
        prevButton.disabled = scrollLeft <= 0;
        nextButton.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
      }

      // Initial check
      updateButtonStates();

      // Event listeners
      swatchContainer.addEventListener('scroll', updateButtonStates);
      window.addEventListener('resize', () => {
        clearTimeout(group.resizeTimer);
        group.resizeTimer = setTimeout(updateButtonStates, 250);
      });
    }
  });
});


const svgFonts = [
  {
    name: "AthleticFont",
    url: "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Athletic.ttf?v=1738045478"
  },
  {
    name: "BlockFont",
    url: "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Block.TTF?v=1738045807"
  },
  {
    name: "ScriptFont",
    url: "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Script.ttf?v=1738045807"
  },
  {
    name: "SerifFont",
    url: "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Serif.ttf?v=1738045806"
  },
  {
    name: "BrushFont",
    url: "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Brush_Script.ttf?v=1738144705"
  }
];


// custom-zoom Start
async function imageUrlToBase64(url) {
  const response = await fetch(url);
  const blob = await response.blob();
  return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
  });
}

async function fetchFontAsBase64(url) {
  const response = await fetch(url);
  const blob = await response.blob();
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      // Strip the beginning of the base64 string
      const base64 = reader.result.split(',')[1];
      resolve(base64);
    };
    reader.readAsDataURL(blob);
  });
}

function injectFontsIntoSVG(svgElement, fonts) {
  const style = document.createElementNS("http://www.w3.org/2000/svg", "style");
  let styleContent = "";

  fonts.forEach(font => {
    styleContent += `
      @font-face {
        font-family: '${font.name}';
        src: url(data:font/truetype;base64,${font.base64}) format('truetype');
      }
    `;
  });

  style.textContent = styleContent;
  svgElement.insertBefore(style, svgElement.firstChild);
}

async function svgToBase64(svgElement) {
  const svgClone = svgElement.cloneNode(true);

  // Handle embedded images
  const images = svgClone.querySelectorAll("image");
  for (const img of images) {
    const imageUrl = img.getAttribute("href") || img.getAttribute("xlink:href");
    if (imageUrl) {
      const base64Data = await imageUrlToBase64(imageUrl);
      img.setAttribute("href", base64Data);
    }
  }

  // Convert fonts to base64
  const fontPromises = svgFonts.map(async (font) => {
    const base64 = await fetchFontAsBase64(font.url);
    return { ...font, base64 };
  });

  const embeddedFonts = await Promise.all(fontPromises);
  injectFontsIntoSVG(svgClone, embeddedFonts);

  const serializer = new XMLSerializer();
  const svgString = serializer.serializeToString(svgClone);
  const base64String = window.btoa(unescape(encodeURIComponent(svgString)));
  return "data:image/svg+xml;base64," + base64String;
}

// async function svgToBase64(svgElement) {
//   let svgClone = svgElement.cloneNode(true);
//   let images = svgClone.querySelectorAll("image");
//   for (let img of images) {
//       let imageUrl = img.getAttribute("href") || img.getAttribute("xlink:href");
//       if (imageUrl) {
//           let base64Data = await imageUrlToBase64(imageUrl);
//           img.setAttribute("href", base64Data); // Update the <image> element with Base64
//       }
//   } 
//   let serializer = new XMLSerializer();
//   let svgString = serializer.serializeToString(svgClone);
   
//   let base64String = window.btoa(unescape(encodeURIComponent(svgString)));
//   return "data:image/svg+xml;base64," + base64String;
// }

$(document).on("click", ".fancybox-img", async function () {
  let image_element = $(this).parent(".product-image-wrapper").find("image-element");  
  let svgElement = image_element.find("svg")[0];

  if (svgElement) {
      if (image_element.find(".svg_to_base64_zoom").length === 0) {
          let base64SvgData = await svgToBase64(svgElement); 
          var containerWidth = parseInt(image_element.width());
          var containerHeight = parseInt(image_element.height()); 
          image_element.find("svg").addClass("hide-svg-image");
          let imgTag = `<div class="svg_to_base64_zoom tile" data-scale="2.4" data-image="${base64SvgData}" ></div>`;
          let newTile = $(imgTag);
          image_element.prepend(newTile); 
          newTile.append('<div class="photo"></div>');
          newTile.children(".photo").css({'background-image': 'url(' + base64SvgData + ')'});
      }else{
          image_element.find("svg").addClass("hide-svg-image");
          image_element.find(".tile").show();
      }
  }
});

$(document).on("change", "[name='properties[Logo]']", function() {
  if ($(".svg_to_base64_zoom").length > 0) {
    $(".svg_to_base64_zoom").each(function(index) {
        $(this).remove();
    });
  }
});

$(document).on("mouseover", ".tile", function () {
  $(this).children('.photo').css({
      'transform': 'scale(' + $(this).attr('data-scale') + ')'
  });
}).on("mouseout", ".tile", function () {
  $(this).children('.photo').css({
      'transform': 'scale(1)'
  });
  $(this).hide();
  $(this).parent("image-element").find("svg").removeClass("hide-svg-image");
}).on("mousemove", ".tile", function (e) {
  $(this).children('.photo').css({
      'transform-origin': ((e.pageX - $(this).offset().left) / $(this).width()) * 100 + '% ' +
          ((e.pageY - $(this).offset().top) / $(this).height()) * 100 + '%'
  });
});
// custom-zoom End